export const tr: { [key: string]: string } = {
  subscribe_with_click: 'Tek tıkla abone ol',
  subscribe: 'Tek tıkla abone ol',
  minimum_number_characters: 'en az 2 karakter',
  request_details: 'Talep detayları',
  form_title: 'Kısa süre içinde sizinle iletişime geçeceğiz',
  form_required: '* ile işaretlenen alanlar zorunludur',
  form_name_placeholder: 'Ad',
  form_email_placeholder: 'E-posta',
  form_phone_placeholder: 'Telefon numarası',
  form_company_placeholder: 'Şirket',
  form_submit: 'Gönder',
  form_1: 'Kişisel verilerin işlenmesine şu belgeye göre onay veriyorum:',
  form_2: 'Gizlilik Politikası',
  validation_privacy_policy: 'Lütfen Gizlilik Politikasını kabul edin',
  validation_phone: 'Telefon numarası geçerli değil',
  validation_email: 'Geçersiz e-posta formatı',
  validation_required: 'Zorunlu alanlar doldurulmadı',
  submit_error: 'Form kaydedilirken bir hata oluştu',
  footer_1: 'Ortaklarımız:',
  footer_2: 'Yöntemler',
  footer_3: 'Ürünler',
  footer_4: 'İletişim:',
  footer_5: 'Künye',
  footer_6: 'Gizlilik Politikası',
  footer_7: 'Pazar Araştırması',
  about_us_1: '4Service Kurumsal Sosyal Sorumluluk',
  about_us_2:
    'Ekibimizin her bir üyesinin kalbinden ve ruhundan. Çalışanlarımızın her birinde iyilik kıvılcımını canlı tutmak ve etrafımızdaki dünyayı biraz daha iyi hale getirmek için elimizden geleni yapıyoruz',
  about_us_3: '4Service Kurumsal Sosyal Sorumluluk',
  about_us_4:
    'Ekibimizin her bir üyesinin kalbinden ve ruhundan. Çalışanlarımızın her birinde iyilik kıvılcımını canlı tutmak ve etrafımızdaki dünyayı biraz daha iyi hale getirmek için elimizden geleni yapıyoruz',
  about_us_5: 'Service Mania iş oyunu',
  about_us_6: 'Çocuklar ve öğrenciler için sosyal erişim girişimlerimiz',
  about_us_7: 'Hayırseverlik / Gönüllülük',
  about_us_8:
    'Yetimhaneler, yaşlı bakım evleri ve Ukrayna ordusu için gönüllülük. Faaliyetlerimizin en dokunaklı kısmı',
  about_us_9: 'Hayvan refahı',
  about_us_10:
    'Herkes evcil hayvanıyla ofisimize gelebilir. Barınaklara destek oluyor, mama için bağış topluyor ve bazen de sahipsiz hayvanlara yuva bulmaya çalışıyoruz',
  about_us_11: '4Service Group',
  about_us_12:
    'Müşteri deneyimini yöneten uluslararası bir araştırma şirketidir.',
  about_us_13:
    'Müşteri odaklı şirketlerin satışlarını artırmak ve işlerini geliştirmek için karmaşık projeler hayata geçiriyoruz.',
  about_us_14:
    'Merkezi Viyana, Avusturya’da bulunan uluslararası bir araştırma holdingidir. Şirket, müşterilerinin ve iş dünyasıyla etkileşimde bulunan, hizmetlerini kullanan ve ürünlerini tüketen insanların yaşam kalitesini artırmak amacıyla 2001 yılında kurulmuştur. Sonuçta, müşteri hizmetlerini ve yüksek kaliteyi temsil eden bir şirket için “Forservice” adının seçilmesi boşuna değildir.',
  about_us_15:
    'Bu, 4Service’in Ukrayna’nın Kyiv kentinde gizli müşteri hizmetlerinin lider sağlayıcısı olarak tarihinin başlangıcı oldu. Şirket, müşteri deneyiminin tüm zincirini analiz etmeye ve iyileştirmeye yönelik bütüncül yaklaşımla 52 ülkede başarılı bir araştırma şirketi olarak faaliyetlerini sürdürmektedir',
  about_us_16: 'hizmet adına doğdu',
  about_us_17: 'Ukrayna dışındaki ilk ofis',
  about_us_18: 'merkez ofisin Viyana’ya taşınması',
  about_us_19: 'elit MSPA üyesi, Avrupa’da İlk 10 ajans',
  about_us_20: '9 ülkede ofislerin kurulması',
  about_us_21: 'ilk dijital projeler, Voicer',
  about_us_22: 'DesignThinkers Academy ortakları',
  about_us_23: 'ilk küresel CX projeleri',
  about_us_24: 'Misyon',
  about_us_25:
    'Misyonumuz, dünya genelinde müşteri hizmetlerini iyileştirmektir! İlham kaynağımız, birlikte çalıştığımız insanlarda ve şirketlerde gördüğümüz niteliksel değişimlerdir.',
  about_us_26: '20+ yıllık Müşteri Deneyimi',
  about_us_27: '95 ülke',
  about_us_28:
    'Dünyanın dört bir yanından en iyi sektör deneyimlerini topluyor ve paylaşıyoruz',
  about_us_29: 'Viyana’daki merkez ofis',
  about_us_30:
    'ülke. Dünyanın dört bir yanından en iyi sektör deneyimlerini topluyor ve paylaşıyoruz',
  about_us_31: 'hizmet kalitesi derecelendirmeleri',
  about_us_32: 'Avrupa’nın ilk 10 CX ajansı arasındayız',
  about_us_33: 'Avusturya’da temsilcilikler / merkez ofis',
  about_us_34: 'aktif projeler',
  about_us_35: 'Gelecekteki iş yeriniz',
  about_us_36: 'Ofislerimiz',
  about_us_37:
    '4Service ™ çalışanları için konforlu bir çalışma alanı yaratmak için çaba gösterir. Çalışanlarımız, her bir çalışanın konforu ve verimliliğine göre ofiste, uzaktan veya hibrit şekilde çalışır. Dinlenme alanları, ücretsiz psikolojik destek ve sıcak bir ortam sunarız. İnsan ve evcil hayvan dostuyuz.',
  about_us_38: 'Işık saçan bir ekip',
  about_us_39:
    'Çok uluslu ekibimiz, müşterilerimizden gelen geri bildirimleri dinlemeye, birlikte gelişmeye ve büyümeye kararlıdır. Müşterilerimizin bizimle olan müşteri yolculuğu haritası, yeni ürünler piyasaya sürmek veya finansal hedeflere ulaşmak kadar işimiz için önemlidir. Faaliyetlerimiz, çevremizdeki topluluklar üzerinde olumlu bir etki yaratmayı ve müşterilerimiz için yenilikçi ve insan odaklı çözümler sunmayı amaçlar.',
  about_us_40: 'Tümü',
  about_us_41: 'Yönetim',
  about_us_42: 'Küresel Ekip',
  about_us_43: 'Ürün sahipleri',
  about_us_44: 'İş ortaklarımız',
  about_us_45:
    'Müşteri odaklı şirketlerin satışlarını artırmak ve işlerini geliştirmek için karmaşık projeler hayata geçiriyoruz',
  about_us_46:
    '25 ülkede temsil edilen ve yaratıcı, disiplinlerarası ekipleri ve toplulukları eğitmek, geliştirmek ve kolaylaştırmak suretiyle olumlu değişimi teşvik eden, önde gelen “tasarım odaklı” Profesyonel Eğitim Enstitülerinden biridir. Design Thinking, yenilikçi fikirler geliştirmenizi ve karmaşık sorunlara değişim ve çözümler sunmanızı sağlar.',
  about_us_47:
    'Misyonları, ekipler ve bireyler için ilham alınacak ve zorlanacak alan ve zamanı sağlamak, “yaparak öğrenme”yi teşvik etmek, yaratıcı problem çözme yeteneklerini güçlendirmek ve kuruluşların cesur inovasyonu başlatmak için gerekli ortamı ve zihniyeti oluşturmalarına yardımcı olmaktır.',
  about_us_48:
    'Gizli Müşteri araştırması sektöründe faaliyet gösteren şirketler için temsili bir Ticaret Birliğidir. Dernek, Amerika, Avrupa/Afrika ve Asya/Pasifik’te bulunan bölümleriyle dünya genelinde bölgesel bazda faaliyet göstermektedir. Üye şirketler, Gizli Müşteri sektörünü ortak çaba ve eylemlerle güçlendirmek amacıyla tek bir yapı altında birleşir.',
  about_us_49:
    'kâr amacı gütmeyen bir üyelik kuruluşudur. Üyeler, veri analitiği, araştırma ve içgörülerin toplumları, kuruluşları ve herkesin yaşamını iyileştirmeye yardımcı olma potansiyeline inanan bir topluluk oluşturur.',
  about_us_50:
    'ESOMAR’ın merkezi Hollanda’nın Amsterdam şehrindedir. ESOMAR, 1947’den bu yana üyeleri aracılığıyla 130’dan fazla ülkede faaliyet göstermektedir.',
  about_us_51:
    '(UCCA), çağrı merkezi ve müşteri hizmetleri alanında gelişim ve etkileşimi amaçlayan, özel uzmanlar ve şirketlerden oluşan profesyonel bir topluluktur. UCCA’nın felsefesi, modern teknolojiler ve yüksek standartlara dayalı olarak çağrı merkezi sektörünün kültürünü yükseltmektir.',
  about_us_52: 'Ukrayna Çağrı Merkezi Derneği 2010 yılında kurulmuştur',
  about_us_53:
    'eğitim alanındaki en iyi dünya deneyimlerini inceleyerek bunları Ukrayna pazarına uyarlayıp kullanmayı amaçlar. Bu nedenle DTEK Akademisi, INSEAD, IE Business School ve Stanford University gibi önde gelen uluslararası işletme okullarıyla iş birliği yapmaktadır.',
  about_us_54:
    'DTEK Akademisi, D.Client School, ID School ve Executive Education programları kapsamında müşteri odaklı ve yenilikçi bir kültürün geliştirilmesine odaklanmaktadır: Energy of Innovation, Power of Communications, DX School dijital programı, Effective Leader: Pre-MBA, Change Energy.',
  about_us_55: 'Sergey Pashkovsky',
  about_us_56: 'Viktoria Skorbota',
  about_us_57: 'Artem Fomin',
  about_us_58: 'Max Papka',
  about_us_59: 'Uluslararası Satış Müdürü',
  bht_1: 'Marka Sağlığı',
  bht_2: 'Takip',
  bht_3: 'Markalar inanılmaz derecede güçlüdür',
  bht_4: 'Markanızın genel olarak ne kadar iyi performans gösterdiğini öğrenin',
  bht_5: 'Hakkında',
  bht_6: 'Marka Sağlığı Takibi nedir?',
  bht_7:
    'Bu, belirli bir düzenlilikle (iki haftada bir, her ay vb.) yürütülen ve',
  bht_8:
    'bilinirlik, talep, imaj, tüketici özellikleri, marka sağlığı gibi göstergelere dayanarak markanın pazardaki durumuna ilişkin bilgi elde etmeyi amaçlayan bir pazar araştırması türüdür.',
  bht_9: 'Markayı en sık satın alanlar',
  bht_10: 'Sadık',
  bht_11: 'Markayı 3 ay içinde satın alanlar',
  bht_12: 'Düzenli / sürekli müşteriler',
  bht_13: 'Markayı 6 ay içinde satın alanlar',
  bht_14: 'Kısa vadeli müşteriler',
  bht_15: 'Markayı bir yıl içinde satın alanlar',
  bht_16: 'Uzun vadeli müşteriler',
  bht_17: 'Markanın farkında olan ancak hiç kullanmamış/satın almamış olanlar',
  bht_18: 'Farkında ama müşteri değil',
  bht_19: 'Farkında olmayan: markayı hiç duymamış olanlar',
  bht_20: 'Farkında değil',
  bht_21: 'Marka alıcı profili',
  bht_22:
    'Uzun vadede marka oluşturmak için yapılan çabaların tutarlılığının değerlendirilmesi',
  bht_23: 'Müşterilerin marka hakkındaki bilgi düzeyinin ölçülmesi',
  bht_24: 'Reklam ve bilgilendirme kampanyalarının etkinliğinin gösterilmesi',
  bht_25:
    'Yoğun reklam dönemlerinin rakiplerin satış/pazarlama faaliyetleri üzerindeki etkisinin belirlenmesi',
  bht_26:
    'Sürekli piyasa değişimlerinin yaşandığı dönemlerde işletme sahibine sürekli kontrol sağlanması',
  bht_27: 'BHT ile hangi görevler çözülebilir:',
  bht_28: 'Araştırma talep et',
  bht_29: 'Çözülecek görev',
  bht_30: 'Örneğin,',
  bht_31:
    'bir şirketin pazar payı ölçümü sırasında çeyrek başına yalnızca bir BHT oturumuna ihtiyacı varsa, reklamlardan kaynaklanan müşteri marka bilgisini ölçerken anketler daha sık yapılmalıdır.',
  bht_32: 'CATI',
  bht_33: 'Yüz yüze',
  bht_53: 'Görüşmeler',
  bht_34: 'СAWI',
  bht_35: 'Çözülecek görev',
  bht_36: 'Bilgi toplayarak',
  bht_37:
    'çeşitli yöntemler aracılığıyla marka takibi, genellikle hedef kitleye ve onlara ulaşmanın zorluk derecesine bağlı olarak üç aşamaya ayrılır:',
  bht_38:
    'Veri toplamak için hem geleneksel hem de çağdaş yöntemleri kullanıyoruz:',
  bht_39:
    'İki modelle çalışıyoruz: ilki basit bir gösterge setine sahiptir, ikincisi ise gıda ve hizmet sektörleri gibi daha karmaşık endüstrileri hedefler. Daha karmaşık model, 10’a kadar tahmini endeks içeren derinlemesine bir çalışmayı kapsar.',
  bht_40: 'Sunuyoruz',
  bht_41: 'başlangıç verilerinin kontrolünü',
  bht_42: 'Kapsıyoruz',
  bht_43: 'ülkenin tamamını',
  bht_44: 'Bir çözüm sunuyoruz',
  bht_45:
    'dinamik olmayan pazarlar / sınırlı sayıda oyuncuya sahip pazarlar için (Brand Point Analyze)',
  bht_46: 'Neden biz?',
  bht_47: 'Neden bizi seçmelisiniz?',
  bht_50: 'Zayıf sonuç',
  bht_51: 'İyi sonuç',
  bht_52: 'Ortalama sonuç',
  cases_1:
    'Zorluk: Hyundai showroomlarında elektrikli araç satın alma müşteri deneyimi nasıl iyileştirilebilir?',
  cases_2: 'Müşteri Yolculuğu haritalama',
  cases_3: 'Fikir geliştirme',
  cases_4: 'Nitel araştırma',
  cases_5:
    'Zorluk: Oppo markasına müşteri ilgisi çekmek için mağazalarda (hem hizmet sürecinde, hem iç mekânda, hem de marka algısında) nelerin değiştirilmesi gerekir?',
  cases_6: 'Çevrim içi CJM',
  cases_7: 'UI testleri',
  cases_8: 'Görüşmeler',
  cases_9:
    'Zorluk: Oppo markasına müşteri ilgisi çekmek için mağazalarda nelerin değiştirilmesi gerekir?',
  cases_10: 'Nitel bölüm',
  cases_11: 'Fikir geliştirme',
  cases_12: 'Nicel bölüm',
  cases_13: 'Müşteri Yolculuğu Haritası',
  cases_14: 'Vaka çalışmaları',
  cases_15: 'Tümü',
  cases_16: 'Harika vakanızı birlikte oluşturalım',
  csi_1: 'Müşteri',
  csi_2: 'memnuniyet endeksi',
  csi_3: 'Tüketicilerin',
  csi_4: 'memnuniyet ve memnuniyetsizlik nedenlerini belirlemek',
  csi_5: 'Müşteri memnuniyeti araştırması',
  csi_6:
    'müşterinin satın alma kararını ve hedef kitlenin davranışlarını etkileyen faktörlerin, nedenlerin ve motivasyonların belirlenmesidir.',
  csi_7: 'Bir müşteri memnuniyeti anketi',
  csi_8:
    'müşterinin belirli bir hizmet yönünden veya genel olarak ürünle ne kadar memnun ya da memnuniyetsiz olduğunu gösterir.',
  csi_9: 'Memnuniyet anketi',
  csi_10:
    'şirketin mevcut müşterileri ve belirli ürün/hizmet kullanıcıları arasında gerçekleştirilir.',
  csi_11: 'CSI nedir?',
  csi_12:
    'Müşteri memnuniyeti, şirketiniz tarafından sunulan bir ürün veya hizmetin satın alınmasına ilişkin müşteri beklentilerinin ne ölçüde karşılandığını ölçer.',
  csi_13: 'Mutlu adam',
  csi_14: 'Hakkında',
  csi_15: 'Gizli faktörleri belirlemek',
  csi_16: 'müşteri memnuniyetini etkileyebilecek',
  csi_17: 'Nedenleri belirlemek',
  csi_18: 'ürün ve hizmetlere olan talepteki artış/azalışın arkasındaki',
  csi_19: 'Şirketin',
  csi_20: 'iş süreçlerini optimize etmek',
  csi_21: 'Bunları uyarlamak',
  csi_22: 'modern tüketicinin ihtiyaçlarına göre',
  csi_23: 'Etkili bir reklam mesajı oluşturmak',
  csi_24: 've ürünü müşterinin talebine göre konumlandırmak',
  csi_25: 'Çözülecek görevler',
  csi_26: 'Müşteri memnuniyeti anketlerinin çözebileceği görevler',
  csi_27: 'Telefonlu adam',
  csi_28: 'Matematiksel bir model oluşturuyoruz',
  csi_29:
    'müşteri memnuniyetini/müşteri sadakatini etkileyebilecek faktörlere ilişkin (regresyon analizi)',
  csi_30: 'Optimize etmek',
  csi_31: 'şirketin iş süreçlerini',
  csi_32: 'Hesaplanmış bir müşteri memnuniyeti endeksi oluşturuyoruz',
  csi_33: '(CSI) ve bunu beyan edilen değerle karşılaştırıyoruz',
  csi_34: 'Bir araştırma yürütüyoruz',
  csi_35: 'hem B2B hem de B2C segmentleri için.',
  csi_36: 'Anketlerimiz bir analist ekibi tarafından geliştirilir',
  csi_37: 'müşterilerimizin bireysel projelerine özel olarak',
  csi_38: 'Neden biz',
  csi_39: 'Neden bizi seçmelisiniz?',
  csi_40: 'Bilgi toplama yöntemleri:',
  main_1:
    'müşterilerimizin %’si, müşterilerinin deneyimlerinden öğrenerek finansal performanslarını artırıyor',
  main_2: 'CX araştırma ve danışmanlık hizmetleri: işinize 360° bakış',
  main_3: 'İşinizi desteklemek için çözüm ve araç yelpazemizi keşfedin',
  main_4: 'Ürünler',
  main_5:
    'Nitel araştırma, kavramları, görüşleri veya deneyimleri anlamak için sayısal olmayan verilerin toplanması ve analiz edilmesidir',
  main_6:
    'Nicel araştırma yöntemleri, anketler ve soru formları yoluyla toplanan verilerin nesnel ölçümü ve sayısal analizidir',
  main_7:
    'Gizli müşteri araştırması, önceden tanımlanmış bir senaryo kapsamında müşteri ile bir şirket veya kuruluş arasındaki etkileşimleri ölçmek ve izlemek için kullanılan bir pazar araştırması tekniğidir',
  main_8:
    'Geri Bildirim Yönetim Sistemi. Müşterinizin sesi tek bir sistemde — Müşteri Geri Bildirim Yönetim Sistemi',
  main_9:
    'Hedef kitleden içgörüler sunan yapay zekâ destekli bir içerik zekâsı platformu',
  main_10:
    'Performans Yönetim Yazılımı. Satışları artırmaya yönelik oyunlaştırılmış bir uygulama',
  main_11:
    'Fiyat izleme, rakiplerin fiyatlarının toplanması, işlenmesi ve analiz edilmesi sürecidir',
  main_12:
    'müşteri odaklı hizmet ve ürünlerin tasarlanmasıdır. Süreç, müşterilerin ihtiyaç ve beklentilerinden işleyiş biçimlerine doğru dengeli bir ilerlemeyi içerir',
  main_13:
    'Analitik ekibimiz, birçok müşteriyle başarılı olduğu kanıtlanmış en güncel ve temel yaklaşımları uygular',
  main_14: 'Metodolojiler',
  main_15: 'Müşteri yolculuğu haritası',
  main_16:
    'Müşteri Yolculuğu Haritalama (CJM), hedef kitleyi tanımlamak, onların ihtiyaçlarını ve ortamlarını anlamak ve ardından etkileyici bir deneyim sunmak için bir plan oluşturmaktır',
  main_17: 'CJM',
  main_18: 'Net Tavsiye Skoru',
  main_19:
    'Net Tavsiye Skoru (NPS), tek bir soruya dayanan müşteri deneyimi metriklerinin altın standardıdır: Kuruluşu/Ürünü/Hizmeti tavsiye etme olasılığınız nedir?',
  main_20: 'NPS',
  main_21: 'Marka Sağlığı Takibi',
  main_22:
    'Marka Sağlığı Takibi (BHT) araştırması, markanızın bilinirlik ve kullanım, marka konumlandırması ve marka performansı açısından nasıl bir performans gösterdiğini ölçebilir',
  main_23: 'BHT',
  main_24: 'İnsan Kaynakları Araştırması',
  main_25:
    'İnsan Kaynakları Araştırması, İK uygulamalarını ve performansını değerlendirmek için kullanılır ve mevcut gelişim ile yönetime dair ayrıntılı analiz sunar',
  main_26: 'İK araştırması',
  main_27: 'Müşteri memnuniyeti endeksi',
  main_28:
    'Müşteri Memnuniyeti Endeksi (CSI), müşterilerinizin şirketin ürünleri / hizmetlerinden ne kadar memnun olduğunu gösteren bir puandır.',
  main_29: 'CSI',
  main_30: 'UX testleri',
  main_31:
    'Kullanılabilirlik (UX) testleri, gerçek insanların bir web sitesi, uygulama veya başka bir ürünle nasıl etkileşime girdiğini ve buna verdikleri davranışsal ve duygusal tepkilerin gözlemlenmesini ifade eder',
  main_32: 'Neden biz',
  main_33:
    'Misyonumuz, işletmelerin son derece etkili bir müşteri deneyimi sunmasına yardımcı olmaktır',
  main_34: 'Kaliteye odaklanma',
  main_35: 'Kalite kontrolünden geçiyoruz',
  main_36:
    'araştırma verileri söz konusu olduğunda. Tüm veri setlerini müşterilerimizin erişimine açıyoruz',
  main_37: 'Maliyet etkin',
  main_38: 'Deneyimimiz, kaynaklarımız ve sadeleştirilmiş',
  main_39: 'iş süreçlerimiz, size zaman ve para tasarrufu sağlar',
  main_40: 'Akıllı çözümler',
  main_41: 'Çeşitli teknikler kullanıyoruz',
  main_42: 've özel sorunlarınızı çözmek için araç setleri',
  main_43: 'Kaliteye odaklanma',
  main_44: 'Kalite kontrolü sağlıyoruz',
  main_45:
    'araştırma verileri söz konusu olduğunda. Tüm veri setlerini müşterilerimizin erişimine açıyoruz',
  main_46: 'Maliyet etkin',
  main_47: 'Deneyimimiz, kaynaklarımız ve sadeleştirilmiş',
  main_48: 'iş süreçlerimiz, size zaman ve para tasarrufu sağlar',
  main_49: 'Akıllı çözümler',
  main_50: 'Çeşitli teknikler kullanıyoruz',
  main_51: 've özel sorunlarınızı çözmek için araç setleri',
  main_52: 'Cash & Carry',
  main_53: 'Elektronik',
  main_54: 'Lüks / Premium',
  main_55: 'Yeme-İçme ve Konaklama',
  main_56: 'Perakende',
  main_57: 'Otomotiv',
  main_58: 'Moda',
  main_59: 'Bankalar',
  main_60: 'Seyahat ve Eğlence',
  main_61: 'Saatler ve Mücevher',
  main_62: 'Ev ve Beyaz Eşya',
  main_63: 'Blog',
  main_64: 'Daha ilginç yazılar okumak için bloga gidin',
  main_65: 'Perakende denetimi',
  main_66:
    'Mağazanız veya markanız hakkında ayrıntılı veriler toplayın, büyüme engellerini analiz edin ve bunları aşmak için etkili stratejiler oluşturun',
  main_73: 'Günlük Çalışması',
  main_74:
    'Günlük çalışmaları, uzun vadeli deneyimleri ve tekrarlayan faaliyetleri keşfetmek için faydalıdır. Kullanıcı deneyimlerinin ve yaşam tarzlarının zaman içindeki gelişimini günlük ortamlarında takip edin ve içgörüler elde edin.',
  main_75: 'Çalışan Deneyimi (EX)',
  main_76:
    'Çalışan Deneyimi (EX) metodolojisi, kuruluşların çalışan beklentileri ve iş hedefleriyle uyumlu daha iyi süreçler, kültürler ve ortamlar tasarlamasına yardımcı olan stratejik bir yaklaşımdır ve nihayetinde hem çalışan refahını hem de şirket performansını artırır',
  main_77: 'CATI',
  main_78: 'Bilgisayar Destekli Telefon Görüşmeleri (CATI)',
  main_79:
    'CATI, müşteri memnuniyeti ve çalışan bağlılığından pazar ve sosyal araştırmalara kadar çeşitli iş ihtiyaçlarına uygun, yüksek kaliteli verilerin toplanmasını sağlayan esnek ve verimli bir araştırma metodolojisidir; doğru, zamanında ve eyleme dönüştürülebilir içgörüler sunar',
  cjm_1: 'Müşteri',
  cjm_2: 'Yolculuk haritası',
  cjm_3: 'Müşterilerin dünyasına girin ve onların deneyimini paylaşın',
  cjm_4: 'Müşteri Yolculuğu Haritası nedir?',
  cjm_5:
    'CJM, tüketicinin bir ürün, hizmet, şirket veya marka ile çeşitli kanallar üzerinden ve belirli bir zaman dilimi boyunca olan etkileşiminin görselleştirilmiş geçmişini sunar.',
  cjm_6:
    'Bu, şirketlerin müşteri etkileşim deneyimini nesnel olarak analiz etmelerine, ortaya çıkan engelleri tespit edip ortadan kaldırmalarına ve ürünü iyileştirmek için öneriler sunmalarına olanak tanır.',
  cjm_7: 'Hedef kitlenin belirlenmesi, segmentasyon',
  cjm_8: 'Müşteri etkileşimi aşamalarının belirlenmesi',
  cjm_9: 'Birincil müşteri etkileşim kanallarının belirlenmesi',
  cjm_10: 'Müşteri deneyiminin araştırılması',
  cjm_11: 'Engellerin analizi ve optimizasyona yönelik hipotezler',
  cjm_12: 'Hipotezlerin uygulanması ve test edilmesi',
  cjm_13:
    'Bir Müşteri Yolculuğu Haritasının tasarlanması aşağıdaki adımlardan oluşur:',
  cjm_14: 'Müşteri Yolculuğu Haritası şunları gösterecektir:',
  cjm_15:
    'CJM, tüketicinin bir ürün, hizmet, şirket veya marka ile çeşitli kanallar üzerinden ve belirli bir zaman dilimi boyunca olan etkileşiminin görselleştirilmiş geçmişini sunar.',
  cjm_16: 'Ekip çalışmasını sağlıyoruz',
  cjm_17: 'between analysts and designers',
  cjm_18: 'We offer an individual',
  cjm_19: 'approach to each client',
  cjm_20: 'We can increase overall',
  cjm_21:
    'customer satisfaction with the service/product and ultimately increase their loyalty to the company',
  cjm_22: 'We guarantee the',
  cjm_23:
    'optimization of the consumer’s path and take into account the company’s business processes',
  cjm_24: 'We offer our customers',
  cjm_25:
    'the opportunity to use combined approaches: CATI, CAWI, focus groups, in-depth interviews, expert interviews, ethnography, etc.',
  cjm_26: 'Why choose us?',
  methods_hr_1: 'Human Resources Research',
  methods_hr_2:
    'Get objective insights about your team and find how to improve HR performance',
  methods_hr_3: 'Some reasons why you may need HR research',
  methods_hr_4: 'of the staff interviewed',
  methods_hr_5: 'hr projects implemented',
  methods_hr_6: 'staff training sessions have been held',
  methods_hr_7:
    'Leading European holding for customer experience and employee research',
  methods_hr_8: '4service HR researches in numbers',
  methods_hr_9:
    "To identify problems and weaknesses in each stage of the life of your company's employees: search/recruitment/onboarding/career development/recertifications",
  methods_hr_10: 'To know what occasions deserve raises and bonuses',
  methods_hr_11:
    'You need to predict or provide solutions of employees dissatisfaction',
  methods_hr_12:
    'Through HR research new and current methods of evaluation of HR policies, programmes and practices are possible',
  methods_hr_13: 'To improve the mental health of company employees',
  methods_hr_14:
    'If you want to improve productivity through a goal-oriented approach',
  methods_hr_15:
    'If you have an international and/or remote team and you need to manage it',
  methods_hr_16:
    'To understand how attractive your employer brand is to potential employees',
  methods_hr_17: 'Employee Satisfaction',
  methods_hr_18: 'HR Branding Research',
  methods_hr_19: 'Cultural Diversity',
  methods_hr_20: 'Compensation and Salary Plansies',
  methods_hr_21: 'Team Engagement and Loyality',
  methods_hr_22: 'Protected Class Employees',
  methods_hr_23: 'Areas of research',
  methods_hr_24: 'Solution 1',
  methods_hr_25: 'eNPS, Employee Satisfaction, Employee Loyalty',
  methods_hr_26: 'What we measure:',
  methods_hr_27: 'Loyalty:',
  methods_hr_28:
    'employee loyalty, predicting future behavior, determining the weight of factors that affect loyalty',
  methods_hr_29: 'Involvement:',
  methods_hr_30:
    'involvement of employees in work, interest in results and achievements',
  methods_hr_31: 'Engagement:',
  methods_hr_32: 'identification of employee values and company values',
  methods_hr_33: 'Trust 360:',
  methods_hr_34:
    'trust in management, co-workers, subordinates, trust in employer strategies and policies',
  methods_hr_35: 'Satisfaction:',
  methods_hr_36:
    'defining the unique factors for each company, evaluation of satisfaction on each key factor affecting loyalty',
  methods_hr_37: 'Solution 2',
  methods_hr_38: 'Employer branding',
  methods_hr_39: 'Internal employer',
  methods_hr_40:
    'brand analysis (staff, stakeholder, internal recruiters and HR specialists survey)',
  methods_hr_41: 'External employer analysis',
  methods_hr_42:
    '(competitor EVP analysis, external recruiter survey, job seeker survey)',
  methods_hr_43: 'Brand awareness and reputation',
  methods_hr_44: 'analysis',
  methods_hr_45: 'Employer presence',
  methods_hr_47: 'Employer reference',
  methods_hr_48: 'collection',
  methods_hr_49: 'Competitive benchmarking',
  methods_hr_50: 'on key factors such as',
  methods_hr_51: 'Salary,',
  methods_hr_52: 'working environment, atmosphere, nature of work',
  methods_hr_53: 'Analysis of needs and expectations',
  methods_hr_54: 'of job seekers',
  methods_hr_55: 'In-depth interviews,',
  methods_hr_56: 'desk research and quantitative research are used',
  methods_hr_57: 'Solution 3',
  methods_hr_58: 'Employee journey map/mystery employee',
  methods_hr_59: 'constructing the jobseeker journey identifying',
  methods_hr_60:
    'the main stages of the search, channels of communication, selection criteria and assessment of jobseekers',
  methods_hr_61: 'monitoring all stages',
  methods_hr_62:
    'gizli iş arayanlarla iletişim kanalları ve aşamaları (sadece mülakat için randevu alma, mülakat süreci, şirkette staj)',
  methods_hr_63: 'Belirleme',
  methods_hr_64: 'işe alım ve oryantasyon süreçlerindeki zayıf yönlerin',
  methods_hr_65: 'İyileştirme önerileri,',
  methods_hr_66: 'sektör liderleriyle kıyaslama',
  mystery_shopping_1: 'Gizli',
  mystery_shopping_2: 'Müşteri',
  mystery_shopping_3: 'Hizmetinizi gerçek müşterilerle değerlendirin',
  mystery_shopping_4:
    'Standartları kontrol edin, personelinizi değerlendirin ve müşterinize daha yakın olun',
  mystery_shopping_5:
    'Profesyonel lider Gizli Müşteri Sağlayıcıları derneği MSPA Europe’un Elite üyesiyiz',
  mystery_shopping_6: 'yıllık deneyim',
  mystery_shopping_7: 'aylık ziyaret',
  mystery_shopping_8: 'dünya çapında gizli müşteriler',
  mystery_shopping_9: 'Aktif projeler',
  mystery_shopping_10: 'ofisler, merkez Avusturya’da',
  mystery_shopping_11: 'Avrupa Gizli Müşteri Sağlayıcıları',
  mystery_shopping_12: 'hizmet kalitesi değerlendirmeleri',
  mystery_shopping_13: 'Anket',
  mystery_shopping_14: 'Yazılım',
  mystery_shopping_15: 'Müşteri profili',
  mystery_shopping_16: 'Doğrulama ve itiraz',
  mystery_shopping_17: 'Analitik',
  mystery_shopping_18:
    'Bu 5 adım ile 4Service şirketimiz gizli müşteri hizmetinin kalitesini garanti eder',
  mystery_shopping_19: 'Program',
  mystery_shopping_20:
    '4Service tarafından sunulan Gizli Müşteri programının 5 unsuru',
  mystery_shopping_21: 'Anket:',
  mystery_shopping_22: 'programınızın çekirdeği',
  mystery_shopping_23:
    'Programın bu bölümü tüm paydaşlar tarafından görüntülenebilir',
  mystery_shopping_24: 'Üst düzey yöneticiler için.',
  mystery_shopping_25: 'Sürecin tüm önemli adımlarını ve detaylarını gösterir',
  mystery_shopping_26: 'Çalışanlar için.',
  mystery_shopping_27: 'İşverenlerin kendilerinden ne beklediğini yansıtır',
  mystery_shopping_28: 'Gizli müşteriler için.',
  mystery_shopping_29:
    'Karışıklık ve önyargıyı önlemek için açık ve yapılandırılmış',
  mystery_shopping_30: 'Shopmetrics Yazılımı:',
  mystery_shopping_31: 'kullanıcı dostu ve yenilikçi',
  mystery_shopping_32: 'Avantajlar:',
  mystery_shopping_33: 'Entegre olur',
  mystery_shopping_34: 'iş süreçleriniz ve yazılımınız ile',
  mystery_shopping_35: 'GDPR Odaklı',
  mystery_shopping_36: 'Gizlilik Yönetim Araç Seti',
  mystery_shopping_37: 'Detaylı',
  mystery_shopping_38: 'Yasal Uyum Paketi',
  mystery_shopping_39: 'Rapor',
  mystery_shopping_40: 'oluşturucu',
  mystery_shopping_41: 'Yönetim',
  mystery_shopping_42: 'erişim seviyelerinin',
  mystery_shopping_43: 'Çoğu anket',
  mystery_shopping_44: 'bir saat içinde tamamlanır',
  mystery_shopping_45: 'Müşteri profili:',
  mystery_shopping_46: 'Dünya çapında 200 000+ gizli müşteri',
  mystery_shopping_47:
    'Ana kriterler: hedef kitlenize maksimum yakınlık, şirketiniz veya rakiplerinizle önceki deneyim',
  mystery_shopping_48: 'Müşteri eğitimi:',
  mystery_shopping_49: 'Tanıtım eğitim testi',
  mystery_shopping_50: 'Skype/Telefon görüşmesi',
  mystery_shopping_51: 'Değerlendirme testi (opsiyonel)',
  mystery_shopping_52: 'Doğrulama ve itirazlar',
  mystery_shopping_53: 'Doğrulama',
  mystery_shopping_54: 'Sistem',
  mystery_shopping_55: '%100 rapor',
  mystery_shopping_56: 'doğrulama ekibi tarafından incelenir',
  mystery_shopping_57: 'Ek aramalar',
  mystery_shopping_58: 'açıklama için',
  mystery_shopping_59: 'Ses kayıtları',
  mystery_shopping_60: 'ziyaret sonrası en önemli konuları not almak için',
  mystery_shopping_61: 'Çalışan dolandırıcılığı',
  mystery_shopping_62: 'önleme sistemi',
  mystery_shopping_63: 'İtiraz',
  mystery_shopping_64: 'Sistem',
  mystery_shopping_65: 'Herhangi bir müşterinin değerlendirmesi',
  mystery_shopping_66:
    'çalışan tarafından doğrudan web sitesinde itiraz edilebilir',
  mystery_shopping_67: 'Her itiraz',
  mystery_shopping_68:
    'yerel doğrulama ekibi tarafından değerlendirilir ve yanıtlanır',
  mystery_shopping_69: 'İstatistikleri görebilirsiniz',
  mystery_shopping_70: 'itirazların',
  mystery_shopping_71: 'Analitik.',
  mystery_shopping_72: 'Raporlar yüz yüze sunulur ve şunları içerir:',
  mystery_shopping_73: 'Şirketin',
  mystery_shopping_74: 'sorunlu noktaları ve endişeleri',
  mystery_shopping_75: 'Dinamikler',
  mystery_shopping_76: 'bölümler ve birimler bazında',
  mystery_shopping_77: 'Korelasyon',
  mystery_shopping_78: 'standartlara uyum ile müşteri memnuniyeti arasında',
  mystery_shopping_79: 'Kıyaslama',
  mystery_shopping_80: 'rakiplere karşı',
  mystery_shopping_81: 'Pratik',
  mystery_shopping_82: 'hizmet iyileştirmelerine yönelik öneriler',
  mystery_shopping_83: 'Bizi farklı kılan nedir?',
  mystery_shopping_84: 'Fikir geliştirme oturumları yürütüyoruz',
  mystery_shopping_85:
    'Sadece ne yapılması gerektiğini önermekle kalmıyor, aynı zamanda sizinle birlikte hizmet sorunlarını çözmek için pratik yollar arıyoruz.',
  mystery_shopping_86:
    'Fikir geliştirme oturumları bize yardımcı olan güçlü bir araçtır:',
  mystery_shopping_87:
    'Ürün veya hizmetlerin iyileştirilmesi için yönler geliştirmek',
  mystery_shopping_88:
    'Yeni gelir akışı fırsatlarını ve iş stratejilerini keşfetmek',
  mystery_shopping_89: 'Karmaşık müşteri odaklı zorluklara çözümler bulmak',
  mystery_shopping_90:
    'Müşterilerin sorunlu noktalarını memnuniyete dönüştürmek',
  mystery_shopping_91: 'Video görüşmeleri gerçekleştiriyoruz',
  mystery_shopping_92:
    'Sadece anketleri toplamakla kalmıyoruz — alışveriş yapanlardan canlı yorumlar da alıyoruz',
  mystery_shopping_93: 'Bunu şu amaçlarla yapıyoruz:',
  mystery_shopping_94:
    'Kolaylaştırıcılarımız derinlemesine görüşmeler yapacak ve etkili geri bildirim sağlayacaktır',
  mystery_shopping_95: 'Deneyimi müşterinin bakış açısından görmek',
  mystery_shopping_96: 'İçerik pazarlama stratejinizi geliştirmek',
  mystery_shopping_97: 'Müşteri davranışını öngörmek',
  mystery_shopping_98: 'Müşteri Yolculuğu Haritası tasarlıyoruz',
  mystery_shopping_99:
    'Müşteri Yolculuğu Haritalama, müşterilerin ihtiyaçlarını ve zorluklarını anlamak için onların yerine geçmemize yardımcı olur.',
  mystery_shopping_100:
    'Bir müşteri yolculuğu oluşturmak şunlar için en iyi yoldur:',
  mystery_shopping_101: 'Deneyimi müşterinin bakış açısından görmek',
  mystery_shopping_102: 'İçerik pazarlama stratejinizi geliştirmek',
  mystery_shopping_103: 'Müşteri davranışını öngörmek',
  mystery_shopping_104: 'Hizmet veya iletişimdeki boşlukları belirlemek',
  mystery_shopping_105: 'Farklı türlerde Gizli Müşteri hizmetleri sunuyoruz',
  mystery_shopping_106: 'Gizli Müşteri Türleri',
  mystery_shopping_107: 'Gizli Arayan',
  mystery_shopping_108:
    'Telefon üzerinden sunulan hizmet kalitesini belirlemek için yöneticilerinizi ve/veya çağrı merkezinizi arar',
  mystery_shopping_109: 'Lüks gizli müşteri',
  mystery_shopping_110:
    'Özel bir gizli müşteri kategorisi tarafından lüks lokasyonlarda hizmetin kontrol edilmesi',
  mystery_shopping_111: 'Rekabetçi ziyaretler',
  mystery_shopping_112: 'Rakibinizin nasıl çalıştığını anlamanın en kolay yolu',
  mystery_shopping_113: 'Gizli Çalışan',
  mystery_shopping_114:
    'Çalışanınızın tüm yolculuğunu (işe alım, uyum, ofis süreçleri vb.) anlamanıza yardımcı olur',
  mystery_shopping_115: 'Motivasyonel ziyaretler',
  mystery_shopping_116:
    'Ek hizmet ve/veya ürünlerin sunumunu, belirli ürünlerin satışını teşvik etmek için faydalı bir araç',
  mystery_shopping_117: 'Çevrimiçi Gizli Müşteri',
  mystery_shopping_118:
    'Online mağazanızda, web sitenizde veya uygulamanızda müşteri deneyimini simüle eder ve ölçer',
  mystery_shopping_119: 'Satış ve promosyon kontrolü',
  mystery_shopping_120:
    'Promosyonların tüm lokasyonlarda nasıl sergilendiğini ve ne kadar etkili çalıştığını belirlemeye yardımcı olur',
  mystery_shopping_121: 'Satın alma ve iade ziyaretleri',
  mystery_shopping_122:
    'Müşteri deneyimini iyileştirmek için satın almadan iadeye kadar tüm süreci yansıtmaya yardımcı olur',
  mystery_shopping_123: '> 20 yıl',
  nps_1: 'Net Tavsiye',
  nps_2: 'Skoru',
  nps_3: 'Müşteri sadakatini ölçün, takip edin ve geliştirin',
  nps_4: '0 ile 6 arasında bir puan verirler.',
  nps_5:
    'Kötü bir deneyim yaşamış, tekrar sizden satın alma olasılığı düşük olan ve hatta başkalarını da sizden satın almaktan caydırabilecek kişilerdir.',
  nps_6: '7 ile 8 arasında puan veren katılımcılardır.',
  nps_7:
    'Hizmetinizden memnundurlar ancak destekleyici olarak kabul edilecek kadar mutlu değillerdir.',
  nps_8: 'İşinizi 9 veya 10 olarak değerlendiren katılımcılardır.',
  nps_9:
    'Bu, sizi bir arkadaşına veya meslektaşına tavsiye edecekleri ve dolayısıyla sizin adınıza savunuculuk yapacakları anlamına gelir.',
  nps_10: 'NPS nedir?',
  nps_11: 'Tek bir basit soruya dayalı olarak müşteri algısını ölçer:',
  nps_12:
    'Bir arkadaşınıza veya meslektaşınıza [Kuruluş/Ürün/Hizmet] önermeye ne kadar olası görüyorsunuz?',
  nps_13: 'Şirketimin buna ihtiyacı var mı?',
  nps_14: 'NPS sürdürülebilir büyümenizdir',
  nps_15: 'Müşteri Sadakatinin Dinamiklerini Anlamak',
  nps_16: 'Personelinizi motive edin',
  nps_17: 'Farklı ürünlerle olan ilişkiyi anlayın',
  nps_18: 'Müşterilerin size ve rakiplerinize nasıl davrandığını karşılaştırın',
  nps_19: 'NPS ile ne yapabilirim?',
  nps_20: 'NPS hangi tür işletmeler için uygundur?',
  nps_21: 'Bilgi toplama yöntemleri:',
  nps_22: 'NPS ile çalışırken önerilerimiz',
  nps_23:
    'Bu, Detraktörleri destekçilere dönüştürmeye yardımcı olacak yönergeler geliştirdiğimiz anlamına gelir',
  nps_24: '“Kapalı döngü” yöntemiyle çalışıyoruz',
  nps_25:
    'NPS, müşteri sadakatindeki değişimleri takip ettiğimiz bir izleme araştırmasıdır',
  nps_26: 'Dinamikleri izliyoruz',
  nps_27:
    'Daha derinlemesine bir analiz için nişinizdeki rakipleri her zaman değerlendirmeyi öneriyoruz',
  nps_28: 'Rakip değerlendirmesi',
  price_monitoring_1: 'Fiyat İzleme',
  price_monitoring_2: 'Perakende İzleme',
  price_monitoring_3:
    'Rakip fiyat izleme yoluyla satış potansiyelini artırın ve fiyatlandırma politikanızı optimize edin',
  price_monitoring_4:
    '4Service, 20 yılı aşkın süredir dünya çapında fiyat izleme hizmetleri sunmaktadır',
  price_monitoring_5:
    'Fiyatlar, nitelikli kurum içi denetçilerden oluşan ekibimiz tarafından kısa sürede izlenir; bu da rakip fiyatlarındaki değişikliklere hızlı yanıt vermemizi sağlar',
  price_monitoring_6:
    'Fiyat izleme ile şirketimizin çözmenize yardımcı olabileceği zorluklar',
  price_monitoring_7: 'Rakiplerin fiyatlandırmasının değerlendirilmesi',
  price_monitoring_8: 've ürün politikaları',
  price_monitoring_9: 'Promosyonların izlenmesi',
  price_monitoring_10: 've özel teklifler',
  price_monitoring_11: 'Piyasa koşullarının izlenmesi',
  price_monitoring_12: 've piyasa ortamı',
  price_monitoring_13: 'Satış noktalarının kontrol edilmesi ve denetlenmesi',
  price_monitoring_14: 'özel ekipman ve ürünler için',
  price_monitoring_15: 'Ürün akışının yönetimi',
  price_monitoring_16: 'ticaret içinde',
  price_monitoring_17: 'Koşulların optimize edilmesi',
  price_monitoring_18: 'tedarikçiler ve bayilerle daha iyi iş birliği için',
  price_monitoring_19: 'Raf alanının ölçülmesi,',
  price_monitoring_20:
    'ürün konumlandırmasının değerlendirilmesi, stok bulunabilirliği',
  price_monitoring_21: 'Temel göstergeler ve izleme kriterleri',
  price_monitoring_22:
    'Tüm veriler tek bir arayüzde derlenir, bunlar şunları içerir:',
  price_monitoring_23: 'ad',
  price_monitoring_24: 'ürün ve marka kategorisinin',
  price_monitoring_25: 'bulunabilirlik',
  price_monitoring_26: 'promosyon materyallerinin',
  price_monitoring_27: 'fiyat',
  price_monitoring_28: 've tüm promosyon tekliflerinin bulunabilirliği',
  price_monitoring_29: 'raf',
  price_monitoring_30: 'boyutu',
  price_monitoring_31: 'ürün',
  price_monitoring_32: 'sergileme',
  price_monitoring_33: 'SKU',
  price_monitoring_34: 'facing',
  price_monitoring_35: 'türü',
  price_monitoring_36: 'ambalajın',
  price_monitoring_37: 'diğer tüm',
  price_monitoring_38: 'genel bilgiler',
  price_monitoring_39: 'Proje öncesi analiz:',
  price_monitoring_40: 'İnceliyoruz',
  price_monitoring_41:
    'şirketinizin fiyatlandırma ve ürün politikalarını, iş ve sektör uygulamalarını',
  price_monitoring_42: 'Sağlıyoruz',
  price_monitoring_43: 'denetçiler için hızlı eğitim, test ve sertifikasyon',
  price_monitoring_44: 'Özelleştiriyoruz',
  price_monitoring_45: 've yazılımı kuruyoruz',
  price_monitoring_46: 'Saha çalışması:',
  price_monitoring_47: 'Perakende noktalarına',
  price_monitoring_48: 'ziyaretler',
  price_monitoring_49: 'Raporlama:',
  price_monitoring_50: 'Analitik ekibimiz',
  price_monitoring_51:
    'şirketin kişisel hesaplarında çevrimiçi raporlar hazırlar',
  price_monitoring_52: 'Sağlıyoruz',
  price_monitoring_53:
    'yerleşim türü, zincir adı, mağaza adresi bazında tam fotoğraf raporu, PPT raporu ve Excel raporu',
  price_monitoring_54: 'Nasıl',
  price_monitoring_55: 'çalışır',
  price_monitoring_56: 'bireysel indirimlerin büyüklüğü',
  price_monitoring_57: 'maliyet hesaplaması',
  price_monitoring_58: 'bireysel bonusların büyüklüğü',
  price_monitoring_59: 'sadakat programları',
  price_monitoring_60: 'vb.',
  price_monitoring_61: 'Özel yazılımlar kullanıyoruz:',
  price_monitoring_62:
    'PRADATA, Shopmetrics ve kapsamlı teknik destek sunuyoruz',
  price_monitoring_63: 'Hızlı devreye alma',
  price_monitoring_64: 've ölçeklendirme (1. günden itibaren)',
  price_monitoring_65: 'Tüm veriler doğrulanır',
  price_monitoring_66: 'fotoğraflar ve GPS etiketleme ile',
  price_monitoring_67: 'Gerekli sayıda',
  price_monitoring_68: 'saha temsilcisine her ülkede sahibiz',
  price_monitoring_69: 'Büyük',
  price_monitoring_70: 'veri miktarlarıyla çalışabiliyoruz',
  price_monitoring_71: 'Bireysel fiyatların izlenmesi',
  price_monitoring_72:
    'Karmaşık ürünleriniz varsa — fiyatlandırma stratejinizi tanımlamanıza yardımcı olabiliriz',
  price_monitoring_73:
    'Örneğin, bireysel rakiplerin fiyatlarını izleyebiliriz:',
  price_monitoring_74: 'Düşük',
  price_monitoring_75: 'maliyet',
  price_monitoring_76: 'Yüksek',
  price_monitoring_77: 'verimlilik',
  price_monitoring_78: 'Excel raporu',
  price_monitoring_79: 'PPT raporu',
  price_monitoring_80: 'BI raporu',
  price_monitoring_81:
    'Rakip fiyatlandırma verileri, en iyi fiyatlandırma kararlarını almanıza yardımcı olur',
  price_monitoring_82:
    'Yerleşim türüne göre tam fotoğraf raporu, PPT raporu ve Excel raporu sunuyoruz',
  qualitative_research_1: 'Nitel',
  qualitative_research_2: 'araştırmalar',
  qualitative_research_3:
    'Müşterilerinizin eylem ve sözlerini gözlemleyerek veri toplar, analiz eder ve yorumlarız',
  qualitative_research_4: 'Değerler',
  qualitative_research_5: 'Davranış',
  qualitative_research_6: 'Arka plan',
  qualitative_research_7: 'Beklentiler',
  qualitative_research_8: 'Çevre',
  qualitative_research_9: 'Korkular/Engeller',
  qualitative_research_10: 'Müşterinin seçiminin amacı nedir?',
  qualitative_research_11: 'Telefonlu adam',
  qualitative_research_12: 'marka',
  qualitative_research_13: 'kategori',
  qualitative_research_14: 'reklam',
  qualitative_research_15: 'ürün',
  qualitative_research_16:
    'Nitel yöntemlerin benzersizliği, tüketici davranışının nedenlerini ve motivasyonunu anlamamıza olanak tanımasıdır',
  qualitative_research_17:
    'Tüketicinin belirli bir olguya yönelik tutumunun analizi',
  qualitative_research_18: 'Bireysel bakış açıları ve deneyimler',
  qualitative_research_19: 'Anketlerle araştırılamayan konular',
  qualitative_research_20: 'Hassas konular',
  qualitative_research_21: 'Ulaşılması zor kitle',
  qualitative_research_22: 'Karmaşık coğrafya',
  qualitative_research_23: 'Derinlemesine görüşmeler şunlar için faydalıdır:',
  qualitative_research_24: 'Derinlemesine görüşmeler',
  qualitative_research_25:
    'Derinlemesine görüşme, belirli bir fikir, program veya durum hakkında görüşlerini keşfetmek için katılımcılarla bire bir yapılan nitel bir araştırma tekniğidir. Bireysel deneyimleri / algıları / uygulamaları ayrıntılı biçimde inceler.',
  qualitative_research_26: 'Amaçlar:',
  qualitative_research_27: 'Sosyal ve kültürel normların tanımlanması',
  qualitative_research_28: 'Ulaşılması zor kitle',
  qualitative_research_29:
    'Paylaşım ve karşılaştırma (Morgan) — anketlerle incelenir',
  qualitative_research_30: 'Anketlerle araştırılamayan konular',
  qualitative_research_31:
    'Derinlemesine odak grupları şunlar için faydalıdır:',
  qualitative_research_32: 'Odak grupları',
  qualitative_research_33:
    'Bireysel etkileşimlerin derinlemesine incelenmesi, ortaya çıkan tartışmalar ve grup moderatörünün etkisi altındaki görüşmeler.',
  qualitative_research_34:
    'Grup tartışmaları yoluyla paylaşılan deneyimler ve sosyal normlar hakkında içgörü üretimi, odaklı tartışmada anlatı verileri.',
  qualitative_research_36: 'Faydalar:',
  qualitative_research_37:
    'Tüketicinin yaşam tarzı ve davranışlarının çeşitli gerçek koşullarda incelenmesi (evde, satış noktasında, işte vb.)',
  qualitative_research_38:
    'Yeni ürün geliştirme, ambalaj, hizmet iyileştirme vb. için içgörü arayışı',
  qualitative_research_39:
    'Derinlemesine etnografik araştırma şunlar için faydalıdır:',
  qualitative_research_40: 'Etnografik araştırma',
  qualitative_research_41:
    'Etnografi, belirli bir topluluk veya organizasyonun davranışlarını ve etkileşimlerini yakından gözlemlemek için içine girilen bir nitel araştırma türüdür.',
  qualitative_research_42:
    'Etnografi, bir grubun paylaşılan kültürünü, geleneklerini ve sosyal dinamiklerini derinlemesine anlamayı sağlayan esnek bir araştırma yöntemidir. Ancak bazı pratik ve etik zorluklar da içerir.',
  qualitative_research_43: 'Yöntemler:',
  qualitative_research_44:
    'Etnografi, tüketicinin gerçek yaşam koşullarında ve bir ürün/hizmetle etkileşim içinde incelenmesidir',
  qualitative_research_45: 'Bizimle çalışmanın faydaları',
  qualitative_research_46:
    'Herhangi bir hedef kitleden katılımcı bulabiliriz ve işe alım kalitesini kontrol ederiz',
  qualitative_research_47: 'Her türlü karmaşıklıkta işe alım',
  qualitative_research_48:
    'Moderatörlerimiz çok dillidir ve kolaylaştırma becerilerine sahiptir',
  qualitative_research_49: 'Uzman moderatörler',
  qualitative_research_50: 'Çevrim içi/çevrim dışı çalışma',
  qualitative_research_51: 'Ses/video',
  qualitative_research_52: 'kayıtları sağlıyoruz',
  qualitative_research_53:
    'Herhangi bir yerleşim yerinde nitel araştırma yürütebiliriz',
  quantitative_research_1: 'Müşteri memnuniyeti araştırması',
  quantitative_research_2: 'belirli bir ürün veya hizmet için (SCI, NPS)',
  quantitative_research_3: 'Segmentasyonun yürütülmesi',
  quantitative_research_4: 'farklı pazarların anketleri',
  quantitative_research_5: 'Pazar araştırması',
  quantitative_research_6: 'NPS yönetimi',
  quantitative_research_7: 'Rakip analizi',
  quantitative_research_8: 'Nicel',
  quantitative_research_9: 'araştırmalar',
  quantitative_research_10:
    'İnsanların tutum ve davranışlarına ilişkin teorileri nesnel, sayısal ve istatistiksel verilerle test eden araştırma metodolojisi',
  quantitative_research_11: 'yıl',
  quantitative_research_12: 'dünya çapında CX deneyimi',
  quantitative_research_13: 'panel',
  quantitative_research_14: 'katılımcılardan oluşan',
  quantitative_research_15: 'ülke',
  quantitative_research_16: 'dünya genelinde projeler yürütüyoruz',
  quantitative_research_17: 'Biz kimiz',
  quantitative_research_18:
    '4Service, küresel bir pazarlama araştırması ve CX holdingidir. Çok çeşitli işletmelere uzman veri toplama hizmetleri sunuyoruz',
  quantitative_research_19: '4Service Rakamlarla',
  quantitative_research_20: 'Bilgisayar Destekli',
  quantitative_research_21: 'Web Görüşmeleri',
  quantitative_research_22:
    'İnternet tabanlı bir anket tekniği. Katılımcı, görüşmeci yardımı olmadan elektronik anketi doldurur',
  quantitative_research_23: 'Bilgisayar Destekli Web Görüşmeleri',
  quantitative_research_24: 'Çoğu durumda',
  quantitative_research_25:
    'malzeme ve zaman maliyetleri açısından en uygun yöntemdir',
  quantitative_research_26: 'Bu anket',
  quantitative_research_27: 'ulaşılması zor bir kitleyle görüşme imkânı sunar',
  quantitative_research_28: 'Geniş olanaklar sağlar',
  quantitative_research_29: 'video, ses ve görsel materyal gösterimi için',
  quantitative_research_30: 'Katılımcılar',
  quantitative_research_31: 'dünyanın herhangi bir yerinde olabilir',
  quantitative_research_32: 'Araştırmaya olanak tanır',
  quantitative_research_33:
    'internet kitlesinin özel davranışlarını. Sonuçlara müşteri gerçek zamanlı olarak web arayüzünden erişebilir',
  quantitative_research_34: 'Her türlü gizli,',
  quantitative_research_35: 'hassas veya kişisel konu için uygundur',
  quantitative_research_36: '150 000+ panel',
  quantitative_research_37: 'Dünya genelinde kendi katılımcı panelimiz vardır',
  quantitative_research_38: 'Zorlu taleplerle çalışıyoruz',
  quantitative_research_39:
    'Tamamlayıcı araçlar kullanarak (sosyal medya, reklam) özel bir kitle bulabiliriz',
  quantitative_research_40: 'Katılımcılarımızı motive ederiz',
  quantitative_research_41:
    'Uzun anketlerin tamamlanmasını teşvik eden bir yapı tasarladık',
  quantitative_research_42: 'Yüz yüze görüşmeler',
  quantitative_research_43: 'tablet kullanılarak yapılır',
  quantitative_research_44:
    'Bu, yapılandırılmış anketle doğrudan görüşme yapılan temel yöntemlerden biridir',
  quantitative_research_45:
    'Yüz yüze görüşmeler, katılımcıların iş yerinde, evinde, sokakta veya belirlenmiş satış noktalarında tablet ile yapılabilir',
  quantitative_research_46: 'Tablet kullanılarak yapılan yüz yüze görüşmeler',
  quantitative_research_47: 'Belirleme',
  quantitative_research_48: 'marka bilinirliği ve popülerlik düzeyi',
  quantitative_research_49: 'Tüketici segmentasyonu',
  quantitative_research_50: 'satın alma davranışına göre',
  quantitative_research_51: 'Analiz',
  quantitative_research_52: 'reklam kampanyasının etkinliği',
  quantitative_research_53: 'Müşteri memnuniyeti',
  quantitative_research_54: 'ölçümü',
  quantitative_research_55: 'En iyi fiyatın belirlenmesi',
  quantitative_research_56: 'ürün veya hizmet için',
  quantitative_research_57: 'Analiz',
  quantitative_research_58: 'tüketici tercihleri',
  quantitative_research_59: 'İnceleme',
  quantitative_research_60: 'tüketicilerin nasıl satın aldığı',
  quantitative_research_61: 'Değerlendirme',
  quantitative_research_62: 'pazar kapasitesi',
  quantitative_research_63: 'DigSee Yazılımı',
  quantitative_research_64: 'Ses kaydı ve GPS içeren özel yazılım kullanıyoruz',
  quantitative_research_65: 'Görüşmeciler ve süpervizörler',
  quantitative_research_66:
    'Her dilde görüşme yapabilir ve müşterinin tercih ettiği dile çevirebiliriz',
  quantitative_research_67: 'Örnekleme',
  quantitative_research_68:
    'Analitik departman en iyi sonucu elde etmek için katılımcı işe alım sistemi geliştirir',
  quantitative_research_69: 'Bilgisayar Destekli',
  quantitative_research_70: 'Telefon Görüşmeleri',
  quantitative_research_71:
    'Yapılandırılmış anket kullanılarak telefonla nicel veri toplama metodolojisi',
  quantitative_research_72: 'Bilgisayar Destekli Telefon Görüşmeleri',
  quantitative_research_73: 'Kendi çağrı merkezlerimiz vardır',
  quantitative_research_74: 'Ses kaydı ve GPS içeren özel yazılım kullanıyoruz',
  quantitative_research_75: 'Nitelikli operatörler',
  quantitative_research_76:
    'Operatörlerimiz çok dillidir, eğitimlidir ve sürekli gelişir',
  quantitative_research_77: 'Veri tabanları',
  quantitative_research_78:
    'Kendi veri tabanlarımızla ve müşteri veritabanlarınızla çalışıyoruz',
  quantitative_research_79: 'SLA',
  quantitative_research_80: 'Kaliteyi garanti eder ve SLA imzalarız',
  quantitative_research_81: 'Hedef belirleme',
  quantitative_research_82: 'Metodoloji belirleme',
  quantitative_research_83: 'Segmentasyon ve örnekleme',
  quantitative_research_84: 'Veri toplama kanallarının tanımlanması',
  quantitative_research_85: 'Katılımcı için mantıklı anket oluşturma',
  quantitative_research_86: 'Veri toplama süreci',
  quantitative_research_87: 'Kalite güvencesi',
  quantitative_research_88: 'Analiz teknikleri',
  quantitative_research_89: 'Veri işleme',
  quantitative_research_90: 'Anket tasarımı',
  quantitative_research_91: 'Görüşmecilerin GPS konum takibi',
  quantitative_research_92: 'Veri doğrulama',
  quantitative_research_93: 'Anket programlama ve test',
  quantitative_research_94: 'Veri geçerliliği',
  quantitative_research_95: 'GDPR gerekliliklerine uygun ses kayıtları',
  quantitative_research_96: 'Araştırma personelinin eğitimi ve yetkinliği',
  quantitative_research_97: 'Kalite Güvencesi',
  quantitative_research_98: 'Faktör analizi',
  quantitative_research_99: 'Segmentasyon',
  quantitative_research_100: 'Algısal haritalama',
  quantitative_research_101: 'Korelasyon',
  quantitative_research_102: 'Dönüşüm modeli',
  quantitative_research_103: 'Jaccard',
  quantitative_research_104: 'Küme analizi',
  quantitative_research_105: 'vb.',
  quantitative_research_106: 'Analitik Raporlar',
  quantitative_research_107:
    'SPSS® ve diğer araçları kullanarak farklı metodolojilerle analitik raporlar oluşturuyoruz',
  quantitative_research_108: 'Hangi iş zorlukları çözülebilir:',
  quantitative_research_109: 'Hangi iş zorlukları çözülebilir:',
  social_responsibility_1: '4Service Kurumsal Sosyal Sorumluluk',
  social_responsibility_2:
    'Ekibimizin her bir üyesinin kalbinden ve ruhundan. Her çalışanımızda bir iyilik kıvılcımı korumaya ve çevremizdeki dünyayı biraz daha iyi hale getirmeye çalışıyoruz',
  social_responsibility_3: 'Eğitim faaliyetleri / Gençlik desteği',
  social_responsibility_4:
    'Çocuklar ve öğrenciler için sosyal erişim girişimlerimiz',
  social_responsibility_5: 'Service Mania iş oyunu',
  social_responsibility_6:
    'Eğitim faaliyetlerimizin önemli bir parçası Service Mania adlı iş oyunudur.',
  social_responsibility_7:
    'Service Mania, olağandışı durumlarla nasıl başa çıkılacağı konusunda stratejik düşünmeye teşvik eder.',
  social_responsibility_8: 'Araştırma sunumu / Diiya. Business',
  social_responsibility_9:
    'Hizmet durumuna iş ve müşteri perspektifinden bakış: 4Service Ukraine Gelişim Direktörü Victoria Skorbota tarafından sunulan 4Service araştırma bulgularımızın sunumu',
  social_responsibility_10: 'Servis Tasarımı oturumları',
  social_responsibility_11:
    'Servis Tasarımı metodolojisi 4Service’in önemli bir parçasıdır. Birkaç yıl önce DesignThinkers Academy iş ortağı olduk ve çalışmalarımızda en iyi uygulamaları kullanmakla kalmayıp aynı zamanda en iyi şirketlere aktif olarak eğitimler veriyoruz',
  social_responsibility_12: 'Hayırseverlik / Gönüllülük',
  social_responsibility_13:
    'Yetimhaneler, yaşlı bakım evleri ve Ukrayna ordusu için gönüllülük. Faaliyetlerimizin en dokunaklı kısmı',
  social_responsibility_14: '#HelpEasyWith4ServiceGroup',
  social_responsibility_15:
    'Blagomai Hayır Fonu ile ortaklık içinde çalışıyoruz ve acil yardıma ihtiyacı olanlara destek olmaya ve mutluluk getirmeye çalışıyoruz',
  social_responsibility_16: 'Yetimhaneler ve huzurevleri için bağış toplama',
  social_responsibility_17:
    '4Service olarak temel ihtiyaçları satın almak için huzurevleri ve yetimhaneler adına çeşitli bağış kampanyaları başlattık',
  social_responsibility_18: '#SaveUkraine',
  social_responsibility_19:
    'Savaş, personelimizin ve yakın arkadaşlarımızın çoğunu etkiledi. Her birimiz elimizden geldiğince yardımcı oluyoruz',
  social_responsibility_20: 'Hayvan refahı',
  social_responsibility_21:
    'Herkes evcil hayvanıyla ofisimize gelebilir. Barınaklara yardım ediyor, mama için bağış topluyor ve bazen sahipsiz hayvanlar için yuva buluyoruz',
  social_responsibility_22: 'Hayvan barınaklarını destekleme',
  social_responsibility_23:
    'Sahipsiz hayvanlar da toplumumuzdaki tüm savunmasız bireyler kadar yardıma muhtaçtır.',
  social_responsibility_24:
    'Şirketimiz Sirius Sokak Hayvanları Barınağı’nı (Kiev bölgesi, Ukrayna) himayesi altına almıştır.',
  social_responsibility_25:
    'Sahipsiz hayvanlara yardım için yaratıcı girişimler',
  social_responsibility_26:
    'Hayvan barınaklarının acil sorununu müşterilerimizin ve iş ortaklarımızın dikkatine nasıl sunabiliriz?',
  social_responsibility_27: 'Evcil hayvan dostu ofis',
  social_responsibility_28:
    'Ekip üyelerimizin birçoğunun evcil hayvanı var. Herkesin evcil hayvanıyla ofise gelip rahat hissedebileceği sağlıklı bir ortam oluşturduk',
  ux_testing_1: 'UX Testi',
  ux_testing_1_1: 'UX Testi',
  ux_testing_2:
    'Web sitelerinizi ve uygulamalarınızı test etmek ve iyileştirmek için insan ve yapay zekâ tabanlı yaklaşım',
  ux_testing_3: 'UX testi nedir',
  ux_testing_4:
    'UX testi, insanların ürününüz, uygulamanız veya web sitenizle nasıl etkileşim kurduğunu anlamanıza yardımcı olur',
  ux_testing_5: 'Gezinme çok net değil',
  ux_testing_6: 'Nasıl sipariş vereceğimi bilmiyorum',
  ux_testing_7: 'Katalogda yeterli fotoğraf yok',
  ux_testing_8: 'Şunları yapacaksınız:',
  ux_testing_9: 'İyileştirme fırsatlarını keşfetmek',
  ux_testing_10: 'Tasarım ve müşterinin etkileşimindeki sorunları belirlemek',
  ux_testing_11:
    'Kullanıcının siteyle etkileşimde karşılaştığı zorlukları öğrenmek',
  ux_testing_12: 'Müşteri yolculuğunu gözlemlemek',
  ux_testing_13:
    'Hedef kitlenizin siteyi ne zaman ve neden terk ettiğini belirlemek',
  ux_testing_14:
    'Hangi bölümlerin en az ve en fazla ilgi ve duygu uyandırdığını tanımlamak',
  ux_testing_15: 'Kullanıcı temelli UX testi',
  ux_testing_16:
    '4Service, müşteri odaklı web siteleri ve uygulamalar oluşturmanız için nitel ve nicel yöntemlerle ihtiyaç duyduğunuz gerçek insan içgörülerini sunar',
  ux_testing_17: 'Siteyi nasıl kullanacağımı anlamıyorum. Menü nerede gizli?',
  ux_testing_18: 'Harfler arasında çok fazla boşluk var, metin okunamıyor',
  ux_testing_19: 'Resimler üst üste geliyor. Böyle mi olması gerekiyor?',
  ux_testing_20:
    'UX testi, insanların ürününüz, uygulamanız veya web sitenizle nasıl etkileşim kurduğunu anlamanıza yardımcı olur',
  ux_testing_21: 'Kullanıcı temelli UX testi araştırma tasarımı:',
  ux_testing_22: 'İyileştirme fırsatlarını keşfetmek',
  ux_testing_23: 'Test türü ve yönteminin belirlenmesi (nitel/nicel)',
  ux_testing_24: 'Hipotezlerin ve kullanıcı senaryolarının oluşturulması',
  ux_testing_25: 'Test sonuçlarının analizi ve raporlanması',
  ux_testing_26: 'İki çözüm',
  ux_testing_27: 'Başarılı UX testi için iki yaklaşım sunuyoruz',
  ux_testing_28: 'Kullanıcı temelli UX testi',
  ux_testing_29: 'Yapay zekâ + insan temelli UX testi',
  ux_testing_30: 'Güçlü yönlerimiz:',
  ux_testing_31: 'Rekabet ortamını analiz edebiliriz',
  ux_testing_32:
    'Görüşmeleri yürütmek ve katılmak için alanında uzman kişiler dahil edebiliriz',
  ux_testing_33:
    'Farklı dillerde görüşmeler yapabilir ve gerekli dile çevirebiliriz',
  ux_testing_34: 'mevcut kullanılabilirlik',
  ux_testing_35: 'metrikleri veya standartları ile',
  ux_testing_36: 'performansınızı',
  ux_testing_37: 'bir rakibin',
  ux_testing_38: 'versiyonlarına karşı',
  ux_testing_39: 'aynı ürünün',
  ux_testing_40: 'Memnuniyet puanı',
  ux_testing_41: 'NPS',
  ux_testing_42: 'Başarı oranları',
  ux_testing_43: 'Hata oranı',
  ux_testing_44: 'Görev tamamlama süresi',
  ux_testing_45: 'Kullanıcı temelli UX testi',
  ux_testing_46: 'Nicel yöntem',
  ux_testing_47:
    'Bu aşamada UX testine katılım için en az 100 kişi kullanıyoruz',
  ux_testing_48:
    'Web sitenizin veya uygulamanızın karşılaştırmasına ihtiyaç duyduğunuzda geçerlidir:',
  ux_testing_49: 'Nicel yöntem ölçümü:',
  ux_testing_50: 'Gözlem',
  ux_testing_51:
    'Bir kullanıcı veya kullanıcı grubu ile zaman geçirmek ve ürünü günlük yaşamlarında kullanırken davranışlarını gözlemlemek',
  ux_testing_52: 'Derinlemesine görüşme',
  ux_testing_53:
    'Siteye gelen kullanıcıların tutumlarını, inançlarını, isteklerini ve deneyimlerini öğrenmenizi sağlar. 15–20 görüşme yapılmasını öneriyoruz',
  ux_testing_54: 'Etnografik araştırma',
  ux_testing_55:
    'Katılımcıların ürünü kullandıkları ortamda gerçekleştirilir. Gözlem yoluyla, kullanıcının psikolojisini ve karşılaştığı duygusal zorlukları iyi şekilde anlamaya başlarsınız.',
  ux_testing_56: 'Kullanıcı temelli UX testi',
  ux_testing_57: 'Nitel yöntem',
  ux_testing_58:
    'Bu yöntem, kullanıcı davranışlarının motivasyonunu ve mantığını anlamaya yardımcı olur',
  ux_testing_59: 'Kullanıyoruz:',
  ux_testing_60:
    'Araştırma sonuçlarımızı görselleştirmek için bir müşteri yolculuğu haritası geliştiriyoruz',
  ux_testing_61: '30 katılımcı (erkek/kadın)',
  ux_testing_62: 'Katılımcıların ön elemesini yapar ve anketlere davet ederiz',
  ux_testing_63: 'Wantent platformunda uzaktan çevrim içi görüşmeler',
  ux_testing_64: 'Yapay zekâ + insan temelli',
  ux_testing_65: 'Yapay zekâ + insan temelli UX testi',
  ux_testing_66:
    'Wantent’in benzersiz yapay zekâ teknolojisi ile gerçek kullanıcıların birleşimi',
  ux_testing_67: 'Başlıktaki büyük yazı tipi dikkat çekti',
  ux_testing_68:
    "Kullanıcılar 'yüksek sesle konuşan' rakamlara bakıyor ancak yanlarındaki bilgileri okumuyor",
  ux_testing_69:
    'UX testi, insanların ürününüz, uygulamanız veya web sitenizle nasıl etkileşim kurduğunu anlamanıza yardımcı olur',
  ux_testing_70: 'Yapay zekâ + insan temelli test araştırma tasarımı',
  ux_testing_71: 'Nasıl çalışır',
  ux_testing_72:
    'Wantent, yapay zekâ tabanlı bir içerik-pazar uyumu çözümüdür.',
  ux_testing_73:
    'Wantent, hedef kitlenin duygusal tepkilerini ve etkileşimini analiz etmek için ML teknolojilerini uygulayarak web siteleri ve uygulamaların verimliliğini değerlendirir.',
  ux_testing_74:
    'Sonuçları yorumlamak için performans ve büyümeyi destekleyen hikâye anlatımı teknikleri, çeşitlilik ve empati kullanıyoruz.',
  ux_testing_75:
    'Kullanıcının bölümler arasındaki geçişler sırasında dikkat ve duyguları',
  ux_testing_76:
    'Katılımcı gruplarına göre istatistikler (oturum boyunca dikkat ve odaklanma)',
  ux_testing_77: 'Sayfa dönüşümlerinin analizi',
  ux_testing_78: 'Görevleri yerine getirirken dikkat ve duygular',
  ux_testing_79: 'Algıya ilişkin bulgular',
  ux_testing_80:
    'farklı katılımcı grupları tarafından web sitesinin algılanışı',
  ux_testing_81: 'Kullanım kolaylığı analizi',
  ux_testing_82: 'sayfalar arasında gezinme ve önemli öğeleri bulma kolaylığı',
  ux_testing_83: 'Algı analizi',
  ux_testing_84: 'web sitesinde sunulan bilgilere ilişkin',
  ux_testing_85: 'Tanımlama alanları',
  ux_testing_86:
    'tek tek sayfalar içinde iyileştirme alanları (navigasyon, bilgi blokları vb.)',
  ux_testing_87: 'Detaylı olarak analiz ederiz',
  ux_testing_88: 'Araştırmanın temel sonuçları',
  ux_testing_89:
    'Web sitesinin ve tek tek sayfaların yapısını iyileştirmeye yönelik öneriler',
  ux_testing_90:
    'Kullanılabilirlik Testi için hedef kitleyi dikkatle seçiyoruz.',
  ux_testing_91:
    'Araştırmaları farklı ülkelerde, farklı dillerde ve farklı kullanıcı grupları arasında yürütüyoruz',
  ux_testing_92: 'Uygulamalarda test yapabiliriz',
  ux_testing_93:
    've rakiplerin web sitelerinde test ederek karşılaştırmalı analiz sunabiliriz',
  ux_testing_94: 'Farklı araştırma yöntemlerini birleştiriyoruz.',
  ux_testing_95:
    'Nitelikli kolaylaştırıcılarımız katılımcıyı test süreci boyunca yönlendirir.',
  ux_testing_96: 'Testler gerçekleştiriyoruz',
  ux_testing_97: 'çeşitli cihazlar ve yazılım sürümleri üzerinde',
  ux_testing_98: 'Neden bizi seçmelisiniz?',
  wantent_1: '4Service x',
  wantent_2: 'Wantent',
  wantent_3:
    '4Service ve Wantent © iş birliğinden doğan benzersiz bir ortak proje. İçerik analizi için yapay zekâ ve insan temelli yaklaşımın birleşimi',
  wantent_4: 'içerik yayına girmeden önce başarıyı ölçme',
  wantent_5: 'çeşitlilikle ilgili riskleri azaltma',
  wantent_6: 'içeriği iyileştirmek için derin içgörüler ve öneriler',
  wantent_7: 'içerik ve pazarlama stratejisi için objektif kararlar',
  wantent_8: 'Wantent, yapay zekâ tabanlı bir içerik-pazar uyumu çözümüdür.',
  wantent_9:
    'Wantent, içeriği pazarla eşleştirmeye yönelik yapay zekâ tabanlı bir çözümdür. ML teknolojilerini kullanarak duygusal tepkileri ve izleyici etkileşimini analiz eder ve video içeriğin etkinliğini değerlendirir.',
  wantent_10:
    'Wantent, içerik-pazar uyumunu tanımlamaya ve içerik verimliliğini en üst düzeye çıkarmaya yardımcı olur:',
  wantent_11: 'Senaryo kurulumu ve katılımcı temini',
  wantent_12: 'kişiselleştirilmiş proje tasarımı ve dünya çapında hedef kitle',
  wantent_13: 'İzleyici tepkilerinin toplanması',
  wantent_14: 'hedef kitleden ayrıntılı ve net geri bildirim',
  wantent_15: 'İçerik algısının analizi',
  wantent_16: 'yapay zekâ ile davranış ve duygusal tepki analizi',
  wantent_17: 'Son değerlendirme için içgörülerin sunulması',
  wantent_18: 'iyileştirme önerileri',
  wantent_19: 'Wantent, içerik verimliliğinizi en üst düzeye çıkarır',
  wantent_20: 'Reklam konsepti ön testleri',
  wantent_21: 'Yaratıcı konsept testleri',
  wantent_22:
    'Gelecekteki yaratıcılığın geliştirilen stratejiyle tutarlılığını kontrol etmek ve hedef kitlenin tepkilerini anlayarak yaratıcı konseptler/mesajlar için olası uyarlamalar yapmak',
  wantent_23: 'Marka öğelerinin görünürlük testi (post-prodüksiyon)',
  wantent_24: 'Reklam/sponsorluk yatırımının etkinliğinin doğrulanması',
  wantent_25: 'Reklam testleri',
  wantent_26: 'A/B testleri',
  wantent_27:
    'Üretim aşamasında yaratıcı çalışmaların etkinliğini karşılaştırmak ve etkileşim ile dikkati artırmak',
  wantent_28: 'Yayına alınmış reklam testleri',
  wantent_29:
    'Mesajların performansını tanımlama ve ses ile görselleri iyileştirmeye yönelik öneriler oluşturma',
  wantent_30: 'TV için çözümler',
  wantent_31:
    'Pilot bölümler, tanıtımlar, yeni formatlar, TV sunucuları testleri',
  wantent_32:
    'En ilgi çekici olanı belirlemek ve onu güçlendirmek için karşılaştırmalı analiz yapılması',
  wantent_33: 'TV programı ve uzun metrajlı film testleri',
  wantent_34:
    'Uzun içerik izlenirken izleyici katılımını, dikkat seviyesini ve duygusal tepkileri doğal koşullarda analiz etme. Video kurgusunu değerlendirmek ve iyileştirmek için izleyici düşüş noktalarını ve dikkat dağınıklığı anlarını otomatik olarak tespit ederiz',
  wantent_35: 'UI/UX testleri',
  wantent_36: 'Web sitesi prototipleri ve mobil uygulama testleri',
  wantent_37:
    'Wantent teknolojisi kullanılarak kullanıcı tepkileri ve duygularının analizi:',
  wantent_38: 'dikkat seviyesi',
  wantent_39: 'duygusal tepkiler',
  wantent_40: 'katılımcıların bakış yönüne ait ısı haritaları',
  wantent_41:
    'Katılımcı geri bildirimlerine dayalı web sitesi ve uygulama kullanılabilirlik analizi:',
  wantent_42: 'Sistem Kullanılabilirlik Ölçeği (SUS)',
  wantent_43: 'Müşteri Çaba Skoru (Etkileşim Kolaylığı)',
  wantent_44: 'Net Tavsiye Skoru (NPS)',
  wantent_45: 'GDPR uyumluluğu ve kullanıcı gizliliği',
  wantent_46:
    'Wantent, GDPR ve CCPA politikalarına tamamen uygundur ve katılımcıların kişisel verilerinin toplanması, saklanması, işlenmesi ve korunması ilkelerine uyar',
  wantent_47: 'Nikita Lobyntsev',
  wantent_48: 'CDO, Reface (Medya ve Eğlence)',
  wantent_49:
    'Her gün makine öğrenimi teknolojileriyle çok sayıda yeni içerik fikrini deniyoruz. Wantent, riskleri ve avantajları anlamamıza ve değerlendirmemize, kullanıcı geri bildirimlerini, davranışlarını ve algılarını keşfetmemize yardımcı olarak çözümlerimizin farklı yönleri arasındaki nedenselliği ortaya koymamızı sağlıyor.',
  wantent_50: 'Alexander Smirnov',
  wantent_51: 'Ortak sahibi TABASCO (Reklamcılık)',
  wantent_52:
    'Wantent, tüketicilerin neyi sevip neyi sevmediğine dair çok küçük detayları bile anlamamıza yardımcı olan gerçekten benzersiz bir hizmet sunuyor. Hile yapmak mümkün değil, yalan söylemek mümkün değil — Wantent her zaman gerçeği biliyor ve böylece biz pazarlama uzmanları olarak iletişimimizi nasıl geliştireceğimize dair paha biçilemez (hahaha — tam fiyatını biliyoruz ve uygun) rehberlik alıyoruz.',
  wantent_53: 'Yorumlar',
  terms_1: 'Şartlar ve koşullar',
  terms_2: 'Kullanım Şartları Sözleşmesi',
  terms_3:
    'Lütfen web sitesini kullanmadan önce bu Kullanım Şartları Sözleşmesini (“kullanım şartları”, “sözleşme”) dikkatlice okuyunuz',
  terms_4:
    '(“web sitesi”), 4Service Holdings GmbH (“4Service”, “biz”, “bize”, “bizim”) tarafından işletilmektedir.',
  terms_5:
    'Kullanım koşullarıBu web sitesini kullanarak, bu Sözleşmeyi okuduğunuzu ve incelediğinizi ve şartlarına uymayı kabul ettiğinizi beyan edersiniz. Bu Sözleşmenin şartlarına bağlı olmak istemiyorsanız, web sitesinden ayrılmanız tavsiye edilir. 4Service, yalnızca şartlarını kabul eden kişilere bu web sitesini, ürünlerini ve hizmetlerini kullanma ve erişim izni verir.',
  terms_6: 'Gizlilik Politikası',
  terms_7:
    'Web sitemizi kullanmaya devam etmeden önce, kullanıcı verilerinin toplanmasına ilişkin Gizlilik Politikamızı okumanızı tavsiye ederiz. Bu, uygulamalarımızı daha iyi anlamanıza yardımcı olacaktır.',
  terms_8: 'Yaş sınırlaması',
  terms_9:
    'Bu web sitesini kullanabilmek için en az 16 (on altı) yaşında olmanız gerekir. Bu web sitesini kullanarak, en az 16 (on altı) yaşında olduğunuzu ve bu Sözleşmeye yasal olarak uyabileceğinizi garanti edersiniz. 4Service, yaşın yanlış beyan edilmesinden kaynaklanan sorumlulukları kabul etmez.',
  terms_10: 'Fikri mülkiyet',
  terms_11:
    'Bu web sitesinde sağlanan tüm materyallerin, ürünlerin ve hizmetlerin telif hakları, ticari sırlar, ticari markalar, patentler ve diğer fikri mülkiyetler dahil olmak üzere 4Service’e veya bağlı kuruluşlarına, yöneticilerine, çalışanlarına, temsilcilerine, tedarikçilerine ya da lisans verenlerine ait olduğunu kabul edersiniz. Ayrıca, 4Service’in fikri mülkiyetini elektronik, dijital veya yeni ticari marka tescilleri dahil olmak üzere hiçbir şekilde çoğaltmayacağınızı veya yeniden dağıtmayacağınızı kabul edersiniz.',
  terms_12: 'Web sitemize erişim',
  terms_13:
    'Sitemize erişim geçici olarak sağlanmaktadır ve sitemizde sunduğumuz hizmeti önceden bildirimde bulunmaksızın geri çekme veya değiştirme hakkını saklı tutarız. Herhangi bir nedenle sitemizin herhangi bir zamanda veya herhangi bir süre boyunca kullanılamamasından sorumlu olmayacağız. Zaman zaman, sitemizin bazı bölümlerine veya tamamına, bizimle kayıtlı kullanıcıların erişimini kısıtlayabiliriz. Sitemize erişiminiz için gerekli tüm düzenlemeleri yapmak, uyumlu ekipman kullanımı dahil olmak üzere sizin sorumluluğunuzdadır. Ayrıca, internet bağlantınız üzerinden sitemize erişen tüm kişilerin bu şartlardan haberdar olmasını ve bunlara uymasını sağlamak da sizin sorumluluğunuzdadır.',
  terms_14: 'Uygulanabilir hukuk',
  terms_15:
    'Bu web sitesini ziyaret ederek, Avusturya Cumhuriyeti yasalarının, kanunlar ihtilafı ilkeleri dikkate alınmaksızın, bu şart ve koşulları veya 4Service ile aranızda doğabilecek her türlü uyuşmazlığı yöneteceğini kabul edersiniz.',
  terms_16: 'Uyuşmazlıklar',
  terms_17:
    'Bu web sitesini ziyaretinizle herhangi bir şekilde ilgili olan tüm uyuşmazlıklar Viyana Ticaret Mahkemesi tarafından tahkim yoluyla çözülecektir.',
  terms_18: 'Tazminat',
  terms_19:
    'Web sitemizi kullanımınızdan veya kötüye kullanımınızdan doğabilecek hukuki talep ve taleplere karşı 4Service’i ve bağlı kuruluşlarını tazmin etmeyi ve zararsız tutmayı kabul edersiniz. Kendi hukuk danışmanımızı seçme hakkını saklı tutarız.',
  terms_20: 'Saklama süresi',
  terms_21:
    'İşleme amaçları dikkate alındığında, Kullanıcıların kişisel verilerinin saklama süresi (saklama süresi), veri işleme onayının usulüne uygun olarak Sizden alındığı tarihten itibaren 24 aydır.',
  terms_22: 'Sorumluluğun sınırlandırılması',
  terms_23:
    '4Service, web sitemizin kötüye kullanımı sonucunda size gelebilecek herhangi bir zarardan sorumlu değildir. 4Service, bu Sözleşmeyi herhangi bir zamanda bildirimde bulunmaksızın düzenleme, değiştirme ve güncelleme hakkını saklı tutar. Web sitesini kullanmaya devam etmeniz, bu değişiklikleri kabul ettiğiniz anlamına gelir. Bu Sözleşmenin herhangi bir bölümünün hukuka aykırı, geçersiz veya uygulanamaz ilan edilmesi durumunda, söz konusu bölüm ayrılabilir sayılacak ve kalan hükümlerin geçerliliğini etkilemeyecektir. Web sitesinin yasa dışı amaçlarla kullanıldığına dair olası kanıtlar kolluk kuvvetlerine iletilecektir. Bu Sözleşme, 4Service ile kullanıcı arasındaki mutabakatı ifade eder.',
  terms_24:
    'Gizlilik/kullanım ile ilgili tüm soru ve endişelerinizi aşağıdaki adrese yönlendiriniz:',
  terms_25: '4Service Holdings GmbH',
  terms_26: 'Tegetthoffstrasse 7',
  terms_27: '1010 Viyana',
  terms_28: 'Avusturya',
  terms_29: 'İnceleme',
  terms_30:
    'Bize sağladığınız kişisel veriler doğru değilse, bunların düzeltilmesini talep etme hakkına sahipsiniz (GDPR Madde 16).',
  thank_you_1: 'Teşekkürler!',
  thank_you_2: '24 saat içinde size geri dönüş yapacağız',
  thank_you_3:
    'Not: Yöneticilerimiz daha iyi bir teklif hazırlamak için talebinizi şimdiden inceliyor',
  thank_you_4: 'Menü',
  thank_you_5: 'Yazı yazan kadın',
  privacy_policy_1:
    'Veri sahipleri (web sitesi kullanıcıları) için gizlilik bildirimi formu',
  privacy_policy_2:
    'Bu Gizlilik Bildirimi Formu (Gizlilik Bildirimi), 4Service Holdings GmbH tarafından kişisel verileri toplanan gerçek kişiler (Veri Sahipleri) için hazırlanmıştır ve web sitesini ziyaret etme çerçevesinde GDPR gerekliliklerine uygundur',
  privacy_policy_3:
    '(bundan sonra Web Sitesi ve Web Sitesi Kullanıcıları / Kullanıcılar olarak anılacaktır).',
  privacy_policy_4:
    '4Service Holdings GmbH Veri Sahipleri (Web Sitesi Kullanıcıları) için Gizlilik Bildirimi Formu, 4Service Holdings GmbH’nin denetimi altında olan veya kontrol ettiği 4Service Grubu’ndaki tüm şirketlerde uygulanır.',
  privacy_policy_5: 'İletişim',
  privacy_policy_6: '4Service Holdings GmbH',
  privacy_policy_7: '(Şirket/biz/bizim),',
  privacy_policy_8: 'Adres:',
  privacy_policy_9: 'Tegetthoffstraße 7, 1010 Viyana, Avusturya.',
  privacy_policy_10: 'E-posta:',
  privacy_policy_12: 'Biz kimiz?',
  privacy_policy_13:
    'Web Sitesini herhangi bir amaçla ziyaret eden birey (Siz). Bu belge kapsamında Siz ayrıca Kullanıcı olarak adlandırılacaksınız.',
  privacy_policy_14: 'Sizden topladığımız kişisel veriler',
  privacy_policy_15:
    'Web Sitemize giriş yaptığınızda, sizden aşağıdaki bilgilerin işlenmesi için onay vermenizi isteyen bir Gizlilik bildirimi göndeririz:',
  privacy_policy_16:
    'IP adresi, kullanıcı adı, soyadı, adres, telefon numarası (sabit veya mobil), e-posta adresi, adres, şirket adı, ülke, e-posta adresi, isim, soyisim, telefon numarası, il, eyalet ve posta/ZIP kodu, kullanım verileri, harici sosyal ağlar veya platformlarla etkileşim verileri, web sitesinde kayıt ve doğrulama bilgileri',
  privacy_policy_17: 'coğrafi konum.',
  privacy_policy_18:
    'Bu onayı verip iradenizi ifade ettiğiniz takdirde, bu bilgileri işlemeye başlarız.',
  privacy_policy_19: 'Hukuka uygunluk (onay)',
  privacy_policy_20:
    'Web Sitemize giriş yaptığınızda, sizden aşağıdaki bilgilerin işlenmesi için onay vermenizi isteyen bir Gizlilik bildirimi göndeririz:',
  privacy_policy_21:
    'Kişisel verilerin işlenmesinin yasal dayanağı, aşağıdaki bağlantıda yer alan onay formunu doldurarak Sizden alacağımız onaydır:',
  privacy_policy_22:
    'Onay formunu doldurmanız, bu Gizlilik Bildiriminde belirtilen tüm koşulları anladığınız ve kabul ettiğiniz anlamına gelir.',
  privacy_policy_23: 'Onayın geri çekilmesi',
  privacy_policy_24:
    'Daha önce verdiğiniz onayı her zaman geri çekme hakkına sahipsiniz. Onayın geri çekilmesi, geri çekilmeden önceki onay bazlı işlemlerin hukuka uygunluğunu etkilemez. Onayı withdraw@4service-group.com adresine uygun talebi göndererek geri çekebilirsiniz; talep formu aşağıdaki bağlantıda mevcuttur:',
  privacy_policy_25: 'Kullanıcı İçin Onay Geri Çekme Formu',
  privacy_policy_26: 'İşleme amaçları',
  privacy_policy_27: 'Kişisel verilerinizi aşağıdaki amaçlarla işleriz:',
  privacy_policy_28:
    '– Müşteri hizmetlerini geliştirmek (müşteri taleplerine daha etkili yanıt sağlamak); – Kullanıcı deneyimini kişiselleştirmek (hangi hizmetlerin daha ilgi çekici olduğunu belirlemek); – Siteyi geliştirmek (ürün ve hizmetlerin kalitesini, kullanım kolaylığını artırmak, yeni hizmetler geliştirmek); – Kullanıcı ile bültenler, pazarlama veya promosyon materyalleri ve hizmet bilgilerini içeren diğer bilgilerle iletişim kurmak; – Anonimleştirilmiş veriler üzerinden istatistiksel ve diğer analizleri yapmak; – Kullanıcıya kişiselleştirilmiş hizmetler sunmak ve sözleşmeleri yerine getirmek; – Kullanıcının sitedeki çeşitli projelere katılımını sağlamak, kullanıcı taleplerine yanıt vermek, hesap ve kayıt yönetimi yapmak ve hizmetleri tanıtmak.',
  privacy_policy_29: 'Kişisel verilerin aktarılabileceği taraflar',
  privacy_policy_30:
    'Kişisel verilerinizi işlerken, verilerinizi Şirketin işlemcisi olarak hareket eden varlıklara aktarırız. Şirketin işlemcileri yalnızca Şirketin talimatları doğrultusunda hareket eder. İşlemcilerin yaptığı eylemler ve listesi, Gizlilik ve Veri Koruma Politikasında bulunabilir: Gizlilik ve Veri Koruma Politikası',
  privacy_policy_31: 'Kişisel verilerin aktarılabileceği ülkeler',
  privacy_policy_32:
    'Şirket, kişisel verilerinizi GDPR ve AB Komisyonu tarafından belirlenen yeterlilik kararına dayanarak aktarır. ABD’ye veri aktarımıyla ilgili ek bilgiler Gizlilik ve Veri Koruma Politikasında bulunabilir: Gizlilik ve Veri Koruma Politikası.',
  privacy_policy_33: 'Saklama süresi',
  privacy_policy_34:
    'İşleme amaçları göz önünde bulundurularak, kullanıcıların kişisel verilerinin saklama süresi (saklama süresi), onay formu ile onayınızın alındığı tarihten itibaren 24 aydır.',
  privacy_policy_35: 'Erişim hakkı',
  privacy_policy_36:
    'Kişisel verilerinizin işlenip işlenmediğini bilme hakkına sahipsiniz ve eğer işleniyorsa GDPR Madde 15’te belirtilen ek koşullarla bu verilere erişebilirsiniz.',
  privacy_policy_37: 'Düzeltme hakkı',
  privacy_policy_38:
    'Tarafınızdan sağlanan kişisel veriler yanlışsa, bunların düzeltilmesini talep etme hakkınız vardır (GDPR Madde 16).',
  privacy_policy_39: 'Silme hakkı (unutulma hakkı)',
  privacy_policy_40:
    'Kişisel verilerinizin gereksiz gecikme olmadan silinmesini talep etme hakkına sahipsiniz ve GDPR Madde 17’de belirtilen durumlar uygulanıyorsa Şirket, kişisel verilerinizi gecikmeksizin silecektir.',
  privacy_policy_41: 'İşlemenin kısıtlanması hakkı',
  privacy_policy_42:
    'Kişisel verilerinizin işlenmesini GDPR kapsamında, özellikle Madde 18’de belirtilen istisnalar dahilinde sınırlama hakkınız vardır.',
  privacy_policy_43:
    'Hangi verilerin toplandığını, nasıl kullanıldığını, ne kadar süre saklanacağını ve üçüncü taraflarla paylaşılıp paylaşılmayacağını size bildirmekle yükümlüyüz. Bu bilgiler açık ve sade bir dille sunulmalıdır.',
  privacy_policy_44: 'Veri taşınabilirliği hakkı',
  privacy_policy_45:
    'Kişisel verilerinizi farklı hizmetler arasında kendi amaçlarınız için alabilir ve yeniden kullanabilirsiniz.',
  privacy_policy_46: 'İtiraz hakkı',
  privacy_policy_47:
    'Şirketin işlediği kişisel verilerin işlenmesine itiraz hakkına sahipsiniz. İşlemeyi durdurmak zorundayız, aksi takdirde işlemeyi haklı kılan güçlü yasal gerekçelerimiz olmalıdır.',
  privacy_policy_48: 'Otomatik işleme dayalı kararlara konu olmama hakkı',
  privacy_policy_49:
    'İzinsiz otomatik profillemeye itiraz etme hakkınız vardır. Kişisel verilerinizin insan müdahalesiyle işlenmesini talep edebilirsiniz.',
  privacy_policy_50: 'Şikayetler',
  privacy_policy_51:
    'Kişisel verilerinizin işlenmesi veya şikayetinizin ele alınması ile ilgili bir şikayette bulunmak isterseniz, denetleyici otoriteye ve Şirkete doğrudan başvurma hakkına sahipsiniz.',
  privacy_policy_52: 'Bu iletişimlerin detayları:',
  privacy_policy_53: 'Denetleyici otorite:',
  privacy_policy_54: 'Avusturya Veri Koruma Otoritesi',
  privacy_policy_55: 'Österreichische Datenschutzbehörde',
  privacy_policy_56: 'Wickenburggasse 8',
  privacy_policy_57: '1080 Viyana',
  privacy_policy_58: 'Avusturya / Avrupa',
  privacy_policy_59: 'Şirket:',
  privacy_policy_60: '4Service Holdings GmbH (Şirket/biz/bizim),',
  privacy_policy_61: 'Adres: Tegetthoffstraße 7, 1010 Viyana, Avusturya.',
  privacy_policy_62: 'E-posta:',
  privacy_policy_63: 'Gizlilik ve veri koruma politikası',
  privacy_policy_64:
    'Verilerinizi nasıl ve neden kullandığımızı burada okuyabilirsiniz: Gizlilik ve Veri Koruma Politikası',
  privacy_policy_65: 'Onay',
  privacy_policy_66:
    'Şirket, şirket içinde kişisel veri işleme ile ilgili personel rollerini belirlemek için tüm iç belgeleri geliştirmiştir; bu belgenin geçerliliğini onaylama ve gözden geçirme sorumluluğu özellikle Genel Müdüre aittir.',
  contacts_1: 'Müşteriler için',
  contacts_2:
    'Her tür işletme, pazar araştırma ajansları, büyük şirketler, iş ortakları ve medya için.',
  contacts_3: 'Tegetthoffstrasse 7, Viyana, Avusturya',
  contacts_4: 'Alışverişçiler için',
  contacts_5:
    'Yerel halk ve gezginler, sürücüler ve öğrenciler, profesyonel gizli müşteriler ve evde vakit geçirenler.',
  contacts_6: 'Ülkenizden bize ulaşın:',
  contacts_7: 'İtalya',
  contacts_8: 'ABD',
  contacts_9: 'Birleşik Krallık',
  contacts_10: 'İsviçre',
  contacts_11: 'Hollanda',
  contacts_12: 'Slovakya',
  contacts_13: 'Slovenya',
  contacts_14: 'Romanya',
  contacts_15: 'AZ',
  contacts_16: 'Ukrayna',
  contacts_17: 'Kazakistan',
  contacts_18: 'Dünyanın geri kalanı',
  menu_1: 'CJM',
  menu_2: 'NPS',
  menu_3: 'CSI',
  menu_4: 'BHT',
  menu_5: 'UX testleri',
  menu_6: 'İK araştırmaları',
  menu_7: 'Nitel araştırma',
  menu_8: 'Nicel araştırma',
  menu_9: 'Gizli müşteri',
  menu_10: 'Voicer',
  menu_11: 'Play4Sales',
  menu_12: 'Wantent',
  menu_13: 'Fiyat takibi',
  menu_14: 'Hakkımızda',
  menu_15: 'İletişim',
  menu_16: 'Blog',
  menu_17: 'Yöntemler',
  menu_18: 'Ürünler',
  menu_19: 'Alışverişçiler \n platformu',
  menu_20: 'CSR',
  menu_21: 'Otomotiv fiyat analizi',
  menu_22: 'Tesis Denetim Kontrolü',
  menu_23: 'Hizmet Tasarımı',
  menu_24: 'CX',
  nps_passives: 'Pasifler',
  nps_detractors: 'Eleştirenler',
  nps_promoters: 'Destekleyiciler',
  nps_a_score: 'puan',
  area: 'Alan',
  products_tabs_1:
    'Maksimum verimliliğe ulaşmak için ayrıca entegre şekilde şunları da gerçekleştiriyoruz:',
  products_tabs_2: 'Ürünler',
  products_tabs_3:
    'Nitel araştırma, kavramları, görüşleri veya deneyimleri anlamak için sayısal olmayan verilerin toplanması ve analiz edilmesidir',
  products_tabs_4:
    'Nicel araştırma yöntemleri, anketler, soru formları ve araştırmalar yoluyla toplanan verilerin nesnel ölçümü ve sayısal analizidir',
  our_clients_1: 'Müşterilerimiz',
  preview_cases_section_1: 'Vakalar',
  preview_cases_section_2: 'Daha ilginç içerikleri okumak için vakalara gidin',
  blog_1: 'Etkileyici içerik blogu',
  blog_2: 'Talebiniz için mevcut gönderi bulunmamaktadır',
  about: 'Hakkında',
  why_us: 'Neden biz',
  about_us: 'Hakkımızda',
  key_features: 'Temel özellikler',
  solutions: 'Çözümler',
  monitoring: 'İzleme',
  how: 'Nasıl',
  how_it_works: 'Nasıl çalışır',
  when_to_use: 'Ne zaman kullanılır',
  mystery_shopping: 'Gizli müşteri',
  voicer: 'Müşterinin sesi',
  wantent: 'Video içerik testi',
  play4sales: 'Play4Sales',
  price_monitoring: 'Fiyat izleme',
  service_design: 'Hizmet tasarımı',
  qualitative_research: 'Nitel araştırma',
  quantitative_research: 'Nicel araştırma',
  cawi: 'CAWI',
  f2f: 'F2F',
  cati: 'CATI',
  hashtag_automotive: '#Automotiv',
  hashtag_retayl: '#Perakende',
  hashtag_all_posts: '#Tüm_gönderiler',
  hashtag_feedback: '#geri_bildirim',
  hashtag_4Service_csr: '#4Service_CSR',
  hashtag_cases: '#Vakalar',
  hashtag_market_research: '#pazar_araştırması',
  more: 'Daha fazla',
  speak_to_an_expert: 'Bir uzmana danışın',
  book_consultancy: 'Danışmanlık randevusu alın',
  read_all: 'Tümünü oku',
  find_out_more: 'Daha fazlasını keşfet',
  address: 'Adres',
  mon_fri: 'Pzt-Cum',
  phone_number: 'Telefon numarası',
  flag: 'bayrak',
  scroll_to_left: 'sola kaydır',
  online: 'çevrimiçi',
  tel: 'Tel',
  email: 'E-posta',
  light_it_up: 'Parlat',
  about_us_60: 'Alina Andreieva',
  about_us_61: 'İş geliştirme direktörü',
  about_us_62: 'Julia Kravchenko',
  about_us_63: 'Kıdemli proje yöneticisi',
  about_us_64: 'Olga Aksonova',
  about_us_65: 'İş Geliştirme Müdürü',
  about_us_66: 'Zhelevskiy Dmitriy',
  about_us_67: 'Operasyon Direktörü',
  about_us_roles_1: 'Yönetim',
  about_us_roles_2: 'Küresel ekip',
  about_us_roles_3: 'Ürün sahipleri',
  ad_testing_1: 'Reklam Testi',
  ad_testing_2:
    'Bir reklam kampanyası büyük bir yatırımdır. Reklamlarınızın güçlü olduğundan ve maksimum yatırım getirisi sağladığından emin olun',
  ad_testing_3: 'kilit',
  ad_testing_4: 'Hizmet verdiğimiz sektörler',
  ad_testing_5: '4Service küresel bir müşteri deneyimi araştırma holdingidir',
  ad_testing_6:
    '4Service küresel bir pazarlama araştırması ve CX holdingidir. Çok çeşitli işletmelere uzman veri toplama hizmetleri sunuyoruz',
  ad_testing_7: 'Cash & Carry',
  ad_testing_8: 'Perakende',
  ad_testing_9: 'Elektronik',
  ad_testing_10: 'Lüks/Premium',
  ad_testing_11: 'Yeme-İçme ve Konaklama',
  ad_testing_12: 'Otomotiv',
  ad_testing_13: 'Seyahat ve Eğlence',
  ad_testing_14: 'Moda',
  ad_testing_15: 'Bankalar',
  ad_testing_16: 'Saat ve Mücevher',
  ad_testing_17: 'Ev ve Beyaz Eşya',
  ad_testing_18: 'Esomar üyesi',
  ad_testing_19:
    'Farklı alanlardaki çeşitli işletmeler için reklamlar üzerinde Reklam Testi araştırmaları gerçekleştirdik',
  ad_testing_20: 'Aşağıdaki durumlarda Reklam Testine ihtiyacınız vardır',
  ad_testing_21: 'Yeni bir ürün veya hizmeti tanıtıyorsanız',
  ad_testing_22: 'Hassas bir konuya değiniyorsanız',
  ad_testing_23:
    'Yeni bir hedef demografiye veya pazara ulaşmaya çalışıyorsanız',
  ad_testing_24: 'Birden fazla farklı tasarım seçeneğini tartışıyorsanız',
  ad_testing_25:
    'Yönetim ekipleri veya yatırımcılar için bir kavram kanıtına ihtiyacınız varsa',
  ad_testing_26: 'Şu soruların yanıtlarını alacaksınız',
  ad_testing_27: 'Bu reklamlar için hangi reklam kanalları en uygundur?',
  ad_testing_28: 'Mesajı iletmek için doğru görselleri kullanıyor muyuz?',
  ad_testing_29: 'Reklam metinleriniz ve mesajlarınız yankı uyandırıyor mu?',
  ad_testing_30: 'Bu reklamlar için hangi reklam kanalları en uygundur?',
  ad_testing_31: 'İlk etapta dikkatlerini ne çekiyor?',
  ad_testing_32: 'Reklamın yerleşimi ve düzeni kolay anlaşılır mı?',
  ad_testing_33: 'Değerlendiriyoruz',
  ad_testing_34: 'Markalaşma',
  ad_testing_35:
    'markanızın reklamla nasıl ilişkilendirildiğini ve ne kadar hatırlanacağını',
  ad_testing_36: 'Temel metrikler',
  ad_testing_37: 'Entegrasyon',
  ad_testing_38: 'Tanınırlık',
  ad_testing_39: 'Uyum',
  ad_testing_40: 'Yaratıcılık',
  ad_testing_41:
    'Reklamınızın nasıl öne çıktığı ve insanların dikkatini nasıl çektiği',
  ad_testing_42: 'Temel metrikler',
  ad_testing_43: 'TANINIRLIK',
  ad_testing_44: 'BEĞENİ',
  ad_testing_45: 'MTO',
  ad_testing_46: 'MOTİVASYON',
  ad_testing_47: 'Müşteri deneyimi, duygusal etkileşim',
  ad_testing_48:
    'Yapay zekâ teknolojisi ve uzman analistlerin yardımıyla insanların gerçek duygularını analiz ediyor ve reklam algılarına dair içgörüler elde ediyoruz',
  ad_testing_49: 'Derecelendirme',
  ad_testing_50: 'Erkek',
  ad_testing_51: 'Kadın',
  ad_testing_52: 'Yüksek etkileşim',
  ad_testing_53: 'Dikkat',
  ad_testing_54: 'İzleyiciler neyi beğendi ve hatırladı?',
  ad_testing_55: 'Kadın oyuncu',
  ad_testing_56: 'Eşitlik',
  ad_testing_57: 'Müzikal arka plan',
  ad_testing_58: 'Olumlu duygular',
  ad_testing_59: 'Farklı ırklardan ve görünümlerden insanlar',
  ad_testing_60: 'Dış mekân çekimleri',
  ad_testing_61: 'İzleyiciler neyi beğenmedi ve hatırlamadı?',
  ad_testing_62: 'Konuşmacının sesi ekranda olanlarla örtüşmüyordu',
  ad_testing_63: 'Ürüne düşük dikkat',
  ad_testing_64: 'Çok dinamik',
  ad_testing_65: 'Anlaması zor',
  ad_testing_66: 'TRP',
  ad_testing_67: 'Gösterimler',
  ad_testing_68: 'Yayınlar',
  ad_testing_69: 'Dönüşüm',
  ad_testing_70: 'Medya',
  ad_testing_71:
    'Reklam kampanyasının etkinliğini medya faaliyetleriyle birlikte ölçüyor, farklı kanallardaki medya yatırımlarının izlenen sonuçlar üzerindeki etkisini hesaplıyoruz.',
  ad_testing_72:
    'Her formatta, platformda veya kanalda reklam araştırması yürütüyoruz',
  ad_testing_73: 'video içerik',
  ad_testing_74: 'açık hava',
  ad_testing_75: 'TV reklamları',
  ad_testing_76: 'basılı',
  ad_testing_77: 'dijital',
  ad_testing_78: 'reklam kampanyaları',
  ad_testing_79: 'POS teşhir ve reklam',
  ad_testing_80: 'animatikler',
  ad_testing_81: 'Bizimle reklamınızı her aşamada test edebilirsiniz',
  ad_testing_82: 'Kavram',
  ad_testing_83: 'hangi fikirler daha güçlü bir potansiyele sahip?',
  ad_testing_84: 'Erken üretim aşaması',
  ad_testing_85: 'hangi animatikler üretime girecek?',
  ad_testing_86: 'Üretim',
  ad_testing_87: 'dikkati koruyacak şekilde bir video nasıl düzenlenmeli?',
  ad_testing_88: 'Medya öncesi',
  ad_testing_89:
    'hangi iletişim kanalları işe yarayacak ve ne tür sonuçlar beklenebilir?',
  ad_testing_90: 'Reklam Sonrası Test',
  ad_testing_91: 'Üretim',
  ad_testing_92:
    'reklamım ilgi çekici mi? Yaratıcılığın etkinliği zamanla azalıyor mu?',
  ad_testing_93: 'Medya öncesi',
  ad_testing_94:
    'reklamım sayısal olarak ne kadar etkili? Rakiplerle nasıl karşılaştırılıyor?',
  ad_testing_95: 'Reklam Ön Testi',
  ad_testing_96: 'Size yüksek kaliteli veri sunmak için şunları kullanıyoruz',
  ad_testing_97: 'Nicel araştırma metodolojisi',
  ad_testing_98: 'CAWI',
  ad_testing_99: 'Nitel araştırma metodolojisi',
  ad_testing_100: 'Odak grupları',
  ad_testing_101: 'Yapay zekâ',
  ad_testing_102: 'Wantent',
  ad_testing_103: 'Alacağınız analitik raporlar',
  ad_testing_104:
    'Analistlerimiz, medya uzmanlarımız ve pazarlamacılarımız size detaylı öneriler içeren özel bir rapor hazırlayıp sunacaktır',
  ad_testing_age: 'yaş',
  ad_testing_ad: 'Reklam',
  automotive_industry_price_analysis_1: 'Otomotiv Endüstrisi Fiyat Analizi',
  automotive_industry_price_analysis_2:
    'Rekabetçi fiyat analizi, kayıp karları önlemeye, pazar payını artırmaya ve pazar konumunuzu izlemeye yardımcı olabilir. Başarılı bir rekabet stratejisi seçmenizde size yardımcı olalım!',
  automotive_industry_price_analysis_3: 'Teklif isteyin',
  automotive_industry_price_analysis_4: 'Metodolojimiz',
  automotive_industry_price_analysis_5: 'Şık, zarif insanlar araba salonu',
  automotive_industry_price_analysis_6:
    'Gizemli Alışveriş yöntemi, gerçek müşteri deneyimini doğru şekilde yansıtan ve güvenilir bir genel bakış sunan tek yaklaşımdır.',
  automotive_industry_price_analysis_7:
    'Kesin rakamlar ve güvenilir çok yönlü veriler sunuyoruz',
  automotive_industry_price_analysis_8:
    'Dünya genelinde her ülkeyi kapsayan küresel erişimimiz var',
  automotive_industry_price_analysis_9:
    'İç kaynaklarımız arasında gizemli alışveriş yapanlar ve denetçiler bulunmaktadır',
  automotive_industry_price_analysis_10: 'Veri kalitemizi doğruluyoruz',
  automotive_industry_price_analysis_11: 'Avantajlarımız:',
  automotive_industry_price_analysis_12:
    'Belirli rekabetçi modeller için fiyat takibi (B2B ve B2C)',
  automotive_industry_price_analysis_13: 'İndirim seviyesinin izlenmesi',
  automotive_industry_price_analysis_14:
    'Markanız ve rakipleriniz için perakendeci stokunun izlenmesi',
  automotive_industry_price_analysis_15:
    'E-ticaret otomotiv fiyatlarının izlenmesi',
  automotive_industry_price_analysis_16: 'Fiyat iletişimi analizi',
  automotive_industry_price_analysis_17:
    'Perakendeci gönderim ücretlerinin takibi',
  automotive_industry_price_analysis_18:
    'Perakendecilerdeki promosyon ve satışların izlenmesi',
  automotive_industry_price_analysis_19:
    'Aylık ödeme miktarlarının belirlenmesi',
  automotive_industry_price_analysis_20: 'Kira ödemelerinin hesaplanması',
  automotive_industry_price_analysis_21:
    'Elektrikli araçlar (EV) için özel fiyatlandırma hususlarının analizi',
  automotive_industry_price_analysis_22:
    'Doğrudan tüketici ile perakendeci fiyat karşılaştırmalarının yapılması',
  automotive_industry_price_analysis_23:
    'Abonelik fiyatlandırma modellerinin geliştirilmesi',
  automotive_industry_price_analysis_24:
    '4Service, 20 yılı aşkın deneyime sahip küresel bir müşteri deneyimi (CX) holding şirketidir',
  automotive_industry_price_analysis_25:
    'Hedef müşterileriniz için en önemli özellikleri belirlemek ve teklifinizi optimize etmek için farklı özellikler için tüketicilerin ödeme istekliliğine dair verileri kullanacaksınız.',
  automotive_industry_price_analysis_26:
    "4Service'in otomotiv endüstrisi fiyat analizi şunları içerir:",
  automotive_industry_price_analysis_27:
    'En düşük fiyatlar her zaman otomobil markaları için rekabetin anahtarı değildir. Size uzun vadeli bir fiyatlandırma stratejisi oluşturmanızda yardımcı olalım',
  automotive_industry_price_analysis_28:
    'müşterilerin tüm markalarda fiyatların arttığını anlaması',
  automotive_industry_price_analysis_29: '29',
  automotive_industry_price_analysis_30:
    'müşterilerin, marka kendilerine yaklaşan bir fiyat artışını bildirse bile, sevdikleri bir arabayı yine de satın alacaklarını belirtmesi',
  automotive_industry_price_analysis_31: '31',
  automotive_industry_price_analysis_32:
    'insanların, leasing ve aylık ödemeleri araba satın almak için en tercih edilen model olarak görmesi',
  automotive_industry_price_analysis_33: '48',
  automotive_industry_price_analysis_34:
    'bayilerin iletişim/satış sürecinde fiyat artışı olasılığını belirtmesi',
  automotive_industry_price_analysis_35: '47.6',
  automotive_industry_price_analysis_36: 'Temel rakamlar',
  automotive_industry_price_analysis_37:
    'Ürününüzü diğer araçlarla kıyaslayarak nasıl fiyatlandıracağınızı öğreneceksiniz.',
  automotive_industry_price_analysis_38:
    'Hedef müşterileriniz için en önemli özellikleri belirlemek ve teklifinizi optimize etmek için farklı özellikler için tüketicilerin ödeme istekliliğine dair verileri kullanacaksınız.',
  automotive_industry_price_analysis_39:
    'müşterilerin, marka kendilerine yaklaşan bir fiyat artışını bildirse bile, sevdikleri bir arabayı yine de satın alacaklarını belirtmesi',
  automotive_industry_price_analysis_40:
    'Uygun aylık ödeme ve leasing oranlarını belirleyebileceksiniz.',
  automotive_industry_price_analysis_41:
    'Markanız veya bayiiniz için elde edeceğiniz faydalar:',
  automotive_industry_price_analysis_42: 'Başvuru gönderirsiniz',
  automotive_industry_price_analysis_43:
    'Yöneticimiz, ana hedefleri belirlemek için sizinle iletişime geçer',
  automotive_industry_price_analysis_44: 'Pazar araştırması yapıyoruz',
  automotive_industry_price_analysis_45:
    'Size düzenli olarak çevrimiçi formatta raporlar ve öneriler sunuyoruz',
  automotive_industry_price_analysis_46: 'Satış etiketi olan araba',
  automotive_industry_price_analysis_47: 'Projeyi 1 gün içinde başlatıyoruz!',
  automotive_industry_price_analysis_48:
    'Fotoğraf raporları, PPT raporları ve Excel raporlarını içeren kapsamlı bir rapor seti sunuyoruz; yerleşim tipine göre segmentlenmiş',
  retail_audit_1: 'SAHA PAZARLAMA DENETİMİ/perakende denetimi',
  retail_audit_2:
    'Mağazanız veya markanız hakkında detaylı veri toplayın, büyüme engellerini analiz edin ve bunları aşmak için etkili stratejiler oluşturun',
  retail_audit_3: 'Teklif isteyin',
  retail_audit_4:
    '4Service, markalar adına mağaza denetimleri gerçekleştirir; promosyon stratejilerinin etkinliğini, saha uygulama ekiplerini ve pazarlama taktiklerini hedef pazara ulaşmada değerlendirir.',
  retail_audit_5:
    'Promosyon kampanyalarının yürütülmesini titizlikle gözlemler ve promosyon yönergelerine uyumu sağlar.',
  retail_audit_6: 'İlk 10',
  retail_audit_7: 'Avrupa’daki CX ajansları',
  retail_audit_8: 'yıllık deneyim',
  retail_audit_9: 'ülke kapsama alanı',
  retail_audit_10: '1,6 milyon',
  retail_audit_11: 'yıllık değerlendirme',
  retail_audit_12: 'Neleri takip ediyoruz?',
  retail_audit_13: 'Satış noktası (POS) materyallerinin varlığı',
  retail_audit_14:
    'Marka elçileri ve planlanan takvime uyum sağlanmasının varlığı ve aktivasyonu',
  retail_audit_15:
    'Savunuculuk kampanyalarındaki marka elçilerinin katılımının değerlendirilmesi',
  retail_audit_16:
    'Tüketici etkileşiminin değerlendirilmesi, promosyon yönergelerine ve marka mesajına uyum sağlanması',
  retail_audit_17: 'Dolandırıcılığı önleme önlemleri',
  retail_audit_18:
    'İşletmeniz, saha pazarlama denetimi sonuçlarını şu amaçlarla kullanabilir:',
  retail_audit_19: 'Bütçe ve süreç uyumunu değerlendirmek',
  retail_audit_20: 'Gerçek sonuçları planlanan hedeflerle karşılaştırmak',
  retail_audit_21: 'Pazarlama kampanyalarının performansını artırmak',
  retail_audit_22: 'Gelecek için stratejik plan yapmak',
  retail_audit_23: 'Maliyet azaltma fırsatlarını belirlemek',
  retail_audit_24: 'Satış ve dönüşüm oranlarını iyileştirmek',
  retail_audit_25: 'Yatırım getirisini (ROI) optimize etmek',
  retail_audit_26: '4SERVICE’İ TİCARET YATIRIM ORTAĞI OLARAK SEÇTİLER',
  retail_audit_27:
    'Önde gelen uluslararası bir tütün ürünü üreticisi, markalarını geliştirmek ve mağaza içi performansını artırmak için 4Service ile işbirliği yaptı. Ekiplerimiz saha pazarlama denetimi ve tüketici deneyimi canlı raporlama sağladı.',
  retail_audit_28: 'Saha pazarlama ajansının planlama doğruluğunda artış',
  retail_audit_29: 'Marka mesajı iletimi artışı',
  retail_audit_30: 'BA katılımı artışı (tüketici aktivasyonu)',
  retail_audit_31: 'Veri toplama doğruluğu ve GDPR uyumluluğunda artış',
  retail_audit_32: 'Hangi değerli içgörüler bulunuyor:',
  retail_audit_33:
    'SLA koşulları arasında tutarsızlık veya çelişki, müşteriye önemli onaylanmamış ücretlerin uygulanmasına yol açar',
  retail_audit_34:
    'Verilen hizmet türlerinin karışıklığından kaynaklanan yanlış ücretlendirme',
  retail_audit_35:
    'Saha hizmetinin yerine getirilmemesi, personelin planlanan konum | POS’a atanamaması',
  retail_audit_36:
    'Tahmine dayalı ve gerçek olmayan, uzlaştırılmamış ücretlendirme',
  retail_audit_37:
    'Yanıltıcı veriler sağlayan promosyon yönergesinin yanlış uygulanması',
  retail_audit_38: 'Nasıl çalışıyoruz?',
  retail_audit_39:
    'Denetçimiz, ajansın aktivasyon planına göre belirlenen satış noktalarını (POS) ziyaret eder.',
  retail_audit_40:
    'POS varlığı, marka elçisi katılımı, promosyon yönergelerine uyum ve dolandırıcılık önleme önlemleri gibi kısa bilgilendirmede belirtilen temel performans göstergelerini (KPI) değerlendirirler.',
  retail_audit_41: 'Doğrulama:',
  retail_audit_42: 'Elde edilen verileri toplar ve birleştiririz.',
  retail_audit_43: 'Kapsamlı bir rapor hazırlanır.',
  retail_audit_44:
    'Doğrulama ekibimiz, proje brifingine uyum ve ek yorumlar dahil olmak üzere tüm anketleri titizlikle inceler.',
  retail_audit_45: 'Çevrimiçi Raporlama Sistemi:',
  retail_audit_46:
    'Tamamlanmış ve doğrulanmış anketler 36 saat içinde çevrimiçi portalımıza yüklenir.',
  retail_audit_47:
    'Müşteriler, ilerlemeyi her zaman takip edebilecekleri kişisel hesap portalına erişim hakkına sahiptir.',
  retail_audit_48: 'Sonuçlar ve öneriler içeren nihai bir rapor sunulur.',
  retail_audit_49: 'Bir uzmana danışın',
  retail_audit_50: 'Güçlü yönlerimiz:',
  facility_check_audit_1: 'Tesis',
  facility_check_audit_2: 'Kontrol Denetimi',
  facility_check_audit_3: 'Marka Deneyimini Her Detayda Yükseltin',
  facility_check_audit_4: 'Yaklaşımımızı Keşfedin',
  facility_check_audit_5: 'Hakkında',
  facility_check_audit_6: 'Biz kimiz',
  facility_check_audit_7:
    'Küresel bir müşteri deneyimi holdingi olarak 4Service, markaların müşterileri için olağanüstü deneyimler yaratmasına ve sunmasına yardımcı olacak kapsamlı hizmetler sunar.',
  facility_check_audit_8: 'Tesis Kontrol Denetimi hizmetimiz',
  facility_check_audit_9:
    'perakende mağazalardaki fiziksel konumlarınızın ve marka varlığınızın marka standartlarınıza uygun olduğundan ve müşteriler için olumlu bir izlenim yarattığından emin olmanıza yardımcı olmak için tasarlanmıştır.',
  facility_check_audit_10: 'Çözümler 1',
  facility_check_audit_11: 'Tesis Kontrol Denetimi',
  facility_check_audit_12:
    'Perakende mağazalarınızın veya standlarınızın marka standartlarına uyumunu değerlendiren titiz bir incelemedir. Sadece fiziksel özellikleri doğrulamakla kalmaz, aynı zamanda bu unsurların değerli müşterilerinizin markanızı algılayışını nasıl etkilediğini de ölçeriz.',
  facility_check_audit_13: 'İki çözüm',
  facility_check_audit_14: 'İki Uygulama Yöntemi',
  facility_check_audit_15: 'Yöntem',
  facility_check_audit_16: 'Uzman Denetçiler Tarafından Tesis Kontrol Denetimi',
  facility_check_audit_17: 'Tesis Kontrolünün Doğrulanması',
  facility_check_audit_18: 'Raporlar',
  facility_check_audit_19:
    '48 saat içinde erişilebilecek görsel kanıtlar ve istatistikler içeren raporlar alırsınız',
  facility_check_audit_20:
    'Başarılı bir Tesis Kontrol Denetimi, markanız için birçok fayda sağlayabilir, bunlar arasında:',
  facility_check_audit_21: 'Geliştirilmiş müşteri dönüşümü:',
  facility_check_audit_22:
    'Olumlu bir müşteri deneyimi, artan satış ve tekrar iş getirebilir. Denetimlerimiz, müşteri memnuniyetini etkileyebilecek alanları belirlemenize ve düzeltmenize yardımcı olabilir.',
  facility_check_audit_23: 'Geliştirilmiş marka imajı:',
  facility_check_audit_24:
    'Fiziksel konumlarınız, müşteriler için önemli bir temas noktasıdır ve marka imajınızı şekillendirmede önemli rol oynayabilir. Denetimlerimiz, konumlarınızın marka değerlerinizle uyumlu ve müşteriler için olumlu bir izlenim yaratmasını sağlamaya yardımcı olur.',
  facility_check_audit_25: 'Neden biz?',
  facility_check_audit_26: 'Tesis Kontrol Denetimi neden önemlidir?',
  facility_check_audit_27:
    'Başarılı bir Tesis Kontrol Denetimi, markanız için birçok fayda sağlayabilir, bunlar arasında:',
  facility_check_audit_28: 'Geliştirilmiş marka imajı:',
  facility_check_audit_29:
    'Fiziksel konumlarınız, müşteriler için önemli bir temas noktasıdır ve marka imajınızı şekillendirmede önemli rol oynayabilir. Denetimlerimiz, konumlarınızın marka değerlerinizle uyumlu ve müşteriler için olumlu bir izlenim yaratmasını sağlamaya yardımcı olur.',
  facility_check_audit_30: 'Geliştirilmiş müşteri dönüşümü:',
  facility_check_audit_31:
    'Olumlu bir müşteri deneyimi, artan satış ve tekrar iş getirebilir. Denetimlerimiz, müşteri memnuniyetini etkileyebilecek alanları belirlemenize ve düzeltmenize yardımcı olabilir.',
  facility_check_audit_32: 'Kimler için',
  facility_check_audit_33: 'Tesis Kontrol Denetimine kimlerin ihtiyacı var?',
  facility_check_audit_34:
    'Tesis Kontrol Denetimi, fiziksel konumları ve varlığı olan her marka için değerli bir hizmettir. Özellikle şu markalar için önemlidir:',
  facility_check_audit_35: 'Marka standartlarına uyumu sağlamak:',
  facility_check_audit_36:
    'Denetimlerimiz, konumlarınızın marka standartlarından sapabileceği alanları belirlemenize yardımcı olabilir.',
  facility_check_audit_37: 'Müşteri deneyimini geliştirmek:',
  facility_check_audit_38:
    'Denetimlerimiz, konumlarınızda müşteri deneyimini iyileştirme fırsatlarını belirlemenize yardımcı olabilir.',
  facility_check_audit_39: 'Daha güçlü bir marka oluşturmak:',
  facility_check_audit_40:
    'Denetimlerimiz, fiziksel konumlarınızın müşteriler için olumlu bir izlenim yarattığından emin olmanıza yardımcı olur.',
  facility_check_audit_41:
    'Çalışanınız veya gizli müşteri, konumun fotoğrafını çeker.',
  facility_check_audit_42: 'Ardından, bir anket doldurur ve fotoğrafı ekler.',
  facility_check_audit_43:
    'Doğrulayıcı, fotoğrafı alır ve standartlara uygunluğunu kontrol eder.',
  facility_check_audit_44: 'Uzman Denetçiler Tarafından Tesis Kontrol Denetimi',
  facility_check_audit_45: 'Hazırlık Aşaması:',
  facility_check_audit_46: 'Denetim takviminin ortak onayı',
  facility_check_audit_47:
    'Bayiler, yaklaşan denetim hakkında bilgilendirilir ve hazırlanır',
  facility_check_audit_48: 'Denetçi Eğitimi:',
  facility_check_audit_49:
    'Deneyimli 4Service eğitmenlerimiz, denetçileri marka yönergeleriyle güçlendirir',
  facility_check_audit_50: 'Tesis Denetim Aşaması:',
  facility_check_audit_51:
    'Denetçiler, özel yetki mektupları ile konumları ziyaret eder',
  facility_check_audit_52:
    'Her noktayı titizlikle inceleme, yönergelere eksiksiz uyum',
  facility_check_audit_53:
    'Görsel dokümantasyon, HQ ön koşullarına karşı değerlendirmelerle birlikte',
  facility_check_audit_54: 'Sonuç PPT Raporu',
  facility_check_audit_55: 'Bulguları açıklayan kapsamlı bir PowerPoint raporu',
  facility_check_audit_56:
    'Denetlenen sonuçların çevrimiçi/çevrimdışı etkileyici sunumu',
  facility_check_audit_57: 'Tesis Kontrolünün Doğrulanması',
  facility_check_audit_58: 'Adımlar:',
  facility_check_audit_59: 'Tesis Denetim Aşaması:',
  facility_check_audit_60:
    'Marka temsilcileri, saha fotoğraflarını çekmek için 4Service uygulamasını kullanır',
  facility_check_audit_61: 'Katı görsel ve açıklayıcı kriterlere uyum',
  facility_check_audit_62: 'Doğrulama Aşaması:',
  facility_check_audit_63: 'Titiz doğrulayıcılar, her raporu özenle inceler',
  facility_check_audit_64:
    'Fotoğrafların marka standartlarıyla kapsamlı karşılaştırması',
  facility_check_audit_65:
    'Raporun anlaşılır olması için notlar ve içgörüler entegre edilir',
  facility_check_audit_66:
    'Gerekirse netleştirme için bayilerle doğrudan iletişim',
  facility_check_audit_67: 'Raporlama Aşaması:',
  facility_check_audit_68:
    'Görsel kanıtlar ve istatistikler içeren raporlar, iki gün içinde erişilebilir',
  facility_check_audit_69: 'Bugün bizimle iletişime geçin',
  cx_solution_1: 'Sadece içgörüler bulmuyoruz,',
  cx_solution_2: 'İşinizi yeni zirvelere taşıyoruz',
  cx_solution_3:
    '20 yılı aşkın müşteri deneyimi olan uzmanlar, karmaşık çözümleri keşfeder ve büyümenize katkıda bulunan belirli bir eylem planı sunar',
  cx_solution_4:
    'Geleceğe hazır tek bir çözümde benzersiz bir hizmet paketi keşfedin',
  cx_solution_5: 'Hepsi bir arada CX çözümü',
  cx_solution_6: 'Reklam testleri',
  cx_solution_7: 'Yapay Zeka & Nöropazarlama',
  cx_solution_8: 'Müşteri sesi',
  cx_solution_9: 'Masa başı araştırması',
  cx_solution_10: 'CJM',
  cx_solution_11: 'Gizli Alışveriş',
  cx_solution_12: 'CX danışmanlığı',
  cx_solution_13: 'Sosyal Medya Dinleme',
  cx_solution_14: 'Nicel ve nitel araştırma',
  cx_solution_15: 'Hizmet tasarımı',
  cx_solution_16: 'Pazarlama stratejisi',
  cx_solution_17: 'UX/UI testi',
  cx_solution_18: 'Hedef Kitle İçgörüleri',
  cx_solution_19: 'Başarınıza katkıda bulunmaktan onur duyuyoruz',
  cx_solution_20:
    'İşinizin amacı ve hedefleri doğrultusunda araçları ve hizmetleri özelleştirir ve birleştirir, size özel sonuçlar sunarız',
  cx_solution_21: 'Kapsamlı araştırma',
  cx_solution_22:
    'Karar alma süreçlerinizi güçlendirin ve veri odaklı piyasada rekabet avantajı sağlayın.',
  cx_solution_23:
    'Nitel araştırma, kavramları, görüşleri veya deneyimleri anlamak için sayısal olmayan verilerin toplanması ve analizidir',
  cx_solution_24:
    'Nicel araştırma yöntemleri, anketler, soru formları ve araştırmalar yoluyla toplanan verilerin objektif ölçümü ve sayısal analizidir',
  cx_solution_25: 'Özel gereksinimlerinize göre farklı araçlar kullanıyoruz',
  cx_solution_26: 'Araçlar',
  cx_solution_27: 'CAWI',
  cx_solution_28:
    'Bilgisayar Destekli Web Mülakatı, çevrimiçi platformlar üzerinden anketler yapmamızı ve veri toplamamızı sağlayan hayati bir araçtır. Bu yöntem, müşterilerimizin pazar araştırması ihtiyaçları için verimli ve doğru veri toplama sağlar',
  cx_solution_29: 'CATI',
  cx_solution_30:
    'Bilgisayar Destekli Telefon Mülakatı, telefon üzerinden değerli veri toplamak için kullandığımız bir yöntemdir ve özel yazılım ile süreci hızlandırır ve doğruluğu sağlar',
  cx_solution_31: 'F2F',
  cx_solution_32:
    'Yüz yüze yöntem, müşterilerle doğrudan etkileşim ve kişiselleştirilmiş iletişim sağlayarak güven, anlayış ve etkili iletişim oluşturur, bu da uzun vadeli ilişkiler kurmayı ve iş başarısını artırmayı sağlar',
  cx_solution_33: 'Masa başı araştırması',
  cx_solution_34:
    'Masa başı araştırması, kapsamlı veri toplama ve analiz içerir ve araştırma sürecimizin temel adımlarından biridir, içgörüler elde etmek ve stratejik kararları bilgilendirmek için kullanılır',
  cx_solution_35: 'SWOT analizi',
  cx_solution_36:
    'SWOT analizi, müşterilerimizin içsel Güçlü ve Zayıf yönlerini, dışsal Fırsat ve Tehditleri belirlemesine yardımcı olan stratejik bir değerlendirme aracıdır, karar alma süreçlerine değerli içgörüler sağlar ve etkili iş stratejileri geliştirir',
  cx_solution_37: 'Etnografik araştırma',
  cx_solution_38:
    'İnsanları ve kültürleri doğal ortamlarında gözlemleyerek inceleme, davranışlar, inançlar ve sosyal dinamikler hakkında derin içgörüler sağlar',
  cx_solution_39: 'Derinlemesine görüşmeler',
  cx_solution_40:
    'Derinlemesine görüşmeler, katılımcılarla tek tek yapılan ayrıntılı tartışmaları içeren nitel bir araştırma yöntemidir ve perspektiflerini, deneyimlerini ve görüşlerini derinlemesine anlamamıza olanak tanır, zengin içgörüler sağlar',
  cx_solution_41: 'Fikir üretme oturumları',
  cx_solution_42:
    'Fikir üretme oturumları, çeşitli bakış açılarını ve uzmanlığı bir araya getirerek yaratıcı fikirler ve çözümler üretmek için yapılan işbirlikçi beyin fırtınası oturumlarıdır, yeniliği teşvik eder ve stratejik girişimleri ileriye taşır',
  cx_solution_43: 'Alıcı personel profilleri',
  cx_solution_44:
    'Alıcı personel profilleri, müşterilerimizin hedef kitlesini temsil eden detaylı profillerdir ve araştırma ile veri analizi kullanılarak geliştirilir, ihtiyaçlarını, tercihlerini ve davranışlarını anlamamıza yardımcı olur, strateji ve iletişimleri etkili hale getirir ve iş başarısını destekler',
  cx_solution_45: 'Gizli Alışveriş',
  cx_solution_46:
    'Gizli Alışveriş, önceden tanımlanmış senaryo sırasında müşteri ve şirket arasındaki etkileşimleri ölçen stratejik bir hizmettir',
  cx_solution_47: 'Refakat kontrolü',
  cx_solution_48:
    'Refakat kontrolü, değerlendiricilerimizin müşterileri hizmet deneyimleri boyunca takip ettiği özel bir gizli alışveriş biçimidir ve müşteri yolculuğunun her yönü hakkında kapsamlı içgörüler sağlar, müşterilerimizin hizmet sunumunu derinlemesine anlamalarına ve iyileştirmeler yapmalarına yardımcı olur',
  cx_solution_49: 'Geri bildirim toplama ve analizi',
  cx_solution_50:
    'Geri bildirim toplama ve analizi, anketler, incelemeler ve sosyal medya gibi çeşitli kanallardan müşteri geri bildirimlerinin sistematik olarak toplanmasını ve analiz edilmesini içeren kritik bir süreçtir. Bu süreç, değerli içgörüler elde etmemizi, trendleri belirlememizi ve müşterilerimizin ürünlerini, hizmetlerini ve genel müşteri deneyimini geliştirmek için veri odaklı öneriler sunmamızı sağlar',
  cx_solution_51: 'Odak grupları',
  cx_solution_52:
    'Odak grupları, belirli konuları veya ürünleri derinlemesine tartışmak için çeşitli katılımcıların bir araya getirildiği dinamik araştırma oturumlarıdır. Bu sayede nitel içgörüler toplanır, tutumlar, tercih ve algılar keşfedilir ve fikirler ve kavramlar incelenir; sonuç olarak müşterilerimizin karar alma ve strateji geliştirme süreçleri bilgilendirilir',
  cx_solution_53: '20 yıllık olağanüstü müşteri deneyimleri tasarlama',
  cx_solution_54:
    'Mesajınızın hedef kitlenizi etkilemesini ve yankı bulmasını sağlayın.',
  cx_solution_55: 'Beklentilerinizi aşan sonuçlar sunmaya kararlıyız',
  cx_solution_56: 'Büyümenize katkıda bulunan karmaşık çözümleri keşfediyoruz',
  cx_solution_57: 'Metodolojimizle müşteri deneyiminizi yükseltin',
  cx_solution_58:
    'Müşteri Yolculuğu Haritalaması, hedef kitleyi tanımlamak, ihtiyaçlarını ve çevrelerini anlamak ve ardından etkileyici bir deneyim sunmak için bir plan oluşturmaktır',
  cx_solution_59: 'BHT',
  cx_solution_60:
    'Marka Sağlığı Takibi araştırması, markanızın farkındalık ve kullanım, marka konumlandırma ve marka performansını ölçebilir',
  cx_solution_61: 'CSI',
  cx_solution_62:
    'Müşteri Memnuniyeti Endeksi, müşterilerinizin şirketin ürün / hizmetlerinden ne kadar memnun olduğunu gösteren bir puandır.',
  cx_solution_63:
    'Fiyat izleme, rakiplerin fiyatlarının toplanması, işlenmesi ve analiz edilmesi sürecidir',
  cx_solution_64: 'NPS',
  cx_solution_65:
    'Net Tavsiye Skoru, müşteri deneyimi metriklerinin altın standardıdır ve tek bir soruya dayanır: Organizasyonu/Ürünü/Hizmeti ne kadar tavsiye edersiniz?',
  cx_solution_66: 'İK araştırması',
  cx_solution_67:
    'İnsan Kaynakları Araştırması, İK uygulamalarını ve performansını değerlendirmek için kullanılır ve mevcut gelişim ve yönetim hakkında detaylı analiz sunar',
  cx_solution_68:
    'Kullanılabilirlik testi, gerçek kişilerin bir web sitesi, uygulama veya diğer ürünle nasıl etkileşimde bulunduğunu ve davranışlarını ve tepkilerini gözlemlemeyi içerir',
  cx_solution_69: 'Diğer',
  cx_solution_70: 'Uzmanlar, işiniz için en iyi metodolojiyi seçer',
  cx_solution_71: 'Başlayalım',
  cx_solution_72: '1 - BAŞLANGIÇ TOPLANTISI',
  cx_solution_73:
    'Başlangıç toplantısında, temel görevler belirlenir ve odaklanılır. Sonuç: hedefin, araştırma görevlerinin, sürelerin, yöntemlerin ve sorumluluk alanlarının anlaşılması.',
  cx_solution_74: '2 - KONSEPT GELİŞTİRME',
  cx_solution_75:
    '4Service analiz departmanı verileri toplar, rapor yapısını koordine eder. Daha sonra sonuçları müşteriye sunar, içgörüler ve uygulanabilir önerilerle destekler.',
  cx_solution_76: '3 - SAHA ÇALIŞMASI',
  cx_solution_77:
    'Araştırmayı yürütmek için katılımcılar işe alınır, görüşmeler ve diğer temel araştırma aşamaları gerçekleştirilir. Müşteri, transkripte edilmiş ses-görüntü görüşmelerini ve özlü özetleri alır.',
  cx_solution_78: '4 - ANALİZ',
  cx_solution_79:
    '4Service analiz departmanı verileri toplar, rapor yapısını koordine eder. Daha sonra sonuçları müşteriye sunar, içgörüler ve uygulanabilir önerilerle destekler.',
  cx_solution_80: '5 - WORKSHOP',
  cx_solution_81: 'Müşteri ile uygulanacak plan hakkında tartışma yapılması',
  cx_solution_82: 'En iyi uygulamalarımız hakkında daha fazla bilgi edinin',
  cx_solution_83:
    'Müşteri Yolculuğu Haritası, tüm iletişim kanallarının hızlı bir şekilde incelenmesini, kritik temas noktalarında potansiyel eksikliklerin belirlenmesini ve planlanan rotadan sapabilecek alanların kapsamlı olarak anlaşılmasını sağlar.',
  cx_solution_84: 'Ne zaman kullanılmalı?',
  cx_solution_85:
    'Gerçek veri tabanlı kişiselleştirilmiş bir reklam kampanyası oluşturun',
  cx_solution_86:
    'Farklı hedef kitle segmentlerinin tetikleyicilerini bulun ve ihtiyaçlarını karşılayın',
  cx_solution_87:
    'Her grubu hassas bir şekilde hedefleyin ve maksimum dönüşüm elde edin',
  cx_solution_88:
    'Refakat Kontrolü tekniği, hedeflerinize ulaşmanın optimal yollarını değerlendirme olanağı sağlar.',
  cx_solution_89: 'Yeni bir web sitesi veya ürünü lansman öncesi test etme',
  cx_solution_90:
    'Değişiklikleri uygulamadan önce geliştirilmiş süreçleri kontrol etme',
  cx_solution_91: 'Düşen satışlar arasında web sitesi veya ürünü değerlendirme',
  cx_solution_92: 'Müşteri tercihlerine göre yeni bir ürün piyasaya sürme',
  cx_solution_93:
    'Piyasada lider konum sağlamak için rakip şirketleri inceleme',
  cx_solution_94:
    'Müşteri odaklı bir hizmet modeli oluşturmak için kapsamlı 360° yaklaşım sunuyoruz.',
  cx_solution_95: 'Personel eğitimi ve geliştirme',
  cx_solution_96: 'Hizmet standartlarının iyileştirilmesi',
  cx_solution_97: 'Müşteri akışı ve satışların artırılması',
  cx_solution_98: 'Personel için KPI ve motivasyon sistemi belirleme',
  cx_solution_99: 'Başarı hikayelerimizi keşfedin',
  cx_solution_100: 'Otomotiv',
  cx_solution_101: 'Tütün',
  cx_solution_102: 'Perakende',
  cx_solution_103: 'Nitel aşama',
  cx_solution_104: 'Nicel aşama (segmentasyon)',
  cx_solution_105: 'Odak grupları',
  cx_solution_106: 'Çevrimiçi dünya çapında hedef kitle kapsamı',
  cx_solution_107: 'Görüşmeler sırasında tekniklerin karışımı',
  cx_solution_108: 'Sadece açık uçlu sorular',
  cx_solution_109: 'Katılımcı desteği 7/24',
  cx_solution_110:
    'Önemli detayların korunması ve yolun gerçek resminin alınması',
  cx_solution_111: 'Pazar araştırması',
  cx_solution_112: 'Şirket ve rakiplerin tanılaması',
  cx_solution_113: 'Güncellenmiş hizmet modelleri ve yeni iş süreçleri',
  cx_solution_114: 'Müşteri odaklı hizmetin teşviki',
  cx_solution_115:
    'Değişikliklerin uygulanması ve hizmet stratejilerinin gelişiminin kontrolü',
  usage_attitude_1: 'Kullanım ve \n Tutum (U&A)',
  usage_attitude_2:
    'Hedef kitlenizin markanızı nasıl algıladığını, kullandığını ve etkileşimde bulunduğunu kapsamlı bir şekilde anlayın.',
  usage_attitude_3: 'Bir uzmana danışın',
  usage_attitude_4: 'Hakkında',
  usage_attitude_5:
    '<b>Tüketici</b> alışkanlıklarını derinlemesine inceleyerek tercihlerini ve etkilerini ortaya çıkarın',
  usage_attitude_6:
    "<b>Tüketici tercihleri</b>nin arkasındaki 'neden'i detaylı analizimizle keşfedin",
  usage_attitude_7:
    '<b>Müşterilerin</b> ürünlerinizle nasıl etkileşimde bulunduğunu stratejik içgörüler için anlayın',
  usage_attitude_8:
    '<b>Tüketici davranışları, alışkanlıkları ve tercihleri</b> hakkında içgörü elde ederek bilinçli kararlar verin',
  usage_attitude_9: 'Deneyim',
  usage_attitude_10:
    '20 yılı aşkın müşteri deneyimi ile 4Service uzmanları, işinizi büyütmeye yardımcı olan benzersiz çözümler sunar',
  usage_attitude_11: 'İletişime geçin',
  usage_attitude_12: 'Kimler için',
  usage_attitude_13: 'Marka Kullanım ve Tutum çalışmasından kimler faydalanır?',
  usage_attitude_14: 'Çeşitli sektörler ve hizmet alanları ilgilenir:',
  usage_attitude_15: '<b>Müşteri taleplerini</b> ve sorun noktalarını tanımak',
  usage_attitude_16:
    '<b>Tüketici harcamalarını</b> artırma fırsatlarını belirlemek',
  usage_attitude_17:
    '<b>Yeni ürün kategorileri veya</b> pazarlama stratejileri geliştirmek',
  usage_attitude_18: '<b>Rekabet ortamını</b> derinlemesine anlamak',
  usage_attitude_19:
    'Metodoloji, müşterinin talebine göre bireysel olarak seçilir',
  usage_attitude_20:
    '<b>Nitel araştırma</b>, kavramları, görüşleri veya deneyimleri anlamak için sayısal olmayan verilerin toplanmasını ve analiz edilmesini içerir.',
  usage_attitude_21:
    '<b>Nicel araştırma</b> yöntemleri, anketler, soru formları ve araştırmalar yoluyla elde edilen verilerin nesnel olarak ölçülmesini ve sayısal analizini içerir.',
  usage_attitude_22:
    '<b>Veriler toplandıktan sonra</b>, uzmanlar bilgileri analiz eder ve en iyi önerileri sunmak için sonuç çıkarır.',
  usage_attitude_23: 'Kimler ihtiyaç duyar',
  usage_attitude_24: 'Başarı Hikayeniz Burada Başlıyor',
  usage_attitude_25:
    '<b>Stratejik karar almayı güçlendiren</b> değerli içgörülerle dolu bir araştırma alacaksınız, böylece eylemler tüketici davranışını derinlemesine anlamaya dayanacaktır.',
  usage_attitude_26:
    '<b>Araştırma, marka stratejilerini</b> tüketici tercihleri ve tutumlarıyla daha uyumlu hale getirmek ve optimize etmek için sağlam bir temel sağlar.',
  usage_attitude_27: 'Çözümler',
  usage_attitude_28: 'Çözümlerimizle birçok fırsatı keşfedin',
  usage_attitude_29: 'Kategori içindeki ürün tercihi',
  usage_attitude_30:
    'Gıda, içecek, giyim, elektronik ve diğer kategorilerde tüketicilerin en çok tercih ettikleri ürünleri belirleyin.',
  usage_attitude_31: 'Tüketim / kullanım davranışı',
  usage_attitude_32:
    'Belirli ürün/hizmetlerin tüketim veya kullanım sıklığını analiz edin ve kullanım anlarını ve durumlarını belirleyin.',
  usage_attitude_33: 'Satın alma davranışı',
  usage_attitude_34:
    'Müşterilerin satın alımlarında kullandıkları kanalları inceleyin ve güvenilen bilgi kaynaklarını belirleyin.',
  usage_attitude_35: 'Tüketici motivasyonları ve ihtiyaçları',
  usage_attitude_36:
    'Tüketimi etkileyen motivasyonları ve engelleri inceleyin. Tüketici satın alma kararlarını etkileyen faktörleri değerlendirin. Ürün kategorisinin algısını inceleyin ve fiyatın nasıl algılandığını analiz edin.',
  usage_attitude_37: 'Yaklaşımımız',
  usage_attitude_38: 'Marka kullanım ve tutum çalışması',
  usage_attitude_39: 'Bilgi',
  usage_attitude_40: 'Hem nicel hem de nitel yöntemlerle anketler yürütülmesi',
  usage_attitude_41: 'Başlat',
  usage_attitude_42:
    'Hedeflerin belirlenmesi ve bireysel taleplere göre yöntemlerin seçilmesi',
  usage_attitude_43: 'Analiz',
  usage_attitude_44: 'Uzmanlarımız tarafından uygulanan sofistike teknikler',
  usage_attitude_45:
    'Belirli gereksinimlerinize göre farklı araçlar kullanıyoruz',
  usage_attitude_46: 'CATI',
  usage_attitude_47:
    'Bilgisayar Destekli Telefon Görüşmeleri (CATI), anketler yapmak ve değerli veriler toplamak için kullandığımız bir yöntemdir. Süreci hızlandırmak ve doğruluğu sağlamak için özel yazılım kullanılır.',
  usage_attitude_48: 'CAWI',
  usage_attitude_49:
    'Bilgisayar Destekli Web Görüşmeleri (CAWI), çevrimiçi platformlar aracılığıyla anketler yürütmemizi ve veri toplamamızı sağlayan kritik bir araçtır. Bu sayede müşterilerimizin pazar araştırması ihtiyaçları için verimli ve doğru veri toplama sağlanır.',
  usage_attitude_50: 'CAPI',
  usage_attitude_51:
    'Bilgisayar Destekli Kişisel Görüşme (CAPI), veri toplama süreçlerini optimize etmek, görüşmeleri daha akıcı yapmak ve iş ihtiyaçlarınız için doğru ve içgörülü sonuçlar elde etmek için kullandığımız bir yöntemdir.',
  usage_attitude_52: 'Odak grupları',
  usage_attitude_53:
    'Odak grupları, belirli konuları veya ürünleri derinlemesine tartışmak için çeşitli katılımcıların bir araya getirildiği dinamik araştırma oturumlarıdır. Bu sayede nitel içgörüler toplanır, tutumlar, tercih ve algılar keşfedilir ve fikirler incelenir; sonuç olarak müşterilerimizin karar alma ve strateji geliştirme süreçleri bilgilendirilir.',
  usage_attitude_54: 'F2F',
  usage_attitude_55:
    'Yüz yüze (F2F), müşterilerle doğrudan etkileşim ve kişiselleştirilmiş iletişim sağlar, güven, anlayış ve etkili iletişimi teşvik eder, uzun vadeli ilişkiler kurmayı ve iş başarısını artırmayı sağlar.',
  usage_attitude_56: 'Etnografik Araştırma',
  usage_attitude_57:
    'İnsanları ve kültürleri, doğal ortamlarında gözlem ve katılım yoluyla incelemek, davranışlar, inançlar ve sosyal dinamikler hakkında derinlemesine içgörüler sağlar.',
  thank_you_page:
    'Zaman ayırdığınız için teşekkürler! Yöneticimiz sizinle kısa süre içinde iletişime geçecektir.',
  back_main: 'Ana sayfaya dön',
  opportunities_1: 'Vaka çalışmalarımız hakkında daha fazla bilgi edinin',
  opportunities_2: 'Keşfedin',
  opportunities_3: 'kendiniz için',
  opportunities_4: 'fırsatlar',
  opportunities_5: 'araştırma holdingi 4Service ile uluslararası iş fırsatları',
  opportunities_6: 'Hangi <span>ürünlerle</span> işinizi güçlendirebiliriz?',
  opportunities_7: 'CX',
  opportunities_8: 'İş için kapsamlı ve özelleştirilmiş çözümler',
  opportunities_9: 'Her tür Gizemli Alışveriş',
  opportunities_10:
    'Gizemli çalışan, gizemli arayan, lüks gizemli müşteri, otomotiv gizemli müşteri ve diğer türleri uygularız',
  opportunities_11: 'İş için özelleştirilmiş BT çözümleri',
  opportunities_12:
    'AI ile kendi BT çözümlerimiz, geri bildirim analitiği ve çağrı transkripsiyonu platformları',
  opportunities_13: 'Pazar araştırması',
  opportunities_14:
    'Her türlü iş talebi için (Marka Sağlığı Takibi, Segmentasyon, NPS, eNPS, CJM, Ürün ve reklam testleri vb.)',
  opportunities_15: 'Denetimler',
  opportunities_16:
    'Çeşitli hizmet denetimleri ve fiyat takibi gerçekleştiriyoruz (offline, belirli nişler vb.)',
  opportunities_17: 'Hizmet Tasarımı',
  opportunities_18:
    '4Service - DesignThinkers Academy sertifikalı ortakları, ekipler için kurumsal eğitimler sunar ve düzenli olarak işletmeler için atölye çalışmaları yürütür',
  opportunities_19:
    'Deneyimimizi paylaşırız, ancak <span>iş süreçlerinize saygı gösterir ve aksatmayız</span>.',
  opportunities_20:
    'İşletmelerin gelişim yolculuğunda karşılaştığı zorlukları biliyoruz ve uluslararası başarılı deneyim sayesinde bu engelleri nasıl aşacağımızı biliyoruz. Sadece deneyim değil, aynı zamanda kaynaklar da elde edersiniz.',
  opportunities_21: 'İş birliği yapmaya davet ediyoruz!',
  opportunities_22: 'İşiniz için <span>ortaklık programı</span> sunuyoruz',
  opportunities_23:
    '4Service’in uluslararası tanınan markası altında, yeni müşteriler çekmeye olumlu katkıda bulunabilirsiniz.',
  opportunities_24:
    'Ortaklarımız, eğitim, pazarlama materyalleri ve operasyonel destek dahil olmak üzere kapsamlı destek alır.',
  opportunities_25:
    'Bizimle ortaklık, mevcut iş sürecinizi aksatmadan planlarınızı gerçekleştirmenizi sağlar.',
  opportunities_26: 'Ofislerimiz <span></span>',
  opportunities_27: 'Müşterilerimiz',
  opportunities_28: 'CX konusunda 20 yılı aşkın deneyime sahibiz',
  opportunities_29: 'Kapsanan ülkeler',
  opportunities_30: 'bin',
  opportunities_31: 'Benzersiz projeler',
  opportunities_32: 'milyon',
  opportunities_33: 'Gizemli müşteriler tarafından yapılan ziyaretler',
  opportunities_34: 'Avrupa’nın TOP 10 CX ajansı arasında yer alır',
  opportunities_35: '4Service ile sizin fırsatlarınız',
  opportunities_36: 'Kâr artışı',
  opportunities_37: 'Uluslararası siparişlere erişim sağlayacaksınız',
  opportunities_38: 'Benzersiz CX yaklaşımı',
  opportunities_39: '20 yıllık deneyime sahip uzmanlardan destek',
  opportunities_40: 'Destek',
  opportunities_41: 'Ekibimiz, sonuç almanız için sizi destekleyecektir',
  opportunities_42: 'Satış',
  opportunities_43: 'Size bir satış sistemi kurmanızda yardımcı olacağız',
  opportunities_44: 'Yazılımlara erişim',
  opportunities_45: 'Tüm sertifikalı BT araçlarına erişim sağlayacaksınız',
  opportunities_46: 'Eğitim',
  opportunities_47:
    'Sadece personelinizi eğitmekle kalmayacak, aynı zamanda danışmanlık hizmeti sunmaya devam edeceğiz',
  opportunities_48: 'Kimler ortaklık için uygundur?',
  opportunities_49: 'İşiniz pazarlama araştırmaları ile mi ilgili?',
  opportunities_50:
    'Yoksa yeni bir alanda kendinizi denemeyi mi planlıyorsunuz?',
  opportunities_51: 'Şunları yapmayı mı planlıyorsunuz:',
  opportunities_52: 'İnovasyonları uygulamak',
  opportunities_53: 'Uluslararası markalarla çalışmak',
  opportunities_54: 'Ürün portföyünüzü genişletmek',
  opportunities_55: 'Pazar konumunuzu güçlendirmek?',
  opportunities_56: 'Çalışanlarınızı eğitmek',
  opportunities_57: 'İşinizi ölçeklendirmek',
  opportunities_58: 'Kaynaklarımız = Sizin kaynaklarınız',
  opportunities_59:
    'Geniş deneyimimiz sayesinde, iş birliğinin ilk aşamasında bunu sizinle paylaşmaya hazırız',
  opportunities_60: 'Veri analizi:',
  opportunities_61: 'Uluslararası analitik ekip',
  opportunities_62: 'Veri işleme yöntemleri - SPSS, Power BI',
  opportunities_63: 'Yenilikçi metodolojiler ve geniş metodoloji yelpazesi',
  opportunities_64: 'Her formatta raporlama',
  opportunities_65: 'Yazılım:',
  opportunities_66: 'Özel olarak uyarlanmış kendi BT geliştirmelerimiz',
  opportunities_67: 'CAPI için DigSee Sure',
  opportunities_68: 'CAWI için SurveyMonkey',
  opportunities_69: 'Shopmetrics',
  opportunities_70: 'VoIPTime (çağrı merkezi)',
  opportunities_71: 'Pazarlama desteği:',
  opportunities_72: 'PR desteği',
  opportunities_73: 'Tanıtım ve içerik oluşturma desteği',
  opportunities_74: 'Lead generation süreçlerinin kurulumu',
  opportunities_75: 'BT desteği:',
  opportunities_76:
    'Yazılımımızın kurulumu, yapılandırması ve kullanımı ile teknik destek.',
  opportunities_77: 'Uzaktan destek',
  opportunities_78: 'Güvenlik kontrolü',
  opportunities_79: 'Operasyonel destek:',
  opportunities_80: 'Saha süreçlerinin kurulmasında destek',
  opportunities_81: 'Dolandırıcılık önleme sistemi',
  opportunities_82: 'Her seviyede personel alımı',
  opportunities_83: 'Proje ve saha departmanları ekibinin operasyonel yönetimi',
  opportunities_84: 'Alım kalitesinin kontrolü',
  opportunities_85: 'UpWork',
  opportunities_86: 'Hangi bonusları alacaksınız?',
  opportunities_87: 'Müşteri tabanında artış',
  opportunities_88: 'Pazar imajının güçlendirilmesi',
  opportunities_89: 'Müşteri kaybı risklerinin çeşitlendirilmesi',
  opportunities_90: 'Teknolojik süreçlerin optimize edilmesi',
  opportunities_91: 'Uluslararası deneyim',
  opportunities_92: 'Mevcut müşterilere daha fazla satış',
  main_67:
    'Rekabetçi fiyat analizi, tüketicinin ödeme istekliliği verilerini kullanarak teklifler optimize eder, kârı artırır ve pazar payını yükseltir',
  main_68:
    'Perakende noktalarınızın marka standartlarına uygun olmasını sağlar, fiziksel özellikleri ve bunların müşteri algısına etkisini değerlendirir',
  main_69: 'CX çözümü',
  main_70:
    'Benzersiz 360 derece CX çözümümüzü keşfedin: İşinizi büyütmek için araçları ve hizmetleri hedeflerinize göre özelleştiriyoruz',
  main_71: 'Konuşma analitiği',
  main_72:
    'Gelişmiş konuşma analitiği aracımız, konuşulan dili metne dönüştürür ve işletmelere müşteri deneyimini geliştirme, performansı izleme, uyumluluğu sağlama ve büyümeyi teşvik etme konusunda değerli bilgiler sunar',
  parthership: 'Ortaklık',
  banner_1: 'CX danışmanlığı ve hizmetleri ile işinize 360° bakış',
  banner_2: 'En son araştırmalarla güncel kalın!',
  banner_3:
    'Kişisel verilerin işlenmesine gizlilik politikası doğrultusunda onay veriyorum',
  banner_4: '*Pazarı seçin',
  banner_5: 'Abone olduğunuz için teşekkürler!',
  banner_6: 'Sadece en ilginç içerikleri sizinle paylaşacağız!',
  banner_7: 'Gönder',
  banner_8: 'Ukraynaca',
  banner_9: 'Kazakistan',
  brand_awareness_1: 'Marka Bilinirliği',
  brand_awareness_2: 've Kullanımı',
  brand_awareness_3:
    'İş başarısı için marka bilinirliği ve kullanım potansiyelinizi açığa çıkarın',
  brand_awareness_4: 'Bir uzmana danışın',
  brand_awareness_5: 'Hakkında',
  brand_awareness_6:
    '<b>Markanızın</b> tanınma ve aşinalık derecesini değerlendirin',
  brand_awareness_7:
    '<b>Hedef pazarınızda</b> marka bilinirliğinin seviyesini belirleyin',
  brand_awareness_8: '<b>Koruma ve sadakat oranlarını</b> yakından izleyin',
  brand_awareness_9:
    '<b>Gerekli göstergeleri iyileştirmek</b> için en uygun stratejiyi seçin',
  brand_awareness_10: 'Çözümlerimizle birçok fırsatı keşfedin',
  brand_awareness_11: 'Marka Bilinirliği',
  brand_awareness_12: 'Marka Kullanımı',
  brand_awareness_13:
    '<b>Marka bilinirliğinizi</b> tüketici segmentlerinde keşfedin',
  brand_awareness_14: '<b>Hedef kitlenizdeki bilinirliği</b> izleyin',
  brand_awareness_15:
    '<b>Alım öncesi</b> tüketicilerin spontan düşüncelerini inceleyin',
  brand_awareness_16:
    '<b>Marka bilinirliğine</b> katkıda bulunan ana kaynakları anlayın',
  brand_awareness_17:
    '<b>Markanızın ürün veya hizmetlerini deneyimleyen</b> tüketici sayısını değerlendirin',
  brand_awareness_18:
    '<b>İlk deneyimden sonra markanıza bağlı kalan</b> tüketicileri belirleyin',
  brand_awareness_19: '<b>Markanızın önerilme olasılığını</b> açığa çıkarın',
  brand_awareness_20:
    '<b>Gelecekte markanızı kullanmayı düşünen</b> tüketicilerin yüzdesini ortaya çıkarın',
  brand_awareness_21: 'Marka Bilinirliği ve Kullanımından kimler faydalanır?',
  brand_awareness_22: 'Yeni ürün piyasaya süren işletmeler',
  brand_awareness_23: 'Mevcut markayı canlandıran işletmeler',
  brand_awareness_24:
    'Markalarının tüketiciler tarafından nasıl tanındığını ve kullanıldığını anlamak ve geliştirmek isteyen tüm işletmeler',
  brand_awareness_25:
    'Metodolojilerimiz, marka bilinirliğini ve kullanımını optimize etmek için değerli bilgiler sağlar',
  brand_awareness_26:
    'Metodoloji, müşterinin talebine göre bireysel olarak seçilir',
  brand_awareness_27: 'Marka kullanım hunisi metodolojisi',
  brand_awareness_28:
    'Deneme oranı, hedef kitlenin markayı tanıma ve ürün/hizmetlerini deneme oranını gösterir.',
  brand_awareness_29:
    'Tekrar kullanım oranı, markayı tanıyan ve ürün/hizmetlerini deneyen kitlenin son 12 ay içinde satın alma veya kullanmaya devam eden yüzdesini gösterir.',
  brand_awareness_30:
    'Sadakat oranı, markanın ürün veya hizmetlerini sürekli kullanan bireylerin oranını gösterir ve son 6 ay içinde bu ürünlerle etkileşimde bulunan yüzdesini ortaya koyar.',
  brand_awareness_31:
    'Sadakat oranı, son 6 ayda markanın ürün/hizmetlerini kullanan müşterilerin zaman içinde markayı tercih etmeye ve bağlılık göstermeye devam eden yüzdesini gösterir.',
  brand_awareness_32: 'Marka bilinirliği metodolojisi',
  brand_awareness_33:
    'Top of mind (TOM), katılımcının spontan olarak ilk söylediği markayı temsil eder.',
  brand_awareness_34:
    'Toplam spontan bilinirlik, TOM dahil olmak üzere toplam spontan bahsini ifade eder.',
  brand_awareness_35:
    'Yönlendirilmiş bilinirlik, kullanıcıların yönlendirmeyle markanızı ne kadar tanıdığını gösterir.',
  brand_awareness_36: 'Marka özellik performans haritası',
  brand_awareness_37:
    'Bu araç, farklı marka özelliklerinin önemini değerlendirir ve görsel olarak sunar, her birinin marka performansına ve tüketici algısına katkısını gösterir.',
  brand_awareness_38:
    'Kapsamlı analizimizle markanızın etkisini artırmanın anahtarlarını keşfedin.',
  brand_awareness_39: 'Marka algı haritası',
  brand_awareness_40:
    'Bu araç, rekabetçi bir pazarda tüketici algılarının görsel temsilini sunar. Bu yaklaşım, markalar arasındaki farkları net bir şekilde belirlemek ve önemli pazar özelliklerini vurgulamak için kritik öneme sahiptir.',
  brand_awareness_41:
    'Markalar ve tanımlayıcı özellikler arasındaki ilişkilerin gözlemlenmesini ve yorumlanmasını kolaylaştırır.',
  brand_awareness_42:
    'Belirli bir markanın belirli özelliklere yakınlığı, bu özelliklerle güçlü bir ilişki içinde olduğunu gösterir. Benzer şekilde, iki marka arasındaki yakınlık, benzerliklerini ve paylaşılan imajları, dolayısıyla aynı pazar segmentindeki bağlantıyı gösterir.',
  consumer_journey_map_1: 'Tüketici Yolculuğu Haritası',
  consumer_journey_map_2:
    'Tüketici Yolculuğu Haritamızla işinizdeki engelleri keşfedin ve aşın',
  consumer_journey_map_3: 'GÜVENİLİR',
  consumer_journey_map_4: '4Service',
  consumer_journey_map_5:
    'CJM’nin potansiyelini açığa çıkararak tüketicileriniz ile markanız arasındaki etkileşimleri optimize edin',
  consumer_journey_map_6:
    'Tüketicinin bir ürün satın almadan önce attığı adımları belirleyin',
  consumer_journey_map_7:
    'Hayali değil, gerçek müşterilerinizden içgörüler edinin',
  consumer_journey_map_8:
    'Müşterilerinizin deneyimlerini kapsamlı bir şekilde anlayın',
  consumer_journey_map_9:
    'Kaçırılan fırsatları belirleyin ve rakiplerinizle karşılaştırın',
  consumer_journey_map_10: 'CJM yaklaşımımızı keşfedin',
  consumer_journey_map_11:
    'Tüketici etkileşim yolunu bir ürün, hizmet, şirket veya marka ile çeşitli kanallar ve belirli bir zaman dilimi boyunca oluşturuyoruz.',
  consumer_journey_map_12:
    'Tüketicilerinizin satın alma işlemini tamamlamadan önce geçtikleri aşamaları, her aşamadaki müşteri beklentilerini, duygularını ve motivasyonlarını özetliyoruz.',
  consumer_journey_map_13: 'Bizimle kazanın',
  consumer_journey_map_14:
    'Küresel iş başarısının inceliklerini anlayan deneyimli bir profesyonel ekibi sunuyoruz',
  consumer_journey_map_15:
    'Beklentilerinizi aşan sonuçlar sunmaya kendimizi adadık',
  consumer_journey_map_16:
    'Büyümenize katkıda bulunan karmaşık çözümler keşfediyoruz',
  consumer_journey_map_17: 'Özelleştirilmiş CJM çözümleri sunmada uzmanız',
  consumer_journey_map_18: 'Danışmanlık rezervasyonu yapın',
  consumer_journey_map_19: 'Veri odaklı kararlar',
  consumer_journey_map_20:
    'Kararlarınızı varsayımlara değil, gerçek verilere dayandırın',
  consumer_journey_map_21: 'CJM’nizi optimize edin',
  consumer_journey_map_22:
    'Müşterilerinizin ihtiyaç ve beklentilerini her aşamada ele alarak daha güçlü ilişkiler kurun',
  consumer_journey_map_23: 'Öncülük edin',
  consumer_journey_map_24:
    'Kendinizi rakiplerinizle karşılaştırın ve pazarda önde kalın',
  consumer_journey_map_25: 'Öneriler',
  consumer_journey_map_26:
    'Başarıyı açığa çıkarmak, müşteri sadakatini artırmak, satışları artırmak ve iş potansiyelinizi maksimize etmek için CJM önerilerimizi uygulayın',
  consumer_journey_map_27:
    'Gerçek tüketici yolculuğunu Tüketici Yolculuğu Haritamız ile keşfedin',
  consumer_journey_map_28:
    '20+ yıllık deneyime sahip uzmanlar kapsamlı bir araştırma sunar',
  consumer_journey_map_29:
    'Nitel araştırma, kavramları, görüşleri veya deneyimleri anlamak için sayısal olmayan verilerin toplanması ve analizini içerir.',
  consumer_journey_map_30:
    'Nicel araştırma yöntemleri, anketler, soru formları ve anketler aracılığıyla elde edilen verilerin nesnel ölçüm ve sayısal analizini içerir.',
  consumer_journey_map_31:
    'Veriler toplandıktan sonra uzmanlar bilgileri analiz eder ve size en iyi önerileri sunmak için sonuçlar çıkarır.',
  boarding_1: 'Tüketici yolculuğu haritası',
  boarding_2:
    'Müşteri Yolculuğu Haritalama (CJM), hedef kitleyi tanımlamak, ihtiyaçlarını ve ortamlarını anlamak ve ardından etkileyici bir deneyim sunmak için bir plan oluşturmayı kapsar',
  boarding_3: 'Net Promoter Skoru',
  boarding_4:
    'Net Promoter Skoru (NPS), müşteri deneyimi metriklerinin altın standardıdır ve tek bir soruya dayanır: Organizasyon/Ürün/Hizmeti ne kadar tavsiye edersiniz?',
  boarding_5: 'Marka Sağlık Takibi',
  boarding_6:
    'Marka Sağlık Takibi (BHT) araştırması, markanızın farkındalık ve kullanım, marka konumlandırması ve marka performansını ölçebilir',
  boarding_7: 'İnsan Kaynakları Araştırması',
  boarding_8:
    'İnsan Kaynakları Araştırması, İK uygulamalarını ve performansını değerlendirmek ve mevcut gelişim ve yönetim üzerinde detaylı analiz sunmak için kullanılır',
  boarding_9: 'UX testi',
  boarding_10:
    'Kullanılabilirlik (UX) testi, gerçek kişilerin bir web sitesi, uygulama veya diğer ürünlerle nasıl etkileşimde bulunduğunu ve davranışlarını ve tepkilerini gözlemlemeyi içerir',
  boarding_11: 'Müşteri memnuniyeti indeksi',
  boarding_12:
    'Müşteri memnuniyeti, müşterinin bir ürün veya hizmet satın alırken beklentilerinin ne ölçüde karşılandığını ölçer',
  boarding_13: 'Reklam testi',
  boarding_14:
    'Bir reklam kampanyası büyük bir yatırımdır. Reklamlarınızın güçlü olduğundan ve maksimum yatırım getirisini sağladığından emin olun',
  boarding_15: 'Saha denetimi/Perakende denetimi',
  boarding_16:
    'Mağazanız veya markanız hakkında detaylı veri toplayın, büyüme engellerini analiz edin ve bunları aşmak için etkili stratejiler oluşturun',
  boarding_17: 'Play4Sales',
  boarding_18:
    'Performans Yönetim Yazılımı. Satışı artırmak için oyunlaştırılmış uygulama',
  boarding_19: 'Voicer',
  boarding_20:
    'Geri Bildirim Yönetim Sistemi. Müşterinizin sesi tek bir sistemde. Müşteri Geri Bildirim Yönetim Sistemi',
  boarding_21: 'Nitel araştırma',
  boarding_22:
    'Nitel araştırma, kavramları, görüşleri veya deneyimleri anlamak için sayısal olmayan verilerin toplanması ve analizidir',
  boarding_23: 'Nicel araştırma',
  boarding_24:
    'Nicel araştırma yöntemleri, anketler, soru formları ve anketler aracılığıyla elde edilen verilerin nesnel ölçümü ve sayısal analizidir',
  boarding_25: 'Mystery Shopping',
  boarding_26:
    'Mystery shopping, müşteri ile bir şirket veya organizasyon arasındaki etkileşimleri önceden belirlenmiş bir senaryo sırasında ölçmek ve izlemek için kullanılan bir pazar araştırması tekniğidir',
  boarding_27: 'Wantent',
  boarding_28:
    'Hedef kitleden içgörü sağlayan yapay zekâ destekli bir içerik istihbarat platformu',
  boarding_29: 'Fiyat takibi',
  boarding_30:
    'Fiyat takibi, rakiplerin fiyatlarının toplanması, işlenmesi ve analiz edilmesi sürecidir',
  boarding_31: 'Hizmet tasarımı',
  boarding_32:
    'Hizmet tasarımı, bir ürün veya hizmeti kullanacak kişilerin ihtiyaçlarını ve isteklerini anlamak için onlarla zaman geçirmeyi kapsar',
  boarding_33: 'Otomotiv Sektörü Fiyat Analizi',
  boarding_34:
    'Rekabetçi fiyat analizi, tüketicinin ödeme istekliliği verilerini kullanarak teklifler optimize eder, kârı artırır ve pazar payını yükseltir',
  boarding_35: 'Facility Check Denetimi',
  boarding_36:
    'Perakende noktalarınızın marka standartlarına uygun olmasını sağlar, fiziksel özellikleri ve bunların müşteri algısına etkisini değerlendirir',
  boarding_37: 'CX çözümü',
  boarding_38:
    'Benzersiz 360 derece CX çözümümüzü keşfedin: İşinizi ilerletmek için hedeflerinize göre araçları ve hizmetleri özelleştiriyoruz',
  boarding_39: 'Konuşma analitiği',
  boarding_40:
    'Gelişmiş konuşma analitiği aracımız, konuşulan dili metne çevirir ve işletmelerin müşteri deneyimlerini artırmasına, performansı izlemesine, uyumu sağlamasına ve büyümeyi yönlendirmesine olanak tanıyan değerli içgörüler sunar',
  boarding_41: 'Kullanım ve Tutum',
  boarding_42:
    'Kullanım ve Tutum, hedef kitlenizin markanızla nasıl etkileşimde bulunduğunu anlamak için pratik kullanım kalıplarını ve psikolojik tutumları analiz eden yaklaşımımızdır; bu, özelleştirilmiş pazarlama ve ürün stratejileri geliştirmeyi sağlar',
  boarding_43: 'Marka Bilinirliği ve Kullanımı',
  boarding_44:
    'Marka Bilinirliği ve Kullanımı, hedef pazarınızda tanınırlık, aşinalık, etkileşim sıklığı ve müşteri bağlılığını değerlendirerek marka görünürlüğünü ve katılımını artırmayı içerir',
  boarding_45: 'Marka Kimliği ve Konumlandırma',
  boarding_46:
    'Marka Kimliği ve Konumlandırma, tüketici algılarını, farklı kitle görüşlerini ve markanızın nasıl algılandığına dair içgörüleri ortaya çıkaran kapsamlı bir analizdir',
  boarding_47: 'Müşteri Profilleme ve Segmentasyon',
  boarding_48:
    'Müşteri Profilleme ve Segmentasyon, hedef pazarınızı paylaşılan özelliklere göre farklı gruplara ayırmayı ve belirli kitle segmentlerine hitap eden kişiselleştirilmiş stratejiler oluşturmayı içerir',
  boarding_49: 'Tüketici Yolculuğu Haritası',
  boarding_50:
    'Tüketici Yolculuğu Haritası, bir tüketicinin ürününüz veya markanızla etkileşimleri boyunca deneyimlediği aşamaları, temas noktalarını, duyguları ve motivasyonları görsel olarak temsil eder',
  boarding_51:
    'İşiniz için uygulanabilir içgörüler sağlama ve etkili sonuçlar elde etme taahhüdümüzü destekleyen yenilikçi teknikleri öğrenin',
  boarding_52:
    'Sektörünüze uyarlanmış veri odaklı zenginlik sunan ürün yelpazemizi keşfedin, bilinçli kararlar almanızı ve rekabette önde olmanızı sağlar',
  boarding_53:
    'Kapsamlı pazar araştırması çözümlerimizle piyasa trendlerini, tüketici davranışlarını ve rekabet ortamlarını derinlemesine inceleyin',
  boarding_54: 'Özel Araştırma',
  boarding_55:
    'Özel Araştırma, belirli bir sorunu ele almak için tasarlanmış özelleştirilmiş bir yaklaşımdır; mevcut metodolojilerin bir karışımı veya yeni bir yaklaşım kullanarak özel bir çözüm oluşturur.',
  boarding_56: 'Sosyolojik Araştırma',
  boarding_57:
    'Sosyolojik Araştırma, insan davranışları ve sosyal etkileşim kalıplarını ortaya çıkarır; yenilikçi stratejiler geliştirmek ve hedef kitlelerle anlamlı bağlantılar kurmak için değerli içgörüler sunar.',
  not_found_1: 'Hoppala! Bu sayfayı bulamıyoruz.',
  not_found_2: 'Neden ürünlerimizi incelemiyorsunuz?',
  not_found_3: 'Danışmanlık rezervasyonu yap',
  customer_profiling_segmentation_1: 'Müşteri Profilleme ve Segmentasyon',
  customer_profiling_segmentation_2:
    'Hedef kitlenizi belirlemenize yardımcı oluyoruz, böylece stratejiniz daha etkili hale gelir',
  customer_profiling_segmentation_3:
    'Mesajlarınızın her zaman hedef tüketici gruplarına etkili bir şekilde ulaşmasını sağlamak için pazar segmentasyonunun gücünü kullanın',
  customer_profiling_segmentation_4: 'Tüketicileri daha derinlemesine anlayın',
  customer_profiling_segmentation_5: 'Ürününüz için en iyi hedef kitleyi bulun',
  customer_profiling_segmentation_6: 'Çekmek için yeni segmentleri keşfedin',
  customer_profiling_segmentation_7: 'Satın alma engellerini keşfedin',
  customer_profiling_segmentation_8:
    'Özelleştirilmiş segmentasyon çözümleri sunmada uzmanız',
  customer_profiling_segmentation_9: 'Benzersiz yaklaşım',
  customer_profiling_segmentation_10:
    'İhtiyaçlarınıza özel olarak hazırlanmış benzersiz, kişiye özel segmentasyon çözümünü deneyimleyin',
  customer_profiling_segmentation_11: 'Hedef Kişilikler',
  customer_profiling_segmentation_12:
    'Derin pazar analizi ve kapsamlı araştırmaya dayalı hazırlanmış Hedef Kişilikler',
  customer_profiling_segmentation_13: 'Yeni segmentler',
  customer_profiling_segmentation_14:
    'En değerli kitle segmentlerinizi belirleyin ve hedeflemeyi kişiselleştirmenin avantajlarını açığa çıkarın',
  customer_profiling_segmentation_15: 'Öneriler',
  customer_profiling_segmentation_16:
    'Önerilerimizi uygulayın; başarıyı açığa çıkarın, müşteri sadakatini artırın, satışları yükseltin ve iş potansiyelinizi maksimize edin',
  customer_profiling_segmentation_17:
    '20+ yıllık deneyime sahip uzmanlar kapsamlı bir araştırma sunar',
  customer_profiling_segmentation_18:
    'Nitel araştırma, kavramları, görüşleri veya deneyimleri anlamak için sayısal olmayan verilerin toplanması ve analizini içerir.',
  customer_profiling_segmentation_19:
    'Nicel araştırma yöntemleri, anketler, soru formları ve anketler aracılığıyla elde edilen verilerin nesnel ölçüm ve sayısal analizini içerir.',
  customer_profiling_segmentation_20:
    'Veriler toplandıktan sonra uzmanlar bilgileri analiz eder ve size en iyi önerileri sunmak için sonuçlar çıkarır.',
  customer_profiling_segmentation_21:
    'Sadece ölçümler yapmıyoruz, aynı zamanda net adım adım eylemlerle bir eylem planı da sunuyoruz',
  customer_profiling_segmentation_22: 'Metodolojimiz',
  customer_profiling_segmentation_23: 'Jaccard İndeksi',
  customer_profiling_segmentation_24:
    'Katılımcılara doğrudan sorulduğunda, şirket tercihleri hakkındaki cevapları gerçek davranışlarıyla örtüşmeyebilir. Doğrudan sorgulama yerine, şirket özellikleri ile tüketici tercihi arasındaki ilişkiyi anlamak için istatistiksel Jaccard analizini kullanıyoruz.',
  customer_profiling_segmentation_25: 'Etkileyen Faktörler',
  customer_profiling_segmentation_26:
    'Belirli bir sonucu etkileyen faktörleri (drivers) tanımlar ve önemlerine göre ana, orta ve önemsiz olarak kategorize ederiz.',
  customer_profiling_segmentation_27: 'Segmentasyon',
  customer_profiling_segmentation_28:
    'Müşteri tercihleriyle ilgili net özelliklere sahip segmentasyon elde edersiniz.',
  customer_profiling_segmentation_29: 'Segmentasyon yaklaşımımız',
  customer_profiling_segmentation_30: 'Demografik',
  customer_profiling_segmentation_31: 'yaş',
  customer_profiling_segmentation_32: 'cinsiyet',
  customer_profiling_segmentation_33: 'gelir',
  customer_profiling_segmentation_34:
    'Ürünleri, hizmetleri ve pazarlamayı belirli gruplara uyarlayarak alaka düzeyi ve etkinliği artırır',
  customer_profiling_segmentation_35: 'Psikografik',
  customer_profiling_segmentation_36: 'yaşam tarzı',
  customer_profiling_segmentation_37: 'değerler',
  customer_profiling_segmentation_38: 'davranışlar',
  customer_profiling_segmentation_39:
    'Kişiselleştirilmiş pazarlama, müşteri ile derin bağlantılar ve şirket için artan sadakat ve satış sağlar',
  customer_profiling_segmentation_40: 'Davranışsal',
  customer_profiling_segmentation_41: 'eylemler',
  customer_profiling_segmentation_42: 'motivasyon',
  customer_profiling_segmentation_43: 'satın alma sıklığı',
  customer_profiling_segmentation_44:
    'Hedeflenmiş pazarlama, artan müşteri memnuniyeti, daha yüksek bağlılık ve şirketin kârlılığını artırır',
  customer_profiling_segmentation_45: 'Coğrafi',
  customer_profiling_segmentation_46: 'konum',
  customer_profiling_segmentation_47:
    'Hedeflenmiş pazarlama, özelleştirilmiş ürünler, etkin dağıtım ve şirketin pazar penetrasyonunu artırmayı sağlar.',
  brands_identity_1: 'Marka kimliği ve konumlandırma',
  brands_identity_2:
    'Tüketici algılarına dair içgörüleri ortaya çıkaran ve stratejinizi başarıya dönüştüren derinlemesine analizimizle markanızı dönüştürün',
  brands_identity_3: 'Bir uzmana danışın',
  brands_identity_4: '<b>Kapsamlı bir</b> marka kimliği analizini keşfedin',
  brands_identity_5:
    '<b>Tüketici algılarından</b> elde edilen içgörüleri inceleyin',
  brands_identity_6: '<b>Çeşitli</b> hedef kitle görüşlerini anlayın',
  brands_identity_7:
    '<b>Tüketici davranışları, alışkanlıklar ve tercihleri</b> hakkında bilinçli kararlar almak için içgörüler edinin',
  brands_identity_8:
    '20 yılı aşkın müşteri deneyimine sahip 4Service uzmanları, işinizi büyütmeye yardımcı olan benzersiz çözümler yaratır',
  brands_identity_9:
    '<b>Tüm gerekli verilerle donatılmış bir araştırma paketine erişiminiz olacak.</b> Bu, güçlü ve dikkat gerektiren alanları vurgulayan bir teşhis aracıdır',
  brands_identity_10:
    '<b>Hizmetlerimiz işletmelere</b> bilinçli kararlar alma, stratejileri geliştirme ve kendi sektörlerinde başarı sağlama için gerekli araçları sunar.',
  brands_identity_11: 'Rekabetçi pazarda markanızın konumunu artırmak için',
  brands_identity_12: 'Pazar varlığını artırmaya çalışan işletmeler',
  brands_identity_13: 'Stratejilerini yükseltmek isteyen işletmeler',
  brands_identity_14: 'Marka Kimliği',
  brands_identity_15: 'Marka Konumlandırması',
  brands_identity_16:
    '<b>Tüketici segmentleri arasındaki</b> markanızın algısını ortaya çıkarın.',
  brands_identity_17:
    '<b>Markanıza ve rakiplerinize atfedilen nitelikleri</b> belirleyin.',
  brands_identity_18:
    '<b>Güçlü ve zayıf yönleri</b> stratejik iyileştirme için değerlendirin.',
  brands_identity_19:
    '<b>Marka imajınızın</b> tanıtılan değerlerle uyumunu değerlendirin.',
  brands_identity_20:
    '<b>Markanızın</b> algılanan güvenilirliğini değerlendirin.',
  brands_identity_21:
    '<b>Markanızın arketipsel</b> ve sembolik algısını keşfedin.',
  brands_identity_22:
    '<b>Markanızın</b> rakiplerle karşılaştırıldığında benzersiz satış noktalarını ve farklılaştırıcı özelliklerini belirleyin.',
  brands_identity_23:
    '<b>Tüketicilerin ürün/hizmet satın alma olasılığını etkileyen</b> ana özellikleri belirleyin.',
  brands_identity_24:
    '<b>Markanızın tüketicilerin zihninde nasıl konumlandığını</b> belirleyin ve istenen pazar segmentlerini çekmek için hangi yönleri iletmeniz gerektiğini tespit edin.',
  brands_identity_25:
    'Metodoloji, müşterinin talebine göre bireysel olarak seçilir',
  brands_identity_26: 'Marka Bilinirliği ve Kullanımı',
  brands_identity_27:
    'Marka seviyesinin değerlendirilmesi, farkındalık ve kullanım seviyelerinin ölçülmesini içerir ve değerlendirmede temel bir bileşen olarak hizmet eder.',
  brands_identity_28: 'Marka Teslimatı ve Güven',
  brands_identity_29:
    'Bu ölçüt, müşteri savunuculuğunu (tavsiye) ve markanın sözlerini tutma, olumlu müşteri deneyimi yaratma ve güven inşa etme konusundaki sürekli yeteneğini değerlendirir.',
  brands_identity_30: 'Marka İmajı Performansı',
  brands_identity_31:
    'Markanın performansını değerlendirmek, altı kritik değerle (3 rasyonel ve 3 duygusal) ilişkisini, kategori içindeki farklılığını ve tüketicilerde gurur uyandırma kapasitesini analiz etmeyi içerir.',
  brands_identity_32: 'Marka Sağlığı Skoru',
  brands_identity_33:
    'Marka Sağlığı Skoru, markanızın rekabet ortamında nasıl performans gösterdiğine dair kapsamlı bir anlayış sunar.',
  sociological_research_1: 'Sosyolojik Araştırma',
  sociological_research_2:
    'Sosyal olgular ve süreçler üzerine derinlemesine analiz gerçekleştiriyoruz; benzersiz analitik sonuçlar ve öneriler sayesinde bilinçli kararlar alınmasına yardımcı olur',
  sociological_research_3: 'Bizimle iletişime geçin',
  sociological_research_4: 'Müşterilerimiz',
  sociological_research_5: 'CAWI',
  sociological_research_6:
    'CATI - telefonla anketler yapmak için bilgisayar kullanan bir veri toplama yöntemidir. CATI yazılımı, veri toplama, yanıt giriş ve anket yönetimi süreçlerini otomatikleştirmenizi sağlar. CATI kullanımı, anketi kontrol etmeyi kolaylaştırır, verileri hızlı bir şekilde analiz ve işlemeyi mümkün kılar ve yüksek düzeyde standartizasyon sağlar.',
  sociological_research_7: 'CATI',
  sociological_research_8:
    'CAWI - katılımcıların web arayüzü üzerinden anket doldurduğu veya soruları yanıtladığı bir veri toplama yöntemidir ve veriler özel yazılımlar kullanılarak otomatik olarak toplanır ve işlenir. CAWI yöntemi, geniş çaplı anketler yapmayı ve verileri hızlı bir şekilde toplamayı ve analiz etmeyi sağlar.',
  sociological_research_9: 'CAPI',
  sociological_research_10:
    'CAPI - yüz yüze anketler için kullanılan bir veri toplama yöntemidir; araştırmacı, katılımcı yanıtlarını tablet veya cep telefonu ile girer, bu da otomatik veri toplama, giriş hatalarını azaltma ve sonuçların analizini kolaylaştırma sağlar.',
  sociological_research_11: 'Uzmanlarımız çeşitli araçlar kullanır',
  sociological_research_12: 'Örneklem',
  sociological_research_13:
    'Her türlü karmaşıklıkta örneklem hesaplar ve uygularız',
  sociological_research_14:
    'Çalışmamızda basit, sistematik, tabakalı ve küme örneklemeler kullanıyoruz',
  sociological_research_15:
    'Ulusal temsili yüz yüze anketler için tabakalı çok aşamalı örneklem prosedürleri uygularız',
  sociological_research_16:
    'Yerleşimlerin bölgelere göre seçimi, yerleşim türü ve büyüklüğüne göre yapılır ve her bölgede hacimlerine orantılı olarak belirlenir',
  sociological_research_17: 'Gerçekleştiriyoruz',
  sociological_research_18: 'Kamuoyu araştırması',
  sociological_research_19: 'Sosyo-ekonomik araştırma',
  sociological_research_20: 'Masa başı araştırma',
  sociological_research_21: 'Sosyal hizmetlerin kalitesinin değerlendirilmesi',
  sociological_research_22: 'Vaka çalışması',
  sociological_research_23: 'Personel araştırması',
  sociological_research_24:
    'Belirli kitleler üzerine araştırma (savunmasız gruplar, göçmenler, askerler, gençler vb.)',
  sociological_research_25: 'Her müşteriyle bireysel olarak çalışıyoruz',
  sociological_research_26: 'Müşterilerimiz:',
  sociological_research_27: 'Hayırsever Vakıflar',
  sociological_research_28: 'Kamu kuruluşları ve birlikler',
  sociological_research_29: 'Devlet yapıları',
  sociological_research_30: 'Çalışma yaklaşımımız',
  sociological_research_31:
    'Çalışmalarımızda bilimsel yaklaşım ve mevcut durumu derinlemesine anlamayı, ayrıca veri toplamak için çeşitli araştırma yöntemlerini kullanıyoruz.',
  sociological_research_32:
    'Özel talebi karşılamak için gerekli deneyime sahip yüksek uzmanlı uzmanlar ile çalışıyoruz ve çeşitli alanlarda uzman havuzumuz bulunuyor.',
  sociological_research_33:
    'Dahili analiz departmanımız, toplanan verileri görevin özelliklerine bağlı olarak benzersiz bir araç seti kullanarak analiz eder.',
  sociological_research_34:
    'Hedef kitlenizin ihtiyaç ve beklentilerini göz önünde bulundurarak ayrıntılı sonuçlar ve öneriler içeren raporlar oluşturuyoruz.',
  sociological_research_35:
    'Önerilerin uygulanması sırasında danışmanlık ve destek sağlıyoruz, olumlu değişiklikler yapmanıza yardımcı oluyoruz.',
  sociological_research_36: 'TV üzerine araştırmalarımız',
  sociological_research_37: 'Raporlarımızı inceleyin',
  sociological_research_38:
    'Çalışmalarımıza bilimsel yaklaşımımız, müşterilerimize Ukrayna ve Avrupa genelinde minimal hata ile doğru ve güvenilir sosyolojik veriler sağlar',
  sociological_research_39:
    'Sosyolojik araştırmalar yaparken tüm etik ilke ve standartlara ve kurallara uyuyoruz.',
  sociological_research_40:
    'Ukrayna Sosyologlar Derneği Profesyonel Etik Kurallarına ve Helsinki Araştırma Etik İlkeleri Bildirisine bağlıyız. ESOMAR, Ukrayna Pazarlama Derneği, Ukrayna Tüm Ulusal İletişim Merkezleri Derneği üyesiyiz.',
  sociological_research_41: 'Saha',
  sociological_research_42: 'Çevrimiçi panel',
  sociological_research_43: 'Düzenli anketörler',
  sociological_research_44: 'Süpervizörler',
  sociological_research_45: 'Saha kalite kontrolü',
  sociological_research_46: 'GPS koordinatlarının %100 kaydı (CAPI)',
  sociological_research_47: 'Anketlerin doğrulanması (CAWI, CAPI, CATI, PAPI)',
  sociological_research_48: 'Mülakatların %100 kaydı (CAPI, CATI)',
  sociological_research_49: 'Lisanslı yazılım kullanıyoruz:',
  sociological_research_50:
    'İstatistiksel verileri analiz etmek ve veri setlerini işlemek için SPSS',
  sociological_research_51:
    'CAPI için DigSee Sure: anket mantığı, coğrafi konum, mülakatların ses kaydı, video materyal gösterimi',
  sociological_research_52:
    'CAWI için SurveyMonkey: anket mantığı, kullanışlı format, görselleştirme',
  sociological_research_53:
    'VoIPTime (iletişim merkezi): her türlü karmaşıklıkta anket programlaması, ses kayıtlarının müşteriye iletimi',
  sociological_research_54: 'Örneklem',
  sociological_research_55:
    'Her türlü karmaşıklıkta örneklem hesaplar ve uygularız',
  sociological_research_56:
    'Çalışmamızda basit, sistematik, tabakalı ve küme örneklemeler kullanıyoruz',
  sociological_research_57:
    'Ulusal temsili yüz yüze anketler için tabakalı çok aşamalı örneklem prosedürleri uygularız',
  sociological_research_58:
    'Yerleşimlerin bölgelere göre seçimi, yerleşim türü ve büyüklüğüne göre yapılır ve her bölgede hacimlerine orantılı olarak belirlenir',
  sociological_research_59: 'Ekip',
  sociological_research_60:
    'Sosyologlarımız Ukrayna Sosyologlar Derneği üyesidir',
  sociological_research_61:
    'Farklı sektörlerde hem nicel hem nitel projelerde deneyime sahip 12 tam zamanlı analistimiz var.',
  sociological_research_62:
    '10 yıldan fazla araştırma deneyimine sahip güçlü bir analitik profesyonel ekibimiz var. Bilim insanları, doktora sahipleri, MBI uzmanları bulunuyor.',
  sociological_research_63: 'Iryna Maksymiuk',
  sociological_research_64:
    'Araştırma Departmanı Başkanı. Pazarlama araştırmaları, tüm aşamalarda araştırma yönetimi, analitik rapor ve sunum hazırlama konularında 15+ yıl deneyim',
  sociological_research_65: 'Andriy Biloskursky',
  sociological_research_66:
    'Programlama ve Veri İşleme Başkanı. Pazarlama, sosyolojik ve pazar araştırmalarında 20 yıl deneyim',
  sociological_research_67: 'Olena Somova',
  sociological_research_68:
    'Programlama Uzmanı DonSUU Sosyoloji Yüksek Lisans öğrencisi. Pazarlama araştırmalarında 5 yıl deneyim. Demokratik Kadınlar İttifakı Yönetim Kurulu Üyesi, Fon Toplama Başkanı.',
  sociological_research_69: 'Anna Padalka',
  sociological_research_70:
    'Araştırma Departmanı Sosyolojik Araştırma Bölümü Başkanı, ulusal ve uluslararası düzeyde sosyolojik ve sosyal projelerde 13 yıl deneyim. Sosyoloji doktorası, Ukrayna İletişim Merkezleri Derneği Araştırma Komitesi Başkanı.',
  ad_hoc_1: 'Ad Hoc',
  ad_hoc_2: 'Özel durumlar için alternatif araştırmamızı keşfedin',
  ad_hoc_3: 'Bizimle iletişime geçin',
  ad_hoc_4: 'Yaklaşımımız',
  ad_hoc_5:
    'Uzman ekibimiz, toplanan verileri titizlikle analiz ederek büyümenize katkı sağlayacak karmaşık çözümler sunar.',
  ad_hoc_6:
    'Anketler, görüşmeler, odak grupları, veri analizi ve daha fazlası dahil çeşitli metodolojilerden yararlanarak, özel gereksinimlerinize uygun benzersiz bir araştırma tasarlıyoruz.',
  ad_hoc_7: 'Neden Ad Hoc Araştırma?',
  ad_hoc_8: 'Esneklik',
  ad_hoc_9:
    'Hiçbir iki araştırma projesi aynı değildir. Ad Hoc Araştırma ile benzersiz yaklaşımı gerektiğinde uyarlama ve geliştirme esnekliğine sahibiz, böylece bulgularınız her zaman geçerli ve uygulanabilir olur.',
  ad_hoc_10: 'Hassasiyet',
  ad_hoc_11:
    'Metodolojilerimizi benzersiz gereksinimlerinize göre uyarlayarak değerli içgörüler sağlayan doğru ve hedefli sonuçlar sunuyoruz.',
  ad_hoc_12: 'Yenilik',
  ad_hoc_13:
    'Araştırma sürecimizde yenilik ve yaratıcılığı benimseyerek, gizli fırsat ve zorlukları ortaya çıkarmak için yeni teknikler ve yaklaşımlar keşfediyoruz.',
  ad_hoc_14: 'Zamanında Uygulama',
  ad_hoc_15:
    'Ad Hoc Araştırma, kritik içgörülere hızlı erişim sağlar ve sektörünüzde önde olmanızı mümkün kılar.',
  ad_hoc_16: 'Uzmanlığımız',
  ad_hoc_17:
    '4Service uzmanları, 20+ yıllık pazar araştırması ve müşteri deneyimi tecrübesiyle işletmenizi büyütmeye yardımcı olan benzersiz çözümler yaratır',
  ad_hoc_18: 'Özel gereksinimlerinize göre farklı bir araç seti kullanıyoruz',
  ad_hoc_19: 'Hiçbir metodoloji sizin için uygun değil mi?',
  ad_hoc_20: 'Ad Hoc Araştırmayı Talep Edin',
  ad_hoc_21: 'Belirli bir konu için özel',
  ad_hoc_22:
    'Metodolojilerin farklı parçalarının bir karışımını veya tamamen yeni bir yaklaşımı kullanıyoruz',
  ad_hoc_23: 'Bireysel yaklaşım',
  ad_hoc_24: 'Çözümü doğrudan sorununuza göre titizlikle uyarlıyoruz',
  ad_hoc_25: 'Beklentilerinizi aşın',
  ad_hoc_26:
    'İşletmenizin hedeflerine ulaşmasına yardımcı olacak uygulanabilir öneriler içeren bir plan sunuyoruz',
  ad_hoc_27: 'Standart dışı bir sorununuz var',
  ad_hoc_28: 'Hiçbir metodoloji sorununuz için uygun değil',
  ad_hoc_29:
    'Farklı metodolojileri veya parçalarını aynı anda talep etmek istersiniz',
  ad_hoc_30: 'Ad Hoc araştırmadan kimler faydalanır?',
  service_design_1: 'Bazı müşterilerimiz',
  service_design_2: 'Hizmet Tasarımı',
  service_design_3:
    'İşletmenizi ürün ve satış odaklılıktan hizmet ve insan odaklılığa dönüştürün',
  service_design_4: 'Bir uzmana danışın',
  service_design_5: 'Ücretsiz öğrenin!',
  service_design_6:
    'Hizmet Tasarımı Kütüphanemizde pratik ve faydalı bilgiler topladık',
  service_design_7:
    'Kütüphane, her adımın ayrıntılı açıklamalarını, ilgili araç ve teknikleri, önemli detaylara dair ipuçlarını ve video gösterimleri içerir.',
  service_design_8: 'Kütüphaneye git',
  service_design_9: 'Hizmet Tasarımı ile fayda sağlayın!',
  service_design_10:
    'Hizmet Tasarımı, tüm hizmet ekosistemini — insanlar, süreçler ve temas noktaları — ele alarak hizmetleri yaratmayı ve iyileştirmeyi amaçlar, hem kullanıcı memnuniyetini hem operasyonel verimliliği artırır',
  service_design_11:
    'Hizmet tasarımı, bir kafeyi diğerine tercih etmenizin nedeni değildir. Ayrıca, bu yere tekrar tekrar gelmenizin ve tüm arkadaşlarınıza anlatmanızın nedenidir.',
  service_design_12: 'İşletmeler Hizmet Tasarımı ile nasıl fayda sağlar',
  service_design_13: 'Kullanıcı memnuniyeti',
  service_design_14:
    'Kullanıcıları memnun edecek sorunsuz, kişiselleştirilmiş deneyimler yaratın.',
  service_design_15: 'Operasyonel verimlilik',
  service_design_16:
    'Süreçleri optimize edin, maliyetleri düşürün ve hizmet sunumunu iyileştirin.',
  service_design_17: 'Marka tutarlılığı',
  service_design_18:
    'Tüm temas noktalarının markanın değerleri ile uyumlu olmasını sağlayın.',
  service_design_19: 'Değişikliklere uyum sağlama',
  service_design_20:
    'Değişen ihtiyaçlarla büyüyebilen ve evrilebilen hizmetler tasarlayın.',
  service_design_21: 'Sadakati artırma',
  service_design_22:
    'Olağanüstü hizmet deneyimleriyle güçlü müşteri ilişkileri kurun ve sadakati artırın.',
  service_design_23: 'Rekabet avantajı',
  service_design_24:
    'Pazarda benzersiz, akılda kalıcı hizmet deneyimleri ile öne çıkın.',
  service_design_25: 'Neden',
  service_design_26: 'Neden Hizmet Tasarımı?',
  service_design_27:
    'Bu, şirketlerin dünya çapında ürün ve satış odaklılıktan insan ihtiyaç ve sorunlarına odaklanmaya geçmesine yardımcı olan bir kültür, metodoloji ve düşünme şeklidir.',
  service_design_28: 'Hizmetlerimiz',
  service_design_29: 'Müşteri Hizmet Tasarımı',
  service_design_30:
    'Yeni ürünler yaratmak veya mevcut ürünleri geliştirmek için müşteri odaklı projeler geliştiriyor ve uyguluyoruz. Ayrıca, bu değişikliklerle gelecekte bağımsız çalışmak için eğitimler sağlıyoruz.',
  service_design_31: 'Çalışan hizmet tasarımı',
  service_design_32:
    'Çalışan odaklı süreçler, yapılar ve değişiklikleri geliştirmek ve uygulamak için pratik bir kurs.',
  service_design_33: 'Gelecek tasarım düşüncesi',
  service_design_34:
    'Farklı senaryolar ve olası yenilikleri dikkate alarak gelecek kavramları ve şirket stratejilerinin geliştirilmesi.',
  service_design_35: 'İşletmede yaratıcılık',
  service_design_36:
    'Katılımcıların yaratıcılığı kullanarak belirli sorunları çözmesine ve benzersiz pazar çözümleri geliştirmesine yardımcı olan pratik eğitim.',
  service_design_37: 'Atölyelerimiz',
  service_design_38:
    'Katılımcılarımız için dünya çapında tanınan sertifikalı pratik atölyeler sunuyoruz',
  service_design_39: 'Beklentilerin ötesinde ürün, hizmet ve tesisler yaratın',
  service_design_40: 'İşleyen iş süreçlerini uygulayın',
  service_design_41:
    'Şirket çalışanları ve müşteriler arasındaki ilişkiyi uyumlu hale getirin',
  service_design_42: 'Takvim',
  service_design_43: 'Yakında',
  service_design_44: 'Önceki etkinliklerimiz hakkında daha fazla bilgi edinin',
  service_design_45: 'Hizmet Tasarımının Temelleri',
  service_design_46: 'Beklentilerin ötesinde ürün, hizmet ve tesisler yaratın',
  service_design_47: 'EX Hizmet Tasarımı',
  service_design_48: 'Beklentilerin ötesinde ürün, hizmet ve tesisler yaratın',
  service_design_49: 'Daha fazla',
  service_design_50: 'Yaklaşımımız',
  service_design_51: '4Service, insan odaklı hizmetiniz için omurgadır!',
  service_design_52:
    'Şirketlerin gerekli zihniyeti geliştirmesine ve insan odaklı bir iç ortam yaratmasına yardımcı oluyoruz.',
  service_design_53: 'Araçlar',
  service_design_54:
    'Özel gereksinimlerinize göre farklı teknikler ve araçlar kullanıyoruz',
  service_design_55: 'Kullanıcı Araştırması',
  service_design_56:
    'Kullanıcı ihtiyaç ve davranışlarını anlamak için görüşmeler, anketler, yüz yüze çalışmalar, etnografik çalışmalar',
  service_design_57: 'Personalar',
  service_design_58:
    'Tasarım kararlarını yönlendirmek için farklı kullanıcı türlerini temsil eden kurgu karakterler',
  service_design_59: 'Müşteri Yolculuk Haritaları',
  service_design_60:
    'Hizmet boyunca kullanıcı deneyiminin görsel temsilleri, ana temas noktalarını ve sorunlu noktaları belirleme',
  service_design_61: 'Beyin fırtınası oturumları',
  service_design_62:
    'Fikir ve çözüm üretmek için paydaşlarla işbirliği oturumları.',
  service_design_63: 'Prototipleme',
  service_design_64:
    'Hizmetin kavramlarını test etmek ve geliştirmek için ön sürümler oluşturma',
  service_design_65: 'Hizmet Mavi Baskıları',
  service_design_66:
    'Farklı hizmet bileşenleri ve süreçler arasındaki ilişkileri gösteren ayrıntılı diyagramlar',
  service_design_67: 'Ortak',
  service_design_68: '4Service & DTA',
  service_design_69:
    '4Service, Tasarım Düşüncesi Akademisi’nin resmi münhasır temsilcisidir',
  service_design_70: 'Ortaklığımız kapsamında:',
  service_design_71:
    '<b>önemli uzmanlar tarafından atölyelerde</b> hizmet tasarımı yöntemiyle pratik eğitimler sağlıyoruz;',
  service_design_72:
    '<b>sertifikalı</b> tasarım düşüncesi uzmanları yetiştiriyoruz;',
  service_design_73:
    '<b>hizmet tasarımı</b> projelerini uluslararası kolaylaştırıcılarla birçok şirket için uyguluyoruz.',
  service_design_74: 'Mükemmeliyet Hizmet Tasarımı Merkezlerini kurduk:',
  service_design_75: 'Ukrayna',
  service_design_76: 'Kazakistan',
  service_design_77: 'Türkiye',
  service_design_78: 'Gürcistan',
  service_design_79: 'Azerbaycan',
  service_design_80: 'Vaka çalışmalarımız hakkında daha fazla bilgi edinin',
  service_design_81: 'Kütüphaneye git',
  service_design_82: 'Hizmet Tasarımına Hoş Geldiniz!',
  four_opinion_1: '4Service tarafından anket',
  four_opinion_2: 'Çevrimiçi anketlere katılarak evden çıkmadan kazanın',
  four_opinion_3: 'Başla',
  four_opinion_4: 'Avantajlarımız',
  four_opinion_5: 'Bize güveniliyor',
  four_opinion_6:
    'Topluluğumuz Ukrayna’da 90.000’den fazla, Kazakistan’da 100.000 tüketiciyi içeriyor',
  four_opinion_7: 'Zamanınızı adil şekilde değerliyoruz',
  four_opinion_8:
    'Anketlere katılımınız için hediye veya nakit ödül alma fırsatına sahipsiniz',
  four_opinion_9: 'Görüşleriniz önemli bir etkiye sahip',
  four_opinion_10:
    'Her yorum, markaların müşterilerini daha iyi anlamasına yardımcı olur',
  four_opinion_11:
    '4Service’in 4Opinion platformunda anketlere katılın ve çevrimiçi kazanın veya ödül kazanın',
  four_opinion_12: '4Opinion’a katılın',
  four_opinion_13: 'Kanalımızda daha ilginç hikayeler',
  four_opinion_14: 'Ukrayna için daha fazla detay',
  four_opinion_15: 'Kazakistan için daha fazla detay',
  four_opinion_16: 'Neden bizi seçmelisiniz?',
  four_opinion_17:
    '4Service, müşteri deneyimi yönetiminde uzmanlaşmış uluslararası bir araştırma holding şirketidir',
  four_opinion_18:
    'Müşteri deneyimi yönetiminde Avrupa’nın ilk 10 ajansı arasında yer alıyoruz',
  four_opinion_19:
    'Misyonumuz, dünya çapında müşteri hizmetlerini iyileştirmektir!',
  four_opinion_20: 'Çevrimiçi anketlerden nasıl kazanç sağlanır?',
  four_opinion_21: 'Web sitesinde kayıt olun',
  four_opinion_22: 'Mevcut anketler hakkında bildirim alın',
  four_opinion_23: 'Anketleri tamamlayın ve kazanın',
  four_opinion_24: 'Katılımcılarımızdan gerçek yorumlar',
  four_opinion_25: 'Vitaliy Kokhan',
  four_opinion_26:
    '“Bir anketi doldurdum ve hatta unuttum. Bir süre sonra Bayan Nataliya beni aradı ve ödül kazandığımı söyledi. İşte burada, Samsung Galaxy M52 5G’m. Çok teşekkür ederim😁”',
  four_opinion_27: 'Viktoriya Popovska',
  four_opinion_28:
    '“Hoparlörü aldım, dürüst, adil ve heyecan verici çekiliş için çok teşekkür ederim.”',
  four_opinion_29: 'Yuliya Oleksandrivna',
  four_opinion_30:
    '“Muhtemelen son zamanlarda başıma gelen en inanılmaz şey💕 Sadece kazanmakla kalmadım, gerçekten harika bir şey aldım. Her şeyi bekliyordum ama bu kadar harika olacağını hayal edemezdim. Bir kez daha çok teşekkürler!”',
  four_opinion_31:
    'Sadece bizimle gerçek para kazanabilir veya ödül kazanabilirsiniz',
  four_opinion_32: 'Kanalımızda mevcut anketleri takip edin',
  four_opinion_33: 'Kanala git',
  career_1: 'Parçası olun',
  career_2: '4Service',
  career_3:
    'Sınırsız profesyonel gelişim fırsatlarıyla ekibimize katılmanızı bekliyoruz!',
  career_4: 'İş İlanları',
  career_5: 'İş ilanı bulamadınız mı?',
  career_6: 'Özgeçmişinizi gönderin ve sizinle iletişime geçelim!',
  career_7: 'Özgeçmiş Gönder',
  career_8: 'Kayıt Formu',
  career_9: '*Ad',
  career_10: '*Soyad',
  career_11: '*E-posta',
  career_12: '*Telefon Numarası',
  career_13: 'Özgeçmiş Yükle',
  career_14: 'Gönder',
  career_15: '4Service’te kariyerinize başlayın',
  career_16: 'Ana görevler:',
  career_17: 'Gereksinimler:',
  career_18: 'Sunduğumuz imkanlar:',
  career_19: 'Başvur',
  career_20: '4Service — uluslararası bir araştırma holdingi',
  career_21: '2001 yılından beri hizmetinizde',
  career_22: 'Hakkımızda',
  career_23: 'Kurumsal kültürü geliştiriyoruz',
  career_24: 'Girişimlerimiz',
  career_25: 'Dünya çapında müşteri hizmetlerini iyileştiriyoruz',
  career_26: '4Service İş İlanları',
  career_27: '4Service ile fırsatlarınız',
  career_28:
    'Haftalık “Morning coffee” seansları, takım etkinlikleri ve sosyal girişimlerle zihinsel sağlık desteği',
  career_29:
    'Dünya çapında en tanınmış markalarla ilginç deneyimler: <span>Mercedes, Huawei, Philip Morris</span>',
  career_30:
    'Seminerler, eğitimler ve atölyeler aracılığıyla sürekli profesyonel gelişim',
  career_31: 'Gizli müşteri rolü ve ünlü markaların gelişimine katkıda bulunma',
  career_32:
    'Dünya genelinden işbirliği ve uzaktan veya ofiste çalışma imkânı: <span>Ukrayna, Kazakistan, Romanya, Avusturya, Azerbaycan, Gürcistan</span>',
  career_33:
    'Etkinlikler, webinarlar ve network etkinliklerine katılarak kendi markanızı geliştirin',
  career: 'Kariyer',
  footer_btn_1: 'Alıcı Ol',
  footer_btn_2: 'Ücretli anketlere katıl',
  diary_study_1: 'Günlük',
  diary_study_2: 'Çalışma',
  diary_study_3:
    'Değişen kullanıcı deneyimleri ve yaşam tarzları hakkında zaman içinde izleme ve veri toplama',
  diary_study_4: 'Bir uzmana danışın',
  diary_study_5: 'Bize ulaşın',
  diary_study_6: 'Başlayın',
  diary_study_7:
    'Tümleşik veri erişimi sağlayan bir Günlük Çalışması talep edin; nitel ve nicel verilerle tüketici davranışları, piyasa trendleri ve marka performansı hakkında değerli bilgiler sunar',
  diary_study_8: 'Dinamiklerde yaşam tarzları ve kullanıcı deneyimi çalışması',
  diary_study_9:
    'Bir Günlük Çalışması, kullanıcıların nasıl etkileşimde bulunduğuna dair derin ve bağlamsal bilgiler sunar, diğer yöntemlerle görülemeyen örüntüleri ve değişiklikleri belirlemeye yardımcı olur.',
  diary_study_10:
    'Bu yöntem, doğal bir ortamda gerçek zamanlı veri toplama sağlar ve güvenilirliği ve ilgililiği önemli ölçüde artırır',
  diary_study_11: 'Sağlayın',
  diary_study_12: 'Özelleştirilmiş Günlük Çalışmaları sunuyoruz',
  diary_study_13: 'Tüketici Katılımı',
  diary_study_14:
    'Katılımcıların davranışlarını, aktivitelerini ve deneyimlerini günlük ortamlarında zaman içinde belgelediği çevrimiçi topluluklar sağlıyoruz.',
  diary_study_15: 'Pazar Araştırması',
  diary_study_16:
    'Yaklaşımımız, müşterilerimizin özel ihtiyaçları için anlamlı ve ilgili veriler sağlamak üzere derinlemesine pazar araştırmasını içerir.',
  diary_study_17: 'Marka İçgörüleri',
  diary_study_18:
    'Tüketici algıları ve davranışları üzerine derinlemesine analiz yaparak, marka stratejilerini şekillendiren değerli içgörüler ortaya çıkarıyoruz.',
  diary_study_19: 'Uzmanlar',
  diary_study_20:
    '20 yılı aşkın müşteri deneyimi olan 4Service uzmanları, işinizi büyütmeye yardımcı olan benzersiz çözümler yaratır',
  diary_study_21: 'Proje Yönetimi',
  diary_study_22:
    'Ekibimiz, her aşamanın dikkatle planlanıp yürütülmesini sağlayarak sorunsuz sonuçlar için kapsamlı proje yönetimi desteği sağlar.',
  diary_study_23: 'Danışmanlık',
  diary_study_24:
    'Müşterilerimizi projenin her aşamasında yönlendirmek, sorunları çözmek ve performansı optimize etmek için uzman danışmanlık sunuyoruz.',
  diary_study_25: 'Kalite Güvencesi',
  diary_study_26:
    'Projelerimizin beklentileri karşılamasını ve aşmasını garanti eden titiz kalite standartlarını her aşamada uyguluyoruz.',
  diary_study_27: 'Fayda',
  diary_study_28: 'Bizimle faydalanın',
  diary_study_29: '<b>Sınırsız bir</b> bilgi kaynağı zaman içinde',
  diary_study_30: '<b>Uzman rehberliği</b> sürecin her aşamasında',
  diary_study_31: '<b>İşletmeleri</b> dünya çapında tüketicilerle bağlamak',
  diary_study_32:
    '<b>Kapsamlı veri toplama</b> derinlemesine geri bildirim ve yanıtlarla',
  diary_study_33: '<b>Erişilebilir veri</b> projenin herhangi bir aşamasında',
  diary_study_34: '<b>Karmaşık çözümler</b> büyümenize katkı sağlar',
  diary_study_35: 'Araştırma',
  diary_study_36: 'Özel içgörülerle özelleştirilmiş nicel araştırmalar alın',
  shoppers_1: 'Platform',
  shoppers_2: 'Gizli Alıcılar',
  shoppers_3: 'Katıl',
  shoppers_4: '4Service ile hizmeti değerlendirin ve kazanın',
  shoppers_5: '4Service’de kariyerinize başlayın',
  shoppers_6: 'Sizi ilginç projeler bekliyor',
  shoppers_7: 'Katıl',
  shoppers_8: 'Ekibimize katılın',
  shoppers_9: 'Daha fazla bilgi ›',
  shoppers_10: 'Süpervizör',
  shoppers_11:
    'Ekibin işini denetleyen, planlama, koordinasyon, kalite kontrol ve organizasyonel konuları yöneten, belirlenen görevlerin yerine getirilmesini sağlayan yönetici.',
  shoppers_12: 'Gizli Alıcı',
  shoppers_13:
    'Senaryo doğrultusunda mağaza, restoran veya diğer mekanlara ziyaretlerde bulunan ve ardından deneyimlerini raporlayan uzman.',
  shoppers_14: 'Merchandiser',
  shoppers_15:
    'Mağazalarda ürünleri marka veya şirket standartlarına göre düzenleyen uzman.',
  shoppers_16: 'Denetçi',
  shoppers_17:
    'Faaliyetleri standart ve gerekliliklere uygunluk açısından kontrol eden uzman.',
  shoppers_18: 'Test Uzmanı',
  shoppers_19:
    'Hizmet, ürün veya süreçleri müşteri perspektifinden kontrol eden ve tüketici beklentilerine uygunluğunu değerlendiren, olası sorunları tespit eden uzman.',
  shoppers_20: 'Gizli Aday',
  shoppers_21:
    'Müşteri hizmetleri sürecini analiz eden, iletişim kalitesini, yanıt hızını, prosedürlerin kolaylığını ve genel etkileşim izlenimini değerlendiren uzman.',
  shoppers_22: 'Promoter',
  shoppers_23:
    'Ürünleri tanıtan, ürün gösterimi yapan, reklam materyalleri dağıtan, kampanyalar organize eden ve müşteri sorularını yanıtlayan uzman.',
  shoppers_24: 'Röportaj Katılımcısı',
  shoppers_25:
    'Derinlemesine röportaj katılımcısı, belirli bir konu, ürün veya hizmet hakkında düşüncelerini, duygularını, motivasyonlarını veya deneyimlerini açığa çıkarmaya yönelik detaylı araştırmaya katılır.',
  shoppers_26: '4Service’in bir parçası olun',
  shoppers_27: '<b>Dünya çapında</b> çalışıyoruz',
  shoppers_28: 'Ekibimiz <b>1000+ profesyonelden</b> oluşmaktadır',
  shoppers_29: 'Piyasada <b>20+ yıllık</b> başarılı deneyimimiz var',
  shoppers_30: 'Talimatlar',
  shoppers_31: 'Ziyaretin ses kaydını nasıl yaparsınız',
  shoppers_32: 'Aramanın ses kaydını nasıl yaparsınız',
  shoppers_33: 'Ankete ses dosyası ekleyemiyor musunuz?',
  shoppers_34:
    'Gizli Alıcılar için MSPA Profesyonel Standartlar ve Etik Kodları',
  shoppers_35: 'S.S.S.',
  shoppers_36: 'Sıkça Sorulan Sorular',
  shoppers_37: 'Ayda ne kadar kazanabilirsiniz?',
  shoppers_38: 'Şehrimde görevleri ne sıklıkla yapabilirim?',
  shoppers_39:
    'Konum kapalıysa ne yapmalı ve bu tür bir ziyaret için ödül nedir?',
  shoppers_40: 'Ödül nasıl alınır?',
  shoppers_41: 'Ödül alma süreleri nelerdir?',
  shoppers_42: 'Ödül alma ile ilgili sorular için kime başvurabilirim?',
  shoppers_43:
    'Aylık ödülünüz, görevleri yerine getirme yoğunluğunuza bağlıdır.',
  shoppers_44:
    'Tek bir görevin ücreti, basit ziyaretler ve aramalar için 40₴’den, karmaşık ve premium ziyaretler için 1200₴’ye kadar değişebilir. Bu, projenin zorluk ve özelliklerine bağlıdır.',
  shoppers_45:
    'Görevler, günlük alışverişleriniz veya arkadaşlarınızla kafelere, pizzacılara ve restoranlara giderken hoş bir hobi haline gelebilir.',
  shoppers_46: 'Konum sayısı, proje ölçeği;',
  shoppers_47: 'Rotasyon (aynı konuma üç ay / çeyrekten daha sık gitmemek);',
  shoppers_48:
    'Profilinizin / becerilerinizin proje gereksinimlerine uygunluk derecesi;',
  shoppers_49: 'Başvuru hızınız.',
  shoppers_50: 'Denetlediğiniz konum:',
  shoppers_51:
    'Kapalı – giriş kapısını, kapalı olma nedenini gösteren duyuruyu (varsa) veya çalışma saatlerini, adresi ile birlikte mekanın cephe fotoğrafını çekin.',
  shoppers_52:
    'Belirtilen adreste yok – çevredeki alanın VİDEO KAYDINI, komşu binanın cephe fotoğrafını ve üzerindeki adresi çekin. Ardından koordinatörünüze başvurun.',
  shoppers_53: 'Ödül, bireysel kişiler için «PrivatBank» kartına ödenir.',
  shoppers_54: 'Ödül alma sürelerini kişisel hesabınızda öğrenebilirsiniz.',
  shoppers_55:
    'Ayrıca koordinatörünüze sorabilir veya Gizli Alıcı Destek Hizmetine ua@4service.support adresinden başvurabilirsiniz, e-posta konusu projenin adını içermelidir.',
  shoppers_56:
    'Genel ödül alma süreleri kişisel hesabınızda «Ana Sayfa» bölümünde belirtilmiştir.',
  shoppers_57:
    'Ödül almadıysanız ve süreler geçtiyse, kişisel hesabınızda aşağıdaki adımları uygulayın:',
  shoppers_58:
    '1. Tüm kişisel bilgilerinizin doldurulduğunu ve boş alan olmadığını kontrol edin;',
  shoppers_59:
    '2. Ödeme kartınızın bilgileri doğru girilmiş ve kartın süresi dolmamış;',
  shoppers_60: '3. Belirtilen banka kartı bireysel kişiler için olmalı;',
  shoppers_61:
    '4. Sisteminizdeki adınız ve soyadınız kartınızdaki ile eşleşmeli (hatalar olmadan doldurulmuş).',
  shoppers_62:
    'Tüm verileri kontrol ettiyseniz ve her şey doğru doldurulmuşsa – Gizli Alıcı Destek Hizmetine ua@4service.support adresinden başvurun, e-posta konusu ilgili proje adını içermelidir.',
  shoppers_63: 'Gizli alıcılar için <br /> uygulamalar',
  shoppers_64: '4Shoppers uygulamasını indirin:',
  shoppers_65: 'veya',
  shoppers_66: 'Bizimle iletişime geçin',
  shoppers_67: 'Destek sohbeti',
  shoppers_68: 'Telefon:',
  shoppers_69: 'E-posta:',
  shoppers_70: 'Sorularınız mı var?',
  shoppers_71: 'Saha personeli <br /> destek servisi',
  shoppers_72: 'İletişim',
  shoppers_73: 'Saha personeli destek servisi',
  shoppers_74:
    'Gizli Alıcı olarak ziyaretler, ödemeler ve diğer iş detaylarıyla ilgili sorular',
  shoppers_75:
    'Kişisel verilerin işlenmesine aşağıdaki şartlara göre izin veriyorum',
  shoppers_76: 'Adınız Soyadınız',
  shoppers_77: 'Sorunun özü',
  shoppers_78: 'Kullanıcı adınız',
  shoppers_79: 'İletişim telefonu',
  shoppers_80: 'Ödeme süreleri',
  shoppers_81: 'Diğer',
  shoppers_82: 'Bizimle iletişime geçin',
  employee_experience_1: 'Çalışan Deneyimi',
  employee_experience_2: 'İşinizin başarısı, Çalışan Deneyimi ile başlar',
  employee_experience_3: 'İletişime geçin',
  employee_experience_4: 'Başarı Hikayeniz Burada Başlıyor',
  employee_experience_5:
    '4Service uzmanları, 20 yılı aşkın pazar araştırması ve müşteri deneyimi tecrübesi ile işinizi büyütmeye yardımcı olan benzersiz çözümler oluşturur.',
  employee_experience_6:
    'Hizmetlerimiz, işletmelere bilinçli kararlar alabilmeleri, stratejilerini geliştirebilmeleri ve sektörlerinde başarıya ulaşmaları için gerekli araçları sağlar.',
  employee_experience_7:
    'Özel ihtiyaçlarınız için ideal metodolojiyi seçiyoruz',
  employee_experience_8: 'Çalışan Yolculuğu Haritası',
  employee_experience_9:
    'Tüm çalışan yaşam döngüsünü, işe alımdan çıkışa kadar haritalıyoruz ve deneyimi etkileyen önemli temas noktalarını belirliyoruz. Bu, her aşamada memnuniyeti ve bağlılığı artırmak için iyileştirme alanlarını ve fırsatları tespit etmeye yardımcı olur.',
  employee_experience_10: 'Benchmark ile Çalışan Yolculuğu Haritası',
  employee_experience_11:
    'Çalışan yolculuğu haritalamasını bir adım öteye taşıyarak çalışan deneyimlerinizi sektör kıyaslamalarıyla karşılaştırıyoruz. Bu, iç süreçleri basitleştirmenin, çalışan bağlılığını artırmanın ve en iyi uygulamaları benimsemenin yollarını belirlemenize yardımcı olur.',
  employee_experience_12: 'İşveren Marka Sağlığı Araştırması',
  employee_experience_13:
    'Çalışanlarınızın şirket markanızı içerden nasıl algıladığını değerlendiriyoruz. Güçlü bir iç marka, daha motive ve sadık bir iş gücü sağlar; bu da daha iyi müşteri etkileşimleri ve dış itibar anlamına gelir.',
  employee_experience_14: 'Çalışan Net Tavsiye Skoru (eNPS)',
  employee_experience_15:
    'eNPS kullanarak, çalışanlarınızın şirketinizi harika bir iş yeri olarak tavsiye etme olasılıklarını ölçeriz. Bu basit ama güçlü metrik, genel çalışan memnuniyeti ve bağlılığı hakkında fikir verir.',
  employee_experience_16: 'Çalışan Bağlılığı ve Memnuniyeti Endeksi (ECSI)',
  employee_experience_17:
    'ECSI metodolojimiz, çalışanlarınızın rollerine ve şirkete olan bağlılık ve memnuniyetini değerlendirir. Bu, bağlılık seviyesini ölçmeye ve tutundurma oranını artırmak için yapılabilecek iyileştirmeleri belirlemeye yardımcı olur.',
  employee_experience_18:
    'Eski ve Mevcut Çalışanlarla Derinlemesine Görüşmeler',
  employee_experience_19:
    'Eski çalışanlarla görüşerek neden ayrıldıklarını ve tutundurma iyileştirmelerini belirliyoruz. Mevcut personelle yapılan görüşmeler, müşteri hizmetlerini geliştirme, bağlılığı artırma ve KPI’ları başarmadaki engelleri aşma yollarını ortaya çıkarır.',
  employee_experience_20: 'UGC Analizi',
  employee_experience_21:
    'Kullanıcı Tarafından Oluşturulan İçerik (UGC) Analizi, özel web siteleri, sosyal medya, forumlar ve video platformlarından yorumlar toplanarak yapılır. Bu analiz, gerçek müşteri beklentilerini ve sorun noktalarını anlamaya, tüketici tercihlerindeki trendleri ve değişiklikleri tespit etmeye, markanın rakiplere karşı güçlü ve zayıf yönlerini belirlemeye yardımcı olur.',
  employee_experience_22: 'Gizli Çalışan',
  employee_experience_23:
    'Gizli Çalışan, potansiyel bir çalışanın bakış açısından şirketin değerlendirilmesidir. İç süreçlerin ne kadar iyi organize edildiğini, mevcut çalışanların adaylarla nasıl etkileşime girdiğini ve şirketin hizmet ve iletişim standartlarını ne kadar etkin takip ettiğini değerlendirir.',
  employee_experience_24: 'Motivasyon Ziyaretleri',
  employee_experience_25:
    'Motivasyon Ziyaretleri, hizmet standartlarını karşılayan çalışanları ödüllendirir; örneğin mükemmel müşteri etkileşimi veya başarılı upselling. Gizli Alıcılar en iyi performans gösterenleri belirleyerek motivasyonu artırır ve diğerlerini ödül ve tanınma kazanmak için onları örnek alarak teşvik eder.',
  employee_experience_26: 'Hizmet Tasarımı',
  employee_experience_27:
    'İş zorluklarını belirlemek ve yenilikçi çözümler bulmak için hizmet tasarımı kullanıyoruz; bu, hizmet sunumunu iyileştiren ve müşteri veya çalışan ihtiyaçlarını karşılayan stratejiler oluşturur.',
  employee_experience_28: 'İK Araştırması',
  employee_experience_29:
    'İK araştırmaları, çalışanların şirketin misyon ve değerleriyle ne kadar uyumlu olduğunu ve bunları müşterilere ne kadar etkili ilettiğini ölçmeye yardımcı olur.',
  employee_experience_30: 'Çalışanlarla Ortak Yaratım (Odak Grupları)',
  employee_experience_31:
    'Çalışanları doğrudan dahil ederek, geri bildirim ve içgörüler toplamak için ortak yaratım odak grupları yürütüyoruz. Bu iş birliği süreci, personelin çalışma ortamını şekillendirmeye katkıda bulunmasını sağlar, sahiplenme ve bağlılık duygusunu artırır.',
  employee_experience_32: 'Neden Çalışan Deneyimine yatırım yapmalı?',
  employee_experience_33: 'Personel Devir Oranını Azaltın',
  employee_experience_34:
    'Çalışanların kalmak ve gelişmek istediği bir iş yeri yaratarak en iyi yeteneklerinizi elde tutun.',
  employee_experience_35: 'Çalışan Bağlılığını Artırın',
  employee_experience_36:
    'Personelinizin uzun vadeli bağlılık ve adanmışlığını artırarak maliyetli yeniden işe alım çabalarını azaltın.',
  employee_experience_37: 'Değişime Sorunsuz Uyumu Sağlayın',
  employee_experience_38:
    'Yeni kurallara ve girişimlere karşı direnci azaltarak şirketinizde daha sorunsuz geçişler sağlayın.',
  employee_experience_39: 'Verimliliği Artırın',
  employee_experience_40:
    'Ekibinizin yeni süreçleri benimsemesine ve rollerinde başarılı olmasına yardımcı olun.',
  employee_experience_41: 'İş Maliyetlerini Düşürün',
  employee_experience_42:
    'Süreçleri kolaylaştırarak maliyet tasarrufu ve gelir artışı sağlayın.',
  employee_experience_43: 'İyi Çalışan Deneyimi, İş Büyümesini Tetikler',
  employee_experience_44:
    'Çalışan Deneyimi (EX), çalışanların şirket içindeki yolculukları boyunca karşılaştıkları ve hissettikleri her şeyi kapsar.',
  employee_experience_45:
    'Pozitif bir EX, şirket hedefleriyle uyumu artırır, motivasyonu yükseltir ve bağlılığı güçlendirir.',
  employee_experience_46:
    'Mutlu, bağlı çalışanlar olağanüstü hizmet sunar, bu da memnun müşteriler ve sürdürülebilir büyüme sağlar.',
  employee_experience_47:
    'EX’e yapılan yatırım zincirleme bir etki yaratır - daha iyi tutundurma, artan verimlilik ve daha güçlü iş sonuçları.',
  employee_experience_48: 'Sizin EX + CX işinizi doğrudan etkiler',
  employee_experience_49:
    'Çalışan Deneyimi (EX) ve Müşteri Deneyimi (CX) el ele gider. Memnun bir ekip, olağanüstü hizmet sunma olasılığı daha yüksek olup, bu da daha iyi müşteri memnuniyeti sağlar. Entegre EX ve CX yaklaşımımızla, iç kültürünüzü dış müşteri hizmetleri mükemmelliği ile uyumlu hale getirebilirsiniz.',
  employee_experience_50:
    'Çalışan ve müşteri deneyimi içgörülerini bütünleştirerek, her iki alanı da geliştirmek için bütüncül bir yaklaşım sunuyoruz. Sonuç, iş başarısını destekleyen daha güçlü ve uyumlu bir şirket kültürüdür.',
  employee_experience_51: 'Mutlu İşveren',
  employee_experience_52: 'Mükemmel Hizmet',
  employee_experience_53: 'Mutlu Müşteri',
  cati_1: 'CATI',
  cati_2: 'Etkili bilgisayar destekli telefon anketleri',
  cati_3: 'İletişime geçin',
  cati_4: 'Güvenilen',
  cati_5:
    '<b>CATI (Bilgisayar Destekli Telefon Görüşmesi)</b>, operatörlerin yanıtları kaydetmek, soru mantığını sağlamak ve sonuçları analiz etmek için özel yazılımlarla çalıştığı telefon anketleriyle veri toplama yöntemidir.',
  cati_6: '4Service’den CATI’nın temel avantajları:',
  cati_7: '<b>Anketlerin hızlı</b> gerçekleştirilmesi',
  cati_8: '<b>Yüksek veri kalitesi</b>',
  cati_9: 'Anket özelleştirmede <b>esneklik</b>',
  cati_10: 'Sürecin <b>otomasyonu</b>',
  cati_11: 'Kalite kontrol için geniş <b>araç yelpazesi</b>',
  cati_12:
    '<b>Ulaşılması zor kategorilerde</b>ki katılımcıları anketleme imkanı',
  cati_13: 'Tüm <b>görüşmelerin kaydı</b> ile ileriye dönük inceleme imkanı',
  cati_14: '<b>Büyük hedef kitleye</b> hızlı erişim yeteneği',
  cati_15:
    'Diğer veri toplama yöntemlerine kıyasla <b>daha maliyet etkin</b> bir yöntem',
  cati_16: 'Çözümler',
  cati_17: 'Telefon anketleri ile hangi görevler çözülebilir:',
  cati_18:
    '<span>Pazar segmentasyonu araştırması.</span> Hedefleme ve etkili pazarlama stratejileri için farklı tüketici gruplarının belirlenmesi',
  cati_19:
    '<span>Müşteri memnuniyeti değerlendirmesi.</span> SCI ve NPS indekslerini kullanarak ürün ve hizmetlere olan tüketici bağlılığını ölçme',
  cati_20:
    '<span>NPS yönetimi ve aksiyon planı uygulaması.</span> İletişim merkezi aracılığıyla telefon anketleri ile müşteri deneyimini aktif olarak iyileştirme',
  cati_21:
    '<span>Talep ve piyasa trendleri analizi.</span> Ürün ve hizmet popülaritesini araştırma, umut vadeden bölgeleri ve büyüme yönlerini belirleme',
  cati_22:
    '<span>Rekabet ortamı analizi.</span> Markanın piyasadaki konumunu değerlendirme, rakiplerle karşılaştırma ve büyüme fırsatlarını belirleme',
  cati_23: 'Kimler için',
  cati_24: 'CATI şu durumlar için idealdir:',
  cati_25: 'Ürün lansmanı yapan şirketler',
  cati_26:
    'Güncel pazar verilerini toplamak, rekabet ortamını analiz etmek ve tüketici tercihlerini incelemek için',
  cati_27: 'Müşterilerle çalışan markalar ve şirketler',
  cati_28:
    'Müşteri memnuniyeti düzeylerini değerlendirmek (Müşteri Memnuniyeti, NPS), ihtiyaçları analiz etmek ve geri bildirim toplamak için',
  cati_29: 'Perakende ve e-ticaret',
  cati_30:
    'Tüketici davranışlarını anlamak, yeni ürünleri test etmek ve satın alma kararlarını etkileyen faktörleri belirlemek için',
  cati_31: 'Bankalar ve finansal kurumlar',
  cati_32:
    'Hizmet değerlendirmesi yapmak, şirket güven düzeylerini ölçmek ve hizmetler hakkında geri bildirim toplamak için',
  cati_33: 'Sosyal kuruluşlar',
  cati_34: 'Sosyolojik araştırmalar yapmak ve kamuoyunu analiz etmek için',
  cati_35: 'Devlet kurumları ve STK’lar',
  cati_36:
    'İstatistiksel veri toplamak, sosyal konuları incelemek ve araştırma programlarını uygulamak için',
  cati_37: 'Kalite',
  cati_38: 'Görüşme kalite değerlendirme kriterleri',
  cati_39: 'Temel iletişim becerileri',
  cati_40:
    'Selamlama ve görüşme sonlandırma standartlarına uyum, ayrıca katılımcının tercih ettiği dile geçiş',
  cati_41: 'İletişim tarzı',
  cati_42:
    'Konuşma doğruluğu, nezaket, samimi ton ve katılımcı ile güvenilir bağlantı kurabilme yeteneği',
  cati_43: 'Görüşme yönetimi',
  cati_44:
    'Aktif dinleme tekniklerini kullanma, katılımcıyı meşgul tutma ve diyaloğu etkili şekilde yönetme',
  cati_45: 'Konu bilgisi',
  cati_46:
    'Anket konusunu derinlemesine anlama ve ek sorulara doğru cevap verebilme',
  cati_47: 'Anket doldurma doğruluğu',
  cati_48: 'Yanıtların talimatlara uygun olarak hatasız ve doğru girilmesi',
  cati_49: 'Neden 4Service',
  cati_50: 'Neden 4Service’den CATI seçmelisiniz?',
  cati_51:
    'CATI, telefon anketleri ile doğru ve yapılandırılmış veri elde etmek isteyen şirketler için uygundur',
  cati_52: 'Kendi iletişim merkezi',
  cati_53:
    'Müşteri taleplerinin %100 oranında yerine getirildiği 70.000’den fazla başarılı arama gerçekleştirdik',
  cati_54: 'Kalite garantisi',
  cati_55: 'Her görüşmenin %100 doğrulaması – veri doğruluğunu garanti eder',
  cati_56: 'Bireysel yaklaşım',
  cati_57: 'Özel müşteri ihtiyaçlarına uygun benzersiz anketler geliştirme',
  cati_58: 'Gelişmiş yazılım',
  cati_59: 'Her tür karmaşıklıkta CATI yürütmek için VolPtime',
  cati_60: 'B2B deneyimi',
  cati_61:
    'Farklı iş ve endüstri alanlarında önde gelen uzmanları anketleyerek tüzel kişilerle çalışıyoruz',
  cati_62: 'Bir talepte bulunun, size en iyi çözümü bulalım!',
  cati_63: 'Teknoloji',
  cati_64:
    'Sonuçları analiz etmek ve işinizi geliştirmek için modern teknolojiler kullanıyoruz',
  cati_65: 'Yetenekler:',
  cati_66: '<span>VolPtime</span> - profesyonel yazılım',
  cati_67: 'Gelen (hotline)/giden otomatik hatların organizasyonu',
  cati_68: 'Operatörler, her tür sorgu, danışma süresi istatistikleri',
  cati_69: 'İletişim merkezi operasyonlarının çevrimiçi takibi',
  cati_70: 'Tüm telefon danışmalarının ses kayıtları',
  cati_71: 'Uzaktan ve kolay yazılım yapılandırması',
  cati_72:
    '<span>Survey Monkey</span> - anket programlama için profesyonel hizmet',
  cati_73: 'Çeşitli karmaşıklık seviyelerinde anket programlama',
  cati_74: 'Tüm araştırma ihtiyaçlarını dikkate alarak',
  cati_75: 'Katılımcılar için basitlik, açıklık ve rahatlık',
  cati_76: 'Kalite',
  cati_77: 'Müşterilerle diyalog kalitesinin değerlendirilmesi',
  cati_78: 'Kontrol listesine dayalı değerlendirme sistemi',
  cati_79:
    'Hizmet kalitesi, kalite değerlendirme çalışanlarının Raporlama Dönemi boyunca ortalama bir puan verdiği özel bir kontrol listesi kullanılarak ölçülür',
  cati_80: 'Hedef uyum göstergeleri',
  cati_81:
    'Standartlara uyum, %90’ın altına düşemeyecek şekilde belirlenmiş seviyelere göre değerlendirilir. Bu göstergeler çalışan deneyimine bağlı olarak ayarlanabilir',
  cati_82: 'Kayıtlar üzerinden ve gerçek zamanlı çağrı izleme',
  cati_83:
    'Çağrıların yaklaşık %40’ı kayıtlardan ve %20’si gerçek zamanlı olarak incelenir; bu da olası standart ihlallerine hızlı yanıt verilmesini sağlar',
  cati_84: 'Uzmanlar',
  cati_85: 'Kendi İletişim Merkezimiz var',
  cati_86: 'İletişim merkezi yöneticisi',
  cati_87: 'İşe alım yöneticileri',
  cati_88: 'Ukrayna uzaktan lokasyonu',
  cati_89: 'Kazakistan uzaktan lokasyonu',
  cati_90: 'Teknik koordinatör',
  cati_91: 'Proje yöneticileri',
  cati_92: 'Proje yöneticileri',
  cati_93: 'Eğitim ve kalite kontrol departmanı',
  cati_94: 'Operatörler – 60 kişi (%20’si İngilizceyi akıcı konuşur)',
  cati_95: 'Operatörler – 20 kişi',
  cati_96: 'Kalite kontrol departmanı başkanı',
  cati_97: 'Kalite kontrol uzmanları',
  cati_98: 'Eğitim koçları',
};
